<template>
  <v-container class="wrapper pa-0" ref="wrapper" :class="{ fullscreen: fullscreen }">
    <v-card
      ref="refComponent"
      class="pa-2 ma-0 position-relative product-wrapper"
      width="100%"
      flat
    >
      <v-progress-linear
        :active="!render || loading"
        :indeterminate="!render || loading"
        absolute
        bottom
        style="top: 0"
        color="primary"
      />
      <v-container class="pa-0 header flex-row-reverse">
        <div class="w-60 d-flex flex-column gap-2">
          <div class="d-flex justify-space-between align-center w-100 gap-1">
            <div class="queue-wrapper">
              <div ref="factorsQueue" class="factors-queue">
                <div
                  v-for="(inv, index) in invoices"
                  :key="index"
                  class="child"
                  :class="{ active: index == activeInv }"
                  @click="activeInv = index"
                >
                  <span class="text-caption">
                    {{
                      !inv.edit
                        ? $t("invoice") + " (" + resolveInvNum(index) + ")"
                        : $t("edit-invoice") + " (" + inv.number + ")"
                    }}
                  </span>
                  <v-icon
                    @click="askPermission(inv, index)"
                    size="10"
                    style="cursor: pointer"
                  >
                    mdi-close
                  </v-icon>
                </div>
              </div>
              <div @click="addInvoice" class="fix-btn">
                <div class="add-btn child d-flex">
                  <v-icon size="14">mdi-plus</v-icon>
                  <span style="color: gray; font-size: 10px"> (F2) </span>
                </div>
              </div>
            </div>
            <div class="d-flex align-center invoice-queue-scroll">
              <v-btn
                color="secondary"
                outlined
                height="28"
                class="invoice-queue-scroll-btn"
                @click="scrollQueue('right')"
              >
                <v-icon size="16">mdi-chevron-right</v-icon>
              </v-btn>
              <!-- <v-btn color="secondary" outlined height="34">
                <span class="ml-2">{{ $t("invoice") }}</span>
              </v-btn> -->
              <v-btn
                color="secondary"
                outlined
                height="28"
                class="invoice-queue-scroll-btn"
                @click="scrollQueue('left')"
              >
                <v-icon size="16">mdi-chevron-left</v-icon>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="error"
                    outlined
                    height="28"
                    class="invoice-queue-scroll-btn invoice-queue-delete-btn"
                    @click="goToInvoice('delete')"
                  >
                    <my-icon
                      :name="'trash-icon'"
                      :width="14"
                      :height="14"
                      :cursor-pointer="true"
                      :fill="'#ff5252'"
                    />
                  </v-btn>
                </template>
                <span>{{ $t("delete-all-items") }}</span>
              </v-tooltip>
            </div>
          </div>
        </div>
        <div class="w-40">
          <div
            v-for="(inv, index) in invoices"
            :key="index"
            class="w-100 d-flex gap-2 invoice-actions-row flex-nowrap"
            :style="{ display: index == activeInv ? 'flex' : 'none !important' }"
          >
            <div class="flex-fill">
              <v-toolbar-title>
                {{ $t(inv.type) }}
              </v-toolbar-title>
              <!-- <v-toolbar-title>
                {{ 
                  !id ?
                  $t(inv.type) : 
                  $t('edit') + ' ' + $t(inv.type) + ' ' + '(' + id + ')'
                }}
              </v-toolbar-title> -->
            </div>
            <div
              class="d-flex invoice-nav-btns"
              :class="
                $vuetify.breakpoint.width < 1320 ? 'invoice-nav-wrapper-responsive' : ''
              "
            >
              <v-btn
                color="primary"
                outlined
                height="28"
                class="invoice-nav-btn-compact"
                :class="
                  $vuetify.breakpoint.width < 1320 ? 'invoice-nav-btn-responsive' : ''
                "
                :disabled="lastId && lastId >= currentId ? false : true"
                @click="goToInvoice('next')"
              >
                <v-icon size="16">mdi-chevron-right</v-icon>
                {{ $t("nextInvoice") }}
              </v-btn>
              <!-- <v-text-field
                v-model="number"
                dense
                :rules="[v => !!v || $t('is-required')]"
                outlined
                clearable
                :label="$t('number')"
                @click="additionalDrawer = true"
                @blur="getInvoiceNumber"
                @focus="focusEvent"
                ref="number"
              /> -->
              <v-btn
                color="primary"
                outlined
                height="28"
                class="invoice-nav-btn-compact"
                :class="
                  $vuetify.breakpoint.width < 1320 ? 'invoice-nav-btn-responsive' : ''
                "
                @click="goToInvoice('prev')"
              >
                {{ $t("prevInvoice") }}
                <v-icon size="16">mdi-chevron-left</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-container>
      <v-container class="pa-0 pt-2 body">
        <div
          v-for="(inv, index) in invoices"
          :key="index"
          class="w-100"
          :style="{ display: index == activeInv ? 'block' : 'none' }"
        >
          <v-form
            v-if="render"
            ref="form"
            v-model="valid"
            style="height: 100%; width: 100%"
            lazy-validation
          >
            <div
              class="d-flex flex-row-reverse gap-2 invoice-main-split"
              style="height: 100%"
            >
              <div class="w-60 d-flex flex-column gap-2 mb-10 invoice-items-col">
                <div class="d-flex gap-1 invoice-header-fields">
                  <div class="flex-fill">
                    <autocomplete
                      ref="refAccount"
                      v-model="inv.account"
                      :title="$t('account')"
                      :type="offline ? 'getAllPersonOffline' : 'person'"
                      :offline="offline"
                      :set-offline="offline"
                      :new-btn="true"
                      :rules="[(v) => !!v || $t('is-required')]"
                      :value="inv.account"
                      @input="onAccountInput(index)"
                    />
                  </div>
                  <div class="flex-fill">
                    <template>
                      <v-text-field
                        id="from"
                        v-model="inv.date"
                        :label="$t('date')"
                        :rules="[(v) => !!v || $t('is-required')]"
                        clear-icon="flaticon2-close-cross"
                        outlined
                        hide-details
                        dense
                        clearable
                        ref="date"
                      />
                      <date-picker
                        v-model="inv.date"
                        element="from"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="$store.state.startDate"
                        :max="$store.state.endDate"
                        @close="setDate"
                      />
                    </template>
                  </div>
                  <div class="flex-fill">
                    <autocomplete
                      ref="refEntrepot"
                      v-model="inv.entrepot"
                      title="entrepot"
                      type="entrepot"
                      :set-init="id ? false : false"
                      :new-btn="true"
                      :value="inv.entrepot"
                      :offline="offline"
                      :set-offline="offline"
                      @input="checkProductsCount"
                    />
                  </div>
                </div>
                <invoice-items
                  ref="refInvoiceItems"
                  v-model="inv.items"
                  :items-prop="inv.items"
                  :decimal="decimal"
                  :currency="inv.currency"
                  :branch="inv.branch"
                  :account="inv.account"
                  :type="inv.type"
                  :offline="offline"
                  :scale="scale"
                  :weight="weight"
                  :selectedTaxOption="inv.selectedTaxOption"
                  :fee-calculator-enabled="feeCalculatorEnabled"
                  :is-edit="!!id || inv.edit"
                  :price-type="inv.priceType"
                  @calc="calcSum"
                  @checkDiscount="checkDiscount"
                  @checkDiscountPercent="checkDiscountPercent"
                  @callrefbodyhight="setRefBody"
                  @setinputFocus="setFocus"
                  :errorIndexes="index === activeInv ? errorIndexes : null"
                  @itemRemoved="errorIndexesHandler"
                  @serial-click="openSerialDialog"
                />
              </div>
              <div class="w-40 d-flex flex-column gap-2 invoice-products-col">
                <div class="d-flex invoice-secondary-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-on="on"
                        v-bind="attrs"
                        outlined
                        color="primary"
                        height="32"
                        class="pa-0 search-invoice-btn-compact invoice-icon-btn-accent"
                        v-shortkey="['f10']"
                        @shortkey="fullScreenFunc"
                        @click="fullScreenFunc"
                      >
                        <v-icon size="18">
                          {{ !fullscreen ? "mdi-fullscreen" : "mdi-fullscreen-exit" }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("fullscreen") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!formType"
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        color="primary"
                        height="32"
                        class="pa-0 search-invoice-btn-compact invoice-icon-btn-accent"
                        @click="configDialog = true"
                      >
                        <v-icon size="18"> mdi-cog-outline </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("setting") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        outlined
                        height="32"
                        :class="
                          $vuetify.breakpoint.width < 1320
                            ? 'search-invoice-btn-compact'
                            : 'flex-fill'
                        "
                        @click="openSearchDialog"
                      >
                        <span v-if="$vuetify.breakpoint.width >= 1320">
                          {{ $t("searchInvoice") }}
                        </span>
                        <v-icon
                          size="18"
                          :class="$vuetify.breakpoint.width >= 1320 ? 'ms-1' : ''"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("searchInvoice") }}</span>
                  </v-tooltip>
                  <!-- <v-btn
                    v-if="id"
                    color="primary"
                    outlined
                    height="32"
                    class="flex-fill"
                    :loading="isLoading"
                    @click="goToInvoice('new')"
                  >
                  {{ $t('newInvoice') }}
                  <v-icon size="18" class="ms-1">mdi-plus</v-icon>
                  </v-btn> -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        outlined
                        height="32"
                        :class="
                          $vuetify.breakpoint.width < 1320
                            ? 'search-invoice-btn-compact'
                            : 'flex-fill'
                        "
                        @click="additionalDrawer = true"
                      >
                        <span v-if="$vuetify.breakpoint.width >= 1320">
                          {{ $t("otherInputs") }}
                        </span>
                        <v-icon
                          size="18"
                          :class="$vuetify.breakpoint.width >= 1320 ? 'ms-1' : ''"
                        >
                          mdi-file-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("otherInputs") }}</span>
                  </v-tooltip>
                  <v-btn
                    color="primary"
                    outlined
                    v-shortkey="['/']"
                    height="32"
                    class="flex-fill"
                    @shortkey="otherProduct"
                    @click="otherProduct"
                  >
                    {{ $t("otherProduct") }} (/)
                  </v-btn>
                  <v-btn
                    v-shortkey="['f8']"
                    color="primary"
                    outlined
                    height="32"
                    class="flex-fill"
                    @shortkey="addProductDialog = true"
                    @click="addProductDialog = true"
                  >
                    {{ $t("defineProduct") }} (f8)
                  </v-btn>
                </div>
                <products
                  ref="productCategoryRef"
                  class="invoice-products-panel"
                  v-model="inv.items"
                  :data="
                    JSON.stringify({ entrepot: inv.entrepot ? inv.entrepot.id : null })
                  "
                  :item-count="inv.items ? inv.items.length : 0"
                  :height-prop="tableHeightInvoice"
                  :offline-prop="offline"
                  :type-prop="inv.type"
                  :scale-prop="scale"
                  :product-details-config="productDetailsConfig"
                  @append="(product, call) => append(product, call, index)"
                  @setOffline="setOffline"
                >
                  <template v-slot:product-name-actions>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-on="on"
                          v-bind="attrs"
                          outlined
                          color="secondary"
                          height="27"
                          style="max-width: 32px; min-width: 32px"
                          class="flex-fill pa-0"
                          @click="
                            excelPage = 1;
                            getAllProductsOffline(inv.type);
                          "
                        >
                          <v-icon size="19"> mdi-sync </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("syncData") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="!formType"
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          color="secondary"
                          height="27"
                          style="max-width: 32px; min-width: 32px"
                          class="flex-fill pa-0"
                          @click="goTo(inv.type + 'List')"
                        >
                          <v-icon class="ma-0" size="19">
                            mdi-format-list-numbered
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("list") }} {{ $t(inv.type) }}</span>
                    </v-tooltip>
                  </template>
                </products>
              </div>
            </div>
          </v-form>
          <v-navigation-drawer
            v-if="index === activeInv"
            width="22%"
            class="pa-0 additional-drawer"
            v-model="additionalDrawer"
            app
            temporary
          >
            <div class="additional-drawer-inner d-flex flex-column fill-height">
              <div class="px-4 pt-3 pb-1 additional-drawer-header">
                <div class="d-flex justify-space-between align-center">
                  <v-icon size="15" @click="additionalDrawer = false"> mdi-close </v-icon>
                  <v-card-text class="pa-0 text-body-1">
                    <!-- {{ $t("addtional-information") }} -->
                    {{ $t("otherInputs") }}
                  </v-card-text>
                </div>
                <v-card-text class="pa-0 text-body-2 mt-2">{{
                  $t("tax-calc")
                }}</v-card-text>
                <div class="wrapper-toggle-tax mt-2 d-flex align-center">
                  <div
                    v-for="(item, taxIndex) in taxOption"
                    :key="taxIndex"
                    @click="selectTaxOption(item)"
                    class="child flex-fill text-center"
                    :style="{
                      'background-color':
                        inv.selectedTaxOption == item.value ? '#0066ff' : '',
                      'border-color':
                        inv.selectedTaxOption == item.value ? '#0066ff' : 'silver',
                      color: inv.selectedTaxOption == item.value ? '#fff' : '',
                    }"
                  >
                    <v-card-text class="pa-0 text-body-2">{{ item.label }}</v-card-text>
                  </div>
                </div>
              </div>
              <div class="additional-drawer-content px-4 mt-2">
                <!-- <v-text-field
                  v-model="inv.number"
                  height="20"
                  dense
                  :rules="[v => !!v || $t('is-required')]"
                  outlined
                  class="my-3 dense"
                  clearable
                  :label="$t('number')"
                  @blur="getInvoiceNumber"
                  @focus="focusEvent"
                  ref="number"
                />  -->
                <div
                  class="additional-drawer-row d-flex"
                  :class="{ 'flex-column': isMobile }"
                >
                  <div class="additional-drawer-col flex-fill">
                    <template>
                      <v-text-field
                        id="dueDateId"
                        v-model="inv.dueDate"
                        :label="$t('dueDate')"
                        clear-icon="flaticon2-close-cross"
                        outlined
                        dense
                        clearable
                        class="dense"
                        @keyup="inv.dueDate = null"
                      />

                      <date-picker
                        v-model="inv.dueDate"
                        element="dueDateId"
                        :locale="$store.state.date_locale"
                        :format="$store.state.date_format"
                        auto-submit
                        :min="inv.date"
                        :max="$store.state.endDate"
                        @close="setDate"
                      />
                    </template>
                  </div>
                  <div
                    v-show="
                      (inv.type == 'presale' ||
                        inv.type == 'sell' ||
                        inv.type == 'returnSell') &&
                      (bodyStatus == false || !isMobile)
                    "
                    class="additional-drawer-col flex-fill"
                  >
                    <v-text-field
                      v-model="inv.officialNumber"
                      height="20"
                      dense
                      outlined
                      class="dense"
                      clearable
                      :label="$t('officialNumber')"
                      @blur="getOfficialInvoiceNumber"
                    />
                  </div>
                </div>
                <div class="mt-6" :class="{ 'mb-5': isMobile }">
                  <status
                    v-model="inv.status"
                    :hideconfig="true"
                    :type="inv.type"
                    :value="inv.status"
                  />
                </div>
                <div class="mt-6" :class="{ 'mb-3': isMobile }">
                  <tag v-model="inv.tag" :solo="false" :input="inv.tag" :height="25" />
                </div>
                <div
                  class="mt-6"
                  v-show="showCurrency && !isMobile"
                  :class="{ 'mb-3': isMobile }"
                >
                  <autocomplete
                    ref="refCurrency"
                    v-model="inv.currency"
                    :rules="[(v) => !!v || $t('is-required')]"
                    :title="$t('currency')"
                    type="currency"
                    :init="defaultCurrency"
                    :value="inv.currency"
                    :offline="offline"
                    :set-offline="offline"
                    @change="changeCurrency"
                  />
                </div>
                <div
                  class="mt-6"
                  v-show="showCurrency && !isMobile"
                  :class="{ 'mb-0': isMobile }"
                >
                  <money
                    v-model="inv.currency_amount"
                    :label="$t('currency-rate')"
                    :dense="true"
                    :outlined="true"
                    :solo="false"
                    :clearable="true"
                    value-when-is-empty=""
                    :options="options"
                    class="mb-6 dense"
                  />
                </div>
                <div class="mt-6" :class="{ 'mb-3': isMobile }">
                  <aicomplete
                    v-model="inv.branch"
                    title="branch"
                    type="branch"
                    :set-init="true"
                    :val="inv.branch"
                    :offline="offline"
                    :set-offline="offline"
                    @input="applyAllRowsFee(index)"
                  />
                </div>
                <div class="mt-6" :class="{ 'mb-3': isMobile }">
                  <v-select
                    v-model="inv.type"
                    :label="$t('documentType')"
                    :items="typeItems"
                    :disabled="inv.edit"
                    height="30"
                    dense
                    outlined
                    item-value="value"
                    item-text="text"
                    item-disabled="disable"
                    @input="checkProductsCount"
                  />
                </div>
                <div class="mt-6" :class="{ 'mb-3': isMobile }">
                  <autocomplete
                    v-model="inv.given"
                    :title="$t('accountGiven')"
                    :offline="offline"
                    :set-offline="offline"
                    type="given"
                  />
                </div>
                <div
                  v-if="inv.type === 'sell' || inv.type === 'presale'"
                  class="mt-6"
                  :class="{ 'mb-3': isMobile }"
                >
                  <v-select
                    v-model="inv.priceType"
                    :label="$t('priceTypeCalculate')"
                    :items="priceTypeItems"
                    height="30"
                    dense
                    outlined
                    item-value="value"
                    item-text="text"
                    hide-details
                    @change="onPriceTypeChange(index)"
                  />
                </div>
              </div>
              <div class="additional-drawer-footer px-4 pb-3 pt-2">
                <v-card-text class="pa-0 text-body-2 mb-1">{{
                  $t("description")
                }}</v-card-text>
                <textarea
                  v-model="inv.content"
                  class="additional-drawer-description"
                  :placeholder="$t('description')"
                  rows="3"
                />
                <v-btn
                  block
                  depressed
                  color="primary"
                  class="mt-2 additional-drawer-save"
                  @click="additionalDrawer = false"
                >
                  {{ $t("Save") }}
                </v-btn>
              </div>
            </div>
          </v-navigation-drawer>
        </div>
      </v-container>
    </v-card>
    <v-container class="pa-0 calc-wrapper" style="background-color: #fff">
      <div
        v-for="(inv, index) in invoices"
        :key="index"
        class="w-100"
        :style="{ display: index == activeInv ? 'block' : 'none' }"
      >
        <!--calculator section-->
        <v-container class="pa-2 ma-0 fixed-bottom-payment" style="height: 100%">
          <v-container
            class="pa-0 d-flex align-start gap-2 payment-footer-row"
            :class="{ 'payment-footer-row--no-restaurant': !restaurantPermission }"
            style="height: 100%"
          >
            <div class="w-40 d-flex align-start gap-2 payment-footer-actions">
              <div
                class="invoice-payment-grid"
                :class="{
                  'invoice-payment-grid--no-restaurant': !restaurantPermission,
                }"
              >
                <div class="invoice-payment-grid__primary-col">
                  <!--update-->
                  <v-btn
                    v-if="
                      invoices[activeInv].id != undefined ||
                      invoices[activeInv].id != null
                    "
                    v-shortkey="['f3']"
                    color="primary"
                    class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                    :height="resolveSubmitBtnHeight()"
                    :loading="isLoading"
                    @shortkey="update"
                    @click="update"
                  >
                    <my-icon
                      :name="'bottom-left-cursor-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                    />
                    <span class="mr-1">{{ $t("edit") }}</span>
                  </v-btn>
                  <!--create-->
                  <v-btn
                    type="button"
                    v-shortkey="['f3']"
                    color="primary"
                    class="invoice-payment-grid__btn invoice-submit-btn-fix invoice-payment-grid__btn--compact"
                    v-if="
                      (invoices[activeInv].id == undefined ||
                        invoices[activeInv].id == null) &&
                      !isMobile &&
                      !sellLinkProp
                    "
                    :height="resolveSubmitBtnHeight()"
                    :loading="isLoading"
                    :disabled="isLoading"
                    @shortkey="(e) => create(null, e)"
                    @click="(e) => create(null, e)"
                  >
                    <my-icon
                      :name="'bottom-left-cursor-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                    />
                    <span class="mr-1">{{ $t("submit") }}</span>
                    <span style="color: #fff; font-size: 10px; padding-right: 2px">
                      (F3)
                    </span>
                  </v-btn>
                  <v-btn
                    color="success"
                    class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                    :height="resolveSubmitBtnHeight()"
                    @click="openOptionsDialog('cash-format')"
                  >
                    <my-icon
                      :name="'cash-icon'"
                      :width="19"
                      :height="19"
                      :cursor-pointer="true"
                    />
                    <span class="mr-1">{{ $t(resolveCompositeType()) }}</span>
                  </v-btn>
                  <v-btn
                    color="primary"
                    outlined
                    class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                    :height="resolveSubmitBtnHeight()"
                    @click="sendToPosProcess('remain')"
                    :loading="posPending"
                  >
                    <my-icon
                      :name="'card-pos-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                    />
                    <span class="mr-1">{{ $t("send-to-pos") }}</span>
                  </v-btn>
                </div>
                <div class="invoice-payment-grid__discount-col">
                  <div class="discount-wrapper invoice-payment-grid__discount">
                    <v-container class="pa-0 ma-0 discount discount-panel-width">
                      <div class="invoice-payment-grid__discount-row">
                        <v-tooltip v-if="!isMobile && !sellLinkProp" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              outlined
                              small
                              :disabled="false"
                              color="secondary"
                              class="invoice-payment-grid__coupon-btn pa-0"
                              @click="openDiscountModeDialog"
                            >
                              <v-icon size="16">mdi-cog-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("discount-Mode") }}</span>
                        </v-tooltip>
                        <v-tooltip v-if="!isMobile && !sellLinkProp" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              outlined
                              small
                              :disabled="false"
                              color="secondary"
                              class="invoice-payment-grid__coupon-btn pa-0"
                              @click="openDiscountCodeDialog"
                            >
                              <v-icon size="16">mdi-ticket-percent-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("discount-Code") }}</span>
                        </v-tooltip>
                        <div class="invoice-payment-grid__discount-input mr-1">
                          <v-text-field
                            v-if="percentDiscountStatus"
                            v-model="discountPercent"
                            :placeholder="$t('header-discount-placeholder')"
                            append-icon="mdi-currency-usd"
                            placeholder="%"
                            :height="resolveSubmitBtnHeight()"
                            outlined
                            dense
                            hide-details
                            type="number"
                            max="100"
                            min="0"
                            @focus="onHeaderDiscountFocus"
                            @input="onHeaderDiscountPercentInput"
                            @keyup="onHeaderDiscountPercentInput"
                            @blur="onHeaderDiscountPercentBlur"
                            @click:append="discountChangeStatus"
                          />
                          <money
                            v-else
                            :key="'header-discount-' + headerDiscountInputKey"
                            v-model="inv.discount"
                            :placeholder="$t('header-discount-placeholder')"
                            :dense="true"
                            :outlined="true"
                            :solo="false"
                            :clearable="true"
                            :hide-details="true"
                            :height="String(resolveSubmitBtnHeight())"
                            :options="options"
                            class="mb-0 dense invoice-payment-grid__discount-money"
                            :append-icon="
                              !percentDiscountStatus ? 'mdi-percent-outline' : null
                            "
                            :disabled="
                              inv.sum > 0 ? (percentDiscountStatus ? true : false) : true
                            "
                            @append="discountChangeStatus"
                            @focus="onHeaderDiscountFocus"
                            @input="onHeaderDiscountInput"
                            @blur="onHeaderDiscountBlur"
                          />
                        </div>
                      </div>
                    </v-container>
                  </div>
                  <div class="invoice-payment-grid__action-grid">
                    <div class="invoice-payment-grid__primary-row">
                      <!--reprint last invoice-->
                      <v-tooltip
                        v-if="!isMobile && !sellLinkProp"
                        class="invoice-payment-grid__reprint-cell"
                        bottom
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            type="button"
                            outlined
                            small
                            :disabled="!lastPrintJob"
                            color="secondary"
                            class="invoice-payment-grid__coupon-btn invoice-payment-grid__reprint-btn receipt pa-0"
                            @click="openReprintPreview"
                          >
                            <v-icon size="16" color="#f97316"
                              >mdi-receipt-text-outline</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>{{ $t("print") + " " + $t("prevInvoice") }}</span>
                      </v-tooltip>
                      <div class="invoice-payment-grid__print-group">
                        <!--create-->
                        <v-btn
                          v-if="
                            (invoices[activeInv].id == undefined ||
                              invoices[activeInv].id == null) &&
                            !isMobile &&
                            !sellLinkProp
                          "
                          type="button"
                          v-shortkey="['f5']"
                          color="secondary"
                          outlined
                          class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                          :loading="isLoading"
                          :height="resolveSubmitBtnHeight()"
                          @shortkey="(e) => create('print', e)"
                          @click="(e) => create('print', e)"
                        >
                          <span style="color: #000">{{ $t("submit&Print") }}</span>
                          <span style="color: #000; font-size: 10px; padding-right: 2px">
                            (F5)
                          </span>
                        </v-btn>
                        <!--update-->
                        <v-btn
                          v-if="
                            (invoices[activeInv].id != undefined ||
                              invoices[activeInv].id != null) &&
                            !isMobile &&
                            !sellLinkProp
                          "
                          v-shortkey="['f5']"
                          color="secondary"
                          outlined
                          class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                          :loading="isLoading"
                          :height="resolveSubmitBtnHeight()"
                          @shortkey="update('print')"
                          @click="update('print')"
                        >
                          <span style="color: #000">{{ $t("edit&Print") }}</span>
                        </v-btn>
                        <!--create-->
                        <v-btn
                          v-if="
                            (invoices[activeInv].id == undefined ||
                              invoices[activeInv].id == null) &&
                            !isMobile &&
                            !sellLinkProp
                          "
                          type="button"
                          v-shortkey="['f4']"
                          color="secondary"
                          outlined
                          class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                          :loading="isLoading"
                          :height="resolveSubmitBtnHeight()"
                          @shortkey="(e) => create('printId', e)"
                          @click="(e) => create('printId', e)"
                        >
                          <span style="color: #000">{{ $t("submit&PrintId") }}</span>
                        </v-btn>
                        <!--update-->
                        <v-btn
                          v-if="
                            (invoices[activeInv].id != undefined ||
                              invoices[activeInv].id != null) &&
                            !isMobile &&
                            !sellLinkProp
                          "
                          v-shortkey="['f4']"
                          color="secondary"
                          outlined
                          class="invoice-payment-grid__btn invoice-payment-grid__btn--compact"
                          :loading="isLoading"
                          :height="resolveSubmitBtnHeight()"
                          @shortkey="update('printId')"
                          @click="update('printId')"
                        >
                          <span style="color: #000">{{ $t("edit&PrintId") }}</span>
                        </v-btn>
                      </div>
                    </div>
                    <div
                      class="invoice-payment-grid__secondary-row"
                      :class="{
                        'invoice-payment-grid__secondary-row--solo': !restaurantPermission,
                        'invoice-payment-grid__secondary-row--with-scale': scale,
                        'invoice-payment-grid__secondary-row--align-print':
                          restaurantPermission && !scale,
                      }"
                    >
                      <div
                        :class="[
                          restaurantPermission && !scale
                            ? 'invoice-payment-grid__hall-composite-group'
                            : 'invoice-payment-grid__main-actions',
                          restaurantPermission && !scale && !isMobile && !sellLinkProp
                            ? 'invoice-payment-grid__hall-composite-group--with-reprint'
                            : null,
                        ]"
                      >
                        <!-- resturant text btn-->
                        <div
                          v-if="restaurantPermission && !scale"
                          class="invoice-payment-grid__hall"
                          :class="{
                            'invoice-payment-grid__hall--btn': !inv.orderCreated,
                          }"
                          @click="inv.orderInfoDialog = true"
                        >
                          <template v-if="inv.orderCreated">
                            <div
                              v-if="inv.restaurant.order_type == 'in_hall'"
                              class="invoice-payment-grid__hall-content"
                            >
                              <div>
                                {{ $t("order-in-hall") }} -
                                {{ resolveHallType(inv.selectedHallType) }}
                              </div>
                              <div>
                                {{ $t("table") }}
                                {{ resolveTableNumber(inv.restaurant.table_id) }} -
                                {{ inv.restaurant.guest_count }} {{ $t("per-person") }}
                              </div>
                            </div>
                            <div
                              v-else-if="inv.restaurant.order_type == 'take_away'"
                              class="invoice-payment-grid__hall-content"
                            >
                              <div>{{ $t("takeaway-order") }}</div>
                              <div>{{ $t(inv.restaurant.delivery_method) }}</div>
                            </div>
                          </template>
                          <span v-else class="invoice-payment-grid__hall-label">
                            {{ $t("order") }} / {{ $t("dining-hall") }} /
                            {{ $t("table") }}
                          </span>
                        </div>

                        <!-- resturant icon-->
                        <v-tooltip
                          v-if="restaurantPermission && scale"
                          class="invoice-payment-grid__reprint-cell"
                          bottom
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              type="button"
                              outlined
                              small
                              color="secondary"
                              class="invoice-payment-grid__coupon-btn invoice-payment-grid__reprint-btn forKknife pa-0"
                              @click="inv.orderInfoDialog = true"
                            >
                              <v-icon size="16" color="#0d9488"
                                >mdi-silverware-fork-knife</v-icon
                              >
                            </v-btn>
                          </template>
                          <span>
                            <template v-if="inv.orderCreated">
                              <template v-if="inv.restaurant.order_type == 'in_hall'">
                                {{ $t("order-in-hall") }} -
                                {{ resolveHallType(inv.selectedHallType) }} /
                                {{ $t("table") }}
                                {{ resolveTableNumber(inv.restaurant.table_id) }}
                              </template>
                              <template
                                v-else-if="inv.restaurant.order_type == 'take_away'"
                              >
                                {{ $t("takeaway-order") }} /
                                {{ $t(inv.restaurant.delivery_method) }}
                              </template>
                            </template>
                            <template v-else>
                              {{ $t("order") }} / {{ $t("dining-hall") }} /
                              {{ $t("table") }}
                            </template>
                          </span>
                        </v-tooltip>

                        <div
                          class="composite-responsive-wrapper invoice-payment-grid__composite-cell"
                        >
                          <composite
                            class="composite-responsive invoice-payment-grid__composite-compact"
                            :compact="true"
                            :total="total"
                            :discount="inv.discount"
                            :totalTax="inv.totalTax"
                            @totalAmount="totalAmount"
                            :credit="credit"
                            :pos="true"
                            :currency="$store.state.currency"
                            :posesList="posesList"
                            :propType="resolveCompositeType()"
                            :propDate="inv.date"
                            :account="inv.account"
                            :optionDialogType="inv.optionDialogType"
                            @closeOptionsDialog="inv.optionDialogType = null"
                            @paymentDialogOpen="closeChildCalculator"
                            @update="onTableUpdate"
                            :editCompositeTableData="inv.compositeTableData"
                            :returnPosInfo="returnPosInfo"
                            @sendToPosProcess="sendToPosProcess"
                            :isPosSuccessfull="isPosSuccessfull"
                            @successAdded="isPosSuccessfull = false"
                          />
                        </div>
                      </div>

                      <div v-if="scale" class="invoice-scale-cluster">
                        <segment-display :value="weight" />
                        <v-btn color="error" class="parsang-icon-btn" @click="setParsang">
                          {{ $t("parsang") }}
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-60 invoice-total-panel">
              <div class="header-total d-flex align-center py-1">
                <v-container
                  v-if="hasCustomerClub && !id"
                  class="pa-0 pl-2"
                  style="border-left: 1px solid silver"
                >
                  <div class="d-flex justify-space-between">
                    <div class="d-flex align-center gap-2">
                      <v-checkbox color="primary" v-model="inv.credit_status">
                      </v-checkbox>
                      <v-card-text class="text-body-2 pa-0">{{
                        $t("club-credit")
                      }}</v-card-text>
                    </div>
                    <div class="d-flex align-center gap-1">
                      <v-btn
                        width="32"
                        height="32"
                        icon
                        :loading="isLoading"
                        color="secondary"
                      >
                        <v-icon
                          size="14"
                          style="cursor: pointer"
                          @click="fetchUserCredit"
                          color="secondary"
                        >
                          mdi-refresh
                        </v-icon>
                      </v-btn>
                      <v-card-text class="text-h5 pa-0">{{
                        $numberFormat(inv.userCredit)
                      }}</v-card-text>
                      <v-card-text class="text-h5 pa-0">{{
                        $store.state.currency.symbol
                      }}</v-card-text>
                    </div>
                  </div>
                </v-container>
                <v-container class="pa-0 pr-2">
                  <div class="d-flex justify-space-between">
                    <v-card-text class="pa-0 text-body-1" style="color: #0066ff">{{
                      $t("sum-total")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-1" style="color: #0066ff"
                      >{{ $numberFormat(total) }}
                      {{ $store.state.currency.symbol }}</v-card-text
                    >
                  </div>
                </v-container>
              </div>
              <div class="body-total d-flex align-center">
                <v-container class="pa-2" style="border-left: 1px solid silver">
                  <div class="d-flex justify-space-between align-center">
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("invoice-total")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">
                      <!-- {{ $numberFormat(+totalFee + +inv.totalTax) }} -->
                      {{ $numberFormat(+totalFee) }}
                    </v-card-text>
                  </div>
                  <div class="d-flex justify-space-between align-center my-1">
                    <span class="d-flex">
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("total-tax")
                      }}</v-card-text>
                      <v-icon
                        size="18"
                        class="mr-1"
                        color="secondary"
                        style="cursor: pointer"
                        @click="additionalDrawer = true"
                        >mdi-cog-outline</v-icon
                      >
                    </span>
                    <!-- <v-card-text class="pa-0 text-body-2">{{
                      $t("tax-total")
                    }}</v-card-text> -->
                    <v-card-text class="pa-0 text-body-2">{{
                      $numberFormat(inv.totalTax)
                    }}</v-card-text>
                  </div>
                  <div class="d-flex justify-space-between align-center">
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("discount-total")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">{{
                      $numberFormat(inv.discount) != "NaN"
                        ? $numberFormat(inv.discount)
                        : 0
                    }}</v-card-text>
                  </div>
                </v-container>
                <v-container class="pa-2">
                  <div class="d-flex justify-space-between align-center">
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("count-of-ware")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">{{
                      $numberFormat(inv.totalCount)
                    }}</v-card-text>
                  </div>
                  <div
                    class="d-flex justify-space-between align-center mt-1"
                    v-if="hasCustomerClub"
                  >
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("club-credit")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">
                      {{ !id ? $numberFormat(creditAmount) : $numberFormat(prevCredit) }}
                      {{ $store.state.currency.symbol }}
                    </v-card-text>
                  </div>
                  <div class="d-flex justify-space-between align-center my-1">
                    <v-card-text class="pa-0 text-body-2">{{
                      $t("payments-total")
                    }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">{{
                      inv.totalPayment ? inv.totalPayment.toLocaleString("fa-IR") : 0
                    }}</v-card-text>
                  </div>
                  <div class="d-flex justify-space-between align-center">
                    <v-card-text class="pa-0 text-body-2">{{ $t("remain") }}</v-card-text>
                    <v-card-text class="pa-0 text-body-2">{{
                      $numberFormat(inv.remainInvoice)
                    }}</v-card-text>
                  </div>
                </v-container>
              </div>
            </div>
          </v-container>
        </v-container>
      </div>
    </v-container>

    <v-dialog
      v-model="taskDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="printDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col class="pb-2 px-2" cols="12">
            <print
              :data-prop="reportData"
              :report-prop="reportName"
              :resource-prop="reportName"
            />
          </v-col>
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogPriceChange"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5"> Use Google's location service? </v-card-title>

        <v-card-text>
          Let Google help apps determine location. This means sending anonymous location
          data to Google, even when no apps are running.
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn color="green darken-1" text @click="dialogPriceChange = false">
            {{ $t("yes") }}
          </v-btn>

          <v-btn color="pink darken-1" text @click="dialogPriceChange = false">
            {{ $t("no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <p style="color: white" class="text-center">
            {{ !lodingText ? $t("syncData") : $t(lodingText) }} ...
          </p>
          <v-progress-linear v-model="progressPercent" color="amber" height="5" />
          <div align="center">
            <p class="white--text mb-0">{{ progressPercent }} %</p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="helpDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '50%'"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="helpDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card class="mx-auto" flat>
          <v-card-text>
            <div class="text--primary">
              {{ $t("indexCategoryHelpContent") }}
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              color="deep-purple accent-4"
              class="ms-2"
              @click="downloadTools"
            >
              {{ $t("downloadSoftware") }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="configDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '50%'"
    >
      <v-card class="pa-5" height="410">
        <v-container class="pa-0 d-flex justify-space-between mb-8">
          <v-card-text class="pa-0 text-body-1">{{ $t("setting") }}</v-card-text>
          <v-icon size="20" @click="configDialog = false" style="cursor: pointer"
            >mdi-close</v-icon
          >
        </v-container>
        <v-tabs v-model="activeTab" vertical>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/fast-access.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("fast-access")
            }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/pos.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("pos-device")
            }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/printer.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t("printer") }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/scales.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{ $t("scale") }}</v-card-text>
          </v-tab>
          <v-tab class="justify-start">
            <img src="@/assets/cash-register/other-setting.png" />
            <v-card-text class="pa-0 text-body-2 ms-2">{{
              $t("otherSetting")
            }}</v-card-text>
          </v-tab>
          <!--fast access-->
          <v-tab-item>
            <v-card-text class="pa-0 text-body-1 mb-5">{{ $t("dashboard") }}</v-card-text>
            <v-container class="pa-0 d-flex flex-column gap-2">
              <!-- <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/fund.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{ $t('default-cach') }}</v-card-text>
                      <v-card-text class="pa-0 text-caption mt-1" style="color: #747373;">برای تنظیم کردن میزان استفاده ترازو مقدار آن را صفر میکند</v-card-text>
                    </div>
                  </div>
                  <autocomplete
                    v-if="currency"
                    v-model="defaultCash"
                    :title="$t('cash')"
                    :currency-prop="currency.id"
                    type="bankCash"
                    class="mt-1"
                  />
                </v-container>
              </v-container> -->
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/calculator.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("calculator")
                      }}</v-card-text>
                      <v-card-text class="pa-0 text-caption mt-1" style="color: #747373">
                        {{ $t("fee-calculator-setting-desc") }}
                      </v-card-text>
                    </div>
                  </div>
                  <v-container
                    class="wrapper-toggle d-flex align-center pa-0 ma-0"
                    style="width: 151px"
                  >
                    <div
                      v-for="(item, index) in taxOption"
                      :key="index"
                      @click="selectFeeCalculatorOption(item)"
                      class="child flex-fill text-center"
                      :style="{
                        'background-color':
                          feeCalculatorStatus == item.value ? '#0066ff' : '',
                        'border-color':
                          feeCalculatorStatus == item.value ? '#0066ff' : 'silver',
                        color: feeCalculatorStatus == item.value ? '#ffff' : '',
                      }"
                    >
                      <v-card-text class="pa-0 text-caption">{{
                        item.label
                      }}</v-card-text>
                    </div>
                  </v-container>
                </v-container>
              </v-container>
              <!-- <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/calculator.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("calculator")
                      }}</v-card-text>
                    </div>
                  </div>
                  <v-btn
                    color="primary"
                    outlined
                    height="32"
                    @click="openCalculator"
                    disabled
                  >
                    {{ $t("unlock") }}
                  </v-btn>
                </v-container>
              </v-container>
              <v-container class="box px-3 py-2">
                <v-container class="pa-0 d-flex justify-space-between align-center">
                  <div class="d-flex align-center gap-3">
                    <img src="@/assets/cash-register/keyboard.png" />
                    <div>
                      <v-card-text class="pa-0 text-body-2">{{
                        $t("keyboard")
                      }}</v-card-text>
                    </div>
                  </div>
                  <v-btn
                    color="primary"
                    outlined
                    height="32"
                    @click="openWindowsKeyboard"
                    disabled
                  >
                    {{ $t("unlock") }}
                  </v-btn>
                </v-container>
              </v-container> -->
            </v-container>
            <!-- <v-container class="pa-0 d-flex justify-end mt-5">
              <v-btn
                color="error"
                outlined
                height="32"
              >
              {{ $t('delete-data-base') }}
              </v-btn>
            </v-container> -->
          </v-tab-item>
          <!--pos device-->
          <v-tab-item>
            <v-container class="pa-0 d-flex justify-space-between">
              <v-card-text class="pa-0 text-body-1 mb-5">{{
                $t("pos-device")
              }}</v-card-text>
              <v-btn color="primary" outlined height="32" @click="openPosDialog('add')">
                {{ $t("add-new-device") }}
              </v-btn>
            </v-container>
            <v-data-table
              :headers="posHeaders"
              :items="posItems"
              :items-per-page="-1"
              hide-default-footer
              :height="isMobile || isTablet ? 265 : 252"
              fixed-header
              class="pos-table"
            >
              <template v-slot:item.status="{ item, index }">
                <v-checkbox
                  v-model="item.status"
                  :true-value="'active'"
                  :false-value="null"
                  @change="setActiveStatus(index)"
                />
              </template>
              <template v-slot:item.title="{ item, index }">
                {{ item.title }}
              </template>
              <template v-slot:item.posDevice="{ item }">
                {{ item.posDevice.Name }}
              </template>
              <template v-slot:item.bank="{ item }">
                {{ item.bank.name }}
              </template>
              <template v-slot:item.posPort="{ item }">
                {{ item.posPort ? item.posPort : $t("haveNot") }}
              </template>
              <template v-slot:item.posIp="{ item }">
                {{ item.posIp ? item.posIp : $t("haveNot") }}
              </template>
              <template v-slot:header.edit="{ header }">
                <v-container
                  class="pa-0 d-flex align-center justify-space-between ma-0 gap-2"
                >
                  {{ $t("edit") }}
                  <div style="cursor: pointer" @click="openDeletePermissionDialog('all')">
                    <my-icon
                      :name="'trash-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                      :fill="'#000'"
                    />
                  </div>
                </v-container>
              </template>
              <template v-slot:item.edit="{ item, index }">
                <v-container class="pa-0 d-flex align-center ma-0 justify-space-between">
                  <div
                    style="cursor: pointer"
                    class="pr-2"
                    @click="openPosDialog('edit', item)"
                  >
                    <my-icon
                      :name="'edit-icon'"
                      :width="15"
                      :height="15"
                      :stroke="'#000'"
                      :cursor-pointer="true"
                    />
                  </div>
                  <div
                    style="cursor: pointer"
                    @click="openDeletePermissionDialog('single', item, index)"
                  >
                    <my-icon
                      :name="'trash-icon'"
                      :width="15"
                      :height="15"
                      :cursor-pointer="true"
                      :fill="'#000'"
                    />
                  </div>
                </v-container>
              </template>
            </v-data-table>
          </v-tab-item>
          <!--printer-->
          <v-tab-item>
            <v-card-text class="pa-0 text-body-1 mb-5">{{ $t("printer") }}</v-card-text>
            <v-container class="pa-0 d-flex flex-column gap-2">
              <v-container class="box px-3 py-2" style="height: 70px">
                <v-container class="pa-0 d-flex justify-space-between">
                  <v-card-text class="pa-0 text-body-2">{{
                    $t("choose-printer")
                  }}</v-card-text>
                  <div>
                    <v-autocomplete
                      v-model="selectedPrinter"
                      :rules="[(v) => !!v || $t('is-required')]"
                      :label="$t('chose-device')"
                      class="mt-2 printer-device"
                      outlined
                      :items="printerList"
                      item-text="Name"
                      item-value="Key"
                      return-object
                    />
                  </div>
                </v-container>
              </v-container>
            </v-container>
          </v-tab-item>
          <!--scale-->
          <v-tab-item>
            <v-card-text class="pa-0 text-body-1 mb-5">{{ $t("scale") }}</v-card-text>
            <v-form ref="formScale">
              <v-container class="pa-0 d-flex flex-column gap-4">
                <div class="d-flex align-center gap-1">
                  <v-checkbox color="primary" v-model="scale"> </v-checkbox>
                  <v-card-text class="pa-0 text-body-1">{{
                    $t("activate-scale")
                  }}</v-card-text>
                </div>
                <v-select
                  dense
                  style="width: 200px"
                  outlined
                  :label="$t('choose-scale')"
                  :items="scalesType"
                  :rules="[(v) => !!v || $t('is-required')]"
                  v-model="scaleType"
                  item-text="label"
                  item-value="value"
                  return-object
                ></v-select>
                <v-container
                  v-if="scaleType && scaleType.value === 2"
                  class="ma-0 pa-0 mt-1"
                >
                  <v-card-text class="pa-0 ma-0 text-body-2">
                    <v-icon size="14">mdi-alert-circle </v-icon>
                    {{ $t("Enter the barcode settings for your scale") }}
                  </v-card-text>
                  <!--item code-->
                  <v-container class="pa-0 ma-0 d-flex gap-1 align-center mt-1">
                    <v-card-text class="pa-0 ma-0 text-body-2 mt-2 pe-2">{{
                      $t("Start of Item Code")
                    }}</v-card-text>
                    <v-text-field
                      v-model="fromThisCharecterItemCode"
                      class="rtl-text mt-2 setting-barcode"
                      style="max-width: 60px"
                      hide-details="auto"
                      clearable
                      outlined
                      height="28"
                      :label="$t('from')"
                      :rules="itemCodeRules"
                    />
                    <v-text-field
                      v-model="untilThisCharecterItemCode"
                      class="rtl-text mt-2 setting-barcode"
                      style="max-width: 60px"
                      hide-details="auto"
                      clearable
                      outlined
                      height="28"
                      :label="$t('until')"
                      :rules="itemCodeRules"
                    />
                  </v-container>
                  <!--item weight-->
                  <v-container class="pa-0 ma-0 d-flex gap-1 align-center mt-1">
                    <v-card-text class="pa-0 ma-0 text-body-2 mt-2">{{
                      $t("Start of Item Weight")
                    }}</v-card-text>
                    <v-text-field
                      v-model="fromThisCharecterItemWeight"
                      class="rtl-text mt-2 setting-barcode"
                      style="max-width: 60px"
                      hide-details="auto"
                      clearable
                      outlined
                      height="28"
                      :label="$t('from')"
                      :rules="itemCodeRules"
                    />
                    <v-text-field
                      v-model="untilThisCharecterItemWeight"
                      class="rtl-text mt-2 setting-barcode"
                      style="max-width: 61px"
                      hide-details="auto"
                      clearable
                      outlined
                      height="28"
                      :label="$t('until')"
                      :rules="itemCodeRules"
                    />
                  </v-container>
                </v-container>
                <v-select
                  v-if="scaleType && scaleType.value != 2"
                  :items="scalePorts"
                  v-model="scalePort"
                  dense
                  style="width: 200px"
                  class="mt-2"
                  outlined
                  :label="$t('choose-port')"
                  item-text="label"
                  item-value="value"
                  :rules="scalePortRules"
                  return-object
                ></v-select>
                <v-btn
                  color="primary"
                  outlined
                  height="32"
                  :loading="loading"
                  class="mt-2"
                  @click="setScaleConfig"
                >
                  {{ $t("submit") }}
                </v-btn>
              </v-container>
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <v-form ref="formSetting">
              <v-container class="pa-0 d-flex flex-column gap-4">
                <v-card-text class="pa-0 ma-0 text-body-1">
                  <v-icon size="15" color="gray">mdi-alert-circle</v-icon>

                  {{ $t("setting_info_product") }}</v-card-text
                >
                <div class="d-flex align-center gap-1">
                  <v-checkbox
                    color="primary"
                    v-model="formSetting.show_product_code"
                  ></v-checkbox>
                  <v-card-text class="pa-0 text-body-2">{{
                    $t("product-code")
                  }}</v-card-text>
                </div>
                <div class="d-flex align-center gap-1">
                  <v-checkbox
                    color="primary"
                    v-model="formSetting.show_price"
                  ></v-checkbox>
                  <v-card-text class="pa-0 text-body-2">{{
                    $t("showing-product-price")
                  }}</v-card-text>
                </div>
                <div class="d-flex align-center gap-1">
                  <v-checkbox
                    color="primary"
                    v-model="formSetting.show_barcode"
                  ></v-checkbox>
                  <v-card-text class="pa-0 text-body-2">{{
                    $t("showBarcodeProduct")
                  }}</v-card-text>
                </div>
                <v-btn
                  color="primary"
                  outlined
                  height="32"
                  :loading="loading"
                  class="mt-2"
                  @click="setProductDetailsConfig()"
                >
                  {{ $t("submit") }}
                </v-btn>
              </v-container>
            </v-form>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addNewPosDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '25%'"
    >
      <v-card class="pa-5">
        <v-form ref="posForm" v-model="valid">
          <v-container class="pa-0 d-flex justify-space-between align-center mb-8">
            <v-card-text class="pa-0 text-body-1">{{
              dialogType == "add" ? $t("new-pos-device") : $t("edit-pos-device")
            }}</v-card-text>
            <v-icon size="20" style="cursor: pointer" @click="addNewPosDialog = false"
              >mdi-close</v-icon
            >
          </v-container>
          <v-card-text class="pa-0 text-caption mb-7"
            >اطلاعات دستگاه پوز خود را وارد کنید</v-card-text
          >
          <v-text-field
            v-model="newPos.title"
            :label="$t('caption')"
            :rules="[(v) => !!v || $t('is-required')]"
            outlined
            dense
            clearable
            class="mt-2 mb-8"
          />
          <v-text-field
            v-model="newPos.posIp"
            :label="$t('PosIp')"
            outlined
            dense
            :rules="[(v) => !!v || $t('is-required')]"
            clearable
          />
          <v-text-field
            v-model="newPos.posPort"
            :label="$t('PosPort')"
            outlined
            dense
            clearable
            class="my-8"
            :rules="[(v) => !!v || $t('is-required')]"
          />
          <autocomplete
            v-model="newPos.bank"
            :rules="[(v) => !!v || $t('is-required')]"
            :title="$t('chose-bank')"
            type="bankCash"
            class="mt-8"
          />
          <v-autocomplete
            v-model="newPos.posDevice"
            :rules="[(v) => !!v || $t('is-required')]"
            :label="$t('chose-device')"
            class="mt-8 pos-device"
            outlined
            :items="posesList"
            item-text="Name"
            item-value="Key"
            return-object
          />
          <v-container class="pa-0 d-flex align-center gap-2 mt-4">
            <v-btn color="primary" height="32" @click="checkValidation">
              {{ dialogType == "add" ? $t("confirm") : $t("edit") }}
            </v-btn>
            <v-btn color="secondary" outlined height="32">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletePermissionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      :width="isMobile ? '100%' : '25%'"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-space-between">
          <v-card-text class="pa-0 text-body-2">
            {{
              isAllItemsDelete
                ? $t("are you sure you want to delete all items?")
                : $t("Are you sure you want to delete this item ?")
            }}
          </v-card-text>
          <v-icon @click="deletePermissionDialog = false" style="cursor: pointer"
            >mdi-close</v-icon
          >
        </v-container>
        <v-container class="pa-0 d-flex gap-2 mt-7">
          <v-btn color="error" height="32" @click="removePosRecord">
            {{ $t("yes") }}
          </v-btn>
          <v-btn outlined height="32" @click="deletePermissionDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="numpadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="323"
    >
      <v-card style="background-color: #e3e3e3">
        <v-col class="d-flex pt-2 pb-0">
          <v-btn icon @click="numpadDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div class="overflow-y-auto ma-1 mx-0 mt-0">
            <numpad :input="numpadValue" @save="setNumpad" />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      :timeout="10000"
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snakbar = !snakbar">
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <!--<div
      v-show="bottomNavigation"
      class="text-center buttom-Button-sheet pa-2"
    >
      <v-btn
        v-if="!sellLinkProp && type === 'sell' "
        v-shortkey="['f6']"
        color="teal"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="sendToPos"
        @click="sendToPos"
      >
        {{ $t('pos&submit') }} (f6)
      </v-btn>
      <v-btn
        v-if="(!id && !isMobile) && !sellLinkProp "
        v-shortkey="['f5']"
        color="primary"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="create('print')"
        @click="create('print')"
      >
        {{ $t('submit&Print') }} (f5)
      </v-btn>
      <v-btn
        v-if="(!id && !isMobile) && !sellLinkProp "
        v-shortkey="['f4']"
        color="blue"
        height="38"
        class="me-2"
        :loading="isLoading"
        @shortkey="create('printId')"
        @click="create('printId')"
      >
        {{ $t('submit&PrintId') }} (f4)
      </v-btn>
      <v-btn
        v-if="id"
        color="blue"
        height="38"
        class="me-2"
        :loading="isLoading"
        @click="update('print')"
      >
        {{ $t('update&Print') }} (f4)
      </v-btn>
      <v-btn
        v-if="!id"
        v-shortkey="['f3']"
        height="38"
        style="background-color: #4CAF50 !important;"
        :loading="isLoading"
        @shortkey="create"
        @click="create"
      >
        {{ $t('submit') }} (f3)
      </v-btn>
      <v-btn
        v-if="id"
        v-shortkey="['f3']"
        color="primary"
        height="38"
        :loading="isLoading"
        @shortkey="update"
        @click="update"
      >
        {{ $t('edit') }} (f3)
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="id"
        color="teal"
        height="38"
        class="mx-3"
        :loading="isLoading"
        @click="clearForm"
      >
        {{ $t('newInvoice') }}
      </v-btn>
      <v-btn
        color="pink"
        height="38"
        :loading="isLoading"
        @click="clearAllItems"
      >
        {{ $t('removeAllItems') }}
      </v-btn>
    </div>-->
    <Confirm ref="confirm" />
    <div ref="refPrint" style="display: none">
      <div
        v-for="(inv, index) in invoices"
        :key="index"
        class="w-100"
        :style="{ display: index == activeInv ? 'block' : 'none' }"
      >
        <index-print
          :account-prop="inv.account"
          :date-prop="inv.date"
          :items-prop="inv.items"
          :sum-prop="total"
          :total-discount="inv.discount"
          :total-tax="inv.totalTax"
          :credit-prop="printCredit"
          :id-prop="idPrint"
          :number-prop="inv.number"
          :status-prop="printStatus"
          :content-prop="inv.content"
          :branch-prop="inv.branch"
          :user-info-prop="userInfo"
        />
      </div>
    </div>
    <v-dialog
      v-model="addProductDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="100%"
      max-width="1250"
    >
      <v-container class="pa-0 ma-0" style="background: #fff">
        <v-col class="d-flex pt-2 justify-space-between pb-0">
          <v-btn icon @click="addProductDialog = false">
            <v-icon class="close-hover" large color="grey"> mdi-close </v-icon>
          </v-btn>
          <span class="pa-0 ma-0 py-3"
            >{{ $t("product") }} / {{ $t("service") }}
            <span v-if="!trigger" :key="'adv-' + advanceTitleTick" class="ms-1">{{
              $t("advance")
            }}</span>
          </span>
        </v-col>
        <v-card-text class="pa-0 ma-0">
          <!-- New component CreateSimpleProduct.vue -->
          <create-simple-product
            ref="refCreateSimpleProduct"
            v-model="newProduct"
            :show-simple="true"
            :invoice-trigger="true"
            :toolbar-title="createSimpleProductToolbarTitle"
            form-type="both"
            :card-height="createDialogCardHeight"
            @addproduct="addProductFromDialog"
            @close-create-modal="addProductDialog = false"
            @trigger="handleTriggerTitle"
          />
        </v-card-text>
      </v-container>
    </v-dialog>
    <!--permission-->
    <v-dialog
      v-model="askPermissionDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="300"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="70" color="warning">mdi-alert-circle-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-1 text-center my-3">
          {{
            visitType == "prev"
              ? $t("are you sure you want to go to prev invoice?")
              : visitType == "next"
              ? $t("are you sure you want to go to next invoice?")
              : visitType == "new"
              ? $t("are you sure you want to create new invoice?")
              : visitType == "delete"
              ? $t("are you sure you want to delete all items?")
              : visitType == "localstorage"
              ? $t("do you want to continue with the lastest queue you added ?")
              : ""
          }}
        </v-card-text>
        <v-container class="pa-0 d-flex justify-center align-center gap-2">
          <v-btn
            color="primary"
            height="32"
            @click="
              visitType == 'prev'
                ? prevInvoice()
                : visitType == 'next'
                ? nextInvoice()
                : visitType == 'new'
                ? clearForm()
                : visitType == 'delete'
                ? clearAllItems()
                : visitType == 'localstorage'
                ? (restoreItems = true)
                : ''
            "
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="error" height="32" @click="askPermissionDialog = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--render-pos-error-->
    <v-dialog
      v-model="posErrorDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="450"
      persistent
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="60" color="error">mdi-close-circle</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-center mt-4">
          <span class="text-body-1" style="font-size: 14.5pt !important">
            {{ $t("transition-failed") }}
          </span>
          <br />
          <span class="text-body-2" style="color: silver; font-size: 10.5pt !important">
            {{ posErrorTxt }}
          </span>
        </v-card-text>
        <div class="d-flex align-center justify-space-between mt-5">
          <div class="d-flex align-center gap-2">
            <v-btn
              height="33.5"
              color="primary"
              class="flex-fill"
              @click="startPosProsess"
            >
              <v-icon size="15" class="ml-1">mdi-refresh</v-icon>
              <span>{{ $t("try-again") }}</span>
            </v-btn>
            <v-btn
              height="33.5"
              color="primary"
              outlined
              @click="editInv"
              class="flex-fill"
              :loading="performingInv"
            >
              <my-icon
                :name="'edit-icon'"
                :width="18"
                :height="18"
                :cursor-pointer="true"
                :stroke="'#0066ff'"
                class="ml-1"
              />
              <span>{{ $t("edit-invoice") }}</span>
            </v-btn>
          </div>
          <div>
            <v-btn
              height="33.5"
              color="error"
              outlined
              @click="removeInv"
              :loading="performingInv"
              class="flex-fill"
            >
              <my-icon
                :name="'trash-icon'"
                :width="17"
                :height="17"
                :cursor-pointer="true"
                class="ml-1"
                :fill="'#ff5252'"
              />
              <span>{{ $t("remove-invoice") }}</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <!--print preview-->
    <v-dialog
      v-model="printPreviewDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="600"
    >
      <v-card class="pa-5">
        <v-radio-group v-model="printType" row hide-details>
          <v-radio class="mr-0" :label="$t('A4')" value="a4" />
          <v-radio :label="$t('invoiceRollprint')" value="fish" />
        </v-radio-group>
        <div v-if="printType == 'a4'"></div>
        <div v-if="printType == 'fish'">salam fish</div>
      </v-card>
    </v-dialog>
    <reprint-preview-dialog
      v-model="reprintPreviewDialog"
      :html="lastPrintJob && lastPrintJob.html"
      :invoice-number="lastPrintJob && lastPrintJob.number"
      @confirm="confirmReprintLastInvoice"
      @cancel="reprintPreviewDialog = false"
    />
    <!--dialog for specify the status of opened edit invoice-->
    <v-dialog
      v-model="decStatusEditInvDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="350"
    >
      <v-card class="pa-5" v-if="openedInvForEdit">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="70" color="warning">mdi-alert-circle-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-1 text-center my-5">
          {{ $t("invoice number") }}
          ({{ openedInvForEdit.number }})
          {{ $t("is opened for edit inside the queue , first declare its status.") }}
        </v-card-text>
        <v-container class="pa-0 d-flex justify-space-between align-center">
          <v-btn
            color="success"
            height="32"
            :loading="isLoading"
            @click="update('visit')"
          >
            {{ $t("edit") }}
          </v-btn>
          <v-btn
            color="error"
            height="32"
            :loading="isLoading"
            @click="closeEditInv('edition')"
          >
            {{ $t("close-invoice") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <!--order information-->
    <div v-for="(inv, index) in invoices" :key="index">
      <v-dialog
        v-if="inv.restaurant"
        v-model="inv.orderInfoDialog"
        :fullscreen="isMobile"
        persistent
        :hide-overlay="isMobile"
        width="600"
      >
        <v-card class="pa-5">
          <v-container class="pa-0 d-flex justify-space-between">
            <v-card-text class="pa-0 text-body-1">{{ $t("order-info") }}</v-card-text>
            <v-icon size="18" style="cursor: pointer" @click="closeOrderDialog">
              mdi-close
            </v-icon>
          </v-container>
          <div style="border-top: 1px solid silver" class="my-4"></div>
          <v-container class="pa-0 d-flex justify-space-between">
            <v-card-text class="pa-0 text-body-1 mt-2">{{
              $t("order-type")
            }}</v-card-text>
            <v-container
              class="wrapper-toggle d-flex align-center pa-0 ma-0"
              style="width: 162px"
            >
              <div
                v-for="(item, index) in orderType"
                :key="index"
                @click="selectOrderType(item)"
                class="child flex-fill text-center"
                :style="{
                  'background-color':
                    inv.restaurant.order_type == item.value ? '#0066ff' : '',
                  'border-color':
                    inv.restaurant.order_type == item.value ? '#0066ff' : 'silver',
                  color: inv.restaurant.order_type == item.value ? 'white' : '',
                }"
              >
                <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
              </div>
            </v-container>
          </v-container>
          <v-container v-if="inv.restaurant.order_type == 'in_hall'" class="pa-0">
            <v-container class="pa-0 d-flex justify-space-between mt-3">
              <v-card-text class="pa-0 text-body-1 mt-2">{{
                $t("dining-hall")
              }}</v-card-text>
              <v-container
                class="wrapper-toggle-multiple d-flex align-center pa-0 ma-0"
                style="width: 375px"
              >
                <div
                  v-for="(item, index) in hallsType"
                  :key="index"
                  @click="selectHallType(item)"
                  class="child flex-fill text-center"
                  :style="{
                    'background-color': inv.selectedHallType == item.id ? '#0066ff' : '',
                    'border-color':
                      inv.selectedHallType == item.id ? '#0066ff' : 'silver',
                    color: inv.selectedHallType == item.id ? 'white' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">{{ item.name }}</v-card-text>
                </div>
              </v-container>
            </v-container>
            <v-container class="pa-0 d-flex justify-space-between mt-3">
              <v-card-text class="pa-0 text-body-1 mt-2">{{
                $t("table-number")
              }}</v-card-text>
              <div style="width: 162px">
                <v-select
                  v-model="inv.restaurant.table_id"
                  :label="$t('table-number')"
                  :items="tableNumbers"
                  height="30"
                  class="table-select"
                  dense
                  :rules="[(v) => !!v || $t('is-required')]"
                  outlined
                  item-value="id"
                  :item-text="(item) => `${$t('table')} ${item.number}`"
                />
              </div>
            </v-container>
            <v-container class="pa-0 d-flex justify-space-between mt-4">
              <v-card-text class="pa-0 text-body-1 mt-2">{{
                $t("guest-count")
              }}</v-card-text>
              <v-container
                style="width: 162px"
                class="pa-0 d-flex align-center gap-1 ma-0"
              >
                <v-btn
                  outlined
                  color="success"
                  height="33"
                  style="max-width: 33px; min-width: 33px"
                  @click="inv.restaurant.guest_count++"
                >
                  <v-icon size="17">mdi-plus</v-icon>
                </v-btn>
                <div class="flex-grow-1">
                  <v-text-field
                    v-model="inv.restaurant.guest_count"
                    v-disabled-icon-focus
                    height="28"
                    outlined
                    min="0"
                    hide-details
                    :rules="[(v) => !!v || $t('is-required')]"
                    :placeholder="$t('count')"
                    @input="checkGuestsCount(inv.restaurant.guest_count)"
                    type="number"
                    style="flex: none"
                  />
                </div>
                <v-btn
                  outlined
                  color="error"
                  height="33"
                  :disabled="inv.restaurant.guest_count == 0"
                  style="max-width: 33px; min-width: 33px"
                  @click="inv.restaurant.guest_count--"
                >
                  <v-icon size="18">mdi-minus</v-icon>
                </v-btn>
              </v-container>
            </v-container>
          </v-container>
          <v-container v-if="inv.restaurant.order_type == 'take_away'" class="pa-0">
            <v-container class="pa-0 d-flex justify-space-between mt-3">
              <v-card-text class="pa-0 text-body-1 mt-2">{{
                $t("shipping-methode")
              }}</v-card-text>
              <v-container
                class="wrapper-toggle d-flex align-center pa-0 ma-0"
                style="width: 162px"
              >
                <div
                  v-for="(item, index) in shippingWay"
                  :key="index"
                  @click="selectShippingWay(item)"
                  class="child flex-fill text-center"
                  :style="{
                    'background-color':
                      inv.restaurant.delivery_method == item.value ? '#0066ff' : '',
                    'border-color':
                      inv.restaurant.delivery_method == item.value ? '#0066ff' : 'silver',
                    color: inv.restaurant.delivery_method == item.value ? 'white' : '',
                  }"
                >
                  <v-card-text class="pa-0 text-caption">{{ item.label }}</v-card-text>
                </div>
              </v-container>
            </v-container>
            <v-text-field
              v-model="inv.guestName"
              :label="$t('customer-name')"
              outlined
              class="mt-3"
              clearable
              dense
            />
            <v-text-field
              v-model="inv.guestPhone"
              :label="$t('phone-number')"
              outlined
              class="mt-6"
              clearable
              dense
            />
          </v-container>
          <div
            style="border-top: 1px solid silver"
            class="my-4"
            :class="{ 'mt-8': inv.restaurant.order_type == 'take_away' }"
          ></div>
          <v-container class="pa-0 d-flex justify-space-between">
            <v-btn color="primary" height="32" @click="submitOrderInfo">
              {{ $t("submit") }}
            </v-btn>
            <v-btn color="error" height="32" outlined @click="closeOrderDialog">
              {{ $t("cancel") }}
            </v-btn>
          </v-container>
        </v-card>
      </v-dialog>
    </div>

    <InvoiceSearch
      :isDialogVisible="searchInvDialog"
      @searchInvClosed="searchInvDialog = false"
      :invoiceType="invoiceType"
      @onSelectedRow="selectRowHandler"
    />
    <PermissionDialog
      :askPerm="askPerm"
      :txtPerm="txtPerm"
      :detailPerm="detailPerm"
      :permType="true"
      :dialogWidth="320"
      @accept="accept('submition')"
      @deny="askPerm = false"
    />
    <header-discount-code-dialog
      v-model="discountCodeDialog"
      :customer-phone="promoCustomerPhone"
      :order-subtotal="totalFee"
      :use-wallet="promoUseWallet"
      :branch-name="promoBranchName"
      :discount="promoHeaderDiscount"
      @apply="applyInvoiceDiscountCode"
    />
    <header-discount-mode-dialog
      v-model="discountModeDialog"
      @submit="onHeaderDiscountModeSubmit"
      @cancel="onHeaderDiscountModeCancel"
    />
    <!-- add serial -->
    <serial-management-dialog
      v-if="showSerialFeature"
      v-model="serialDialog"
      :product="(serialItem && serialItem.product) || {}"
      :entrepot="
        (serialItem &&
          (serialItem.article_entrepot ||
            (invoices[activeInv] && invoices[activeInv].entrepot))) ||
        {}
      "
      :total-count="serialItem && serialItem.count"
      :serials="serialDialogList"
      :serial-flow="serialFlow"
      :loading="serialsLoading"
      :has-more="serialHasMore"
      :selected-serials="(serialItem && serialItem.serials) || []"
      @confirm="setSerials"
      @search="onSerialSearch"
      @load-more="loadMoreSerials"
    />
  </v-container>
</template>
<script>
import Task from "../task/task";
import General from "../../../../Mixins/general";
import autocomplete from "../../components/general/patial/autocomplete";
import Description from "../../components/general/description/Description";
import print from "./../../components/general/printViewer/printViewer";
import segmentDisplay from "./../../components/general/7segment/index.vue";
import indexPrint, {
  buildPrintHtmlFromBody,
  downloadPrintHtmlFile,
  getPrintFileName,
} from "./indexCategoryPrint.vue";
import Product from "./../product/product.vue";
import CreateSimpleProduct from "./../product/partial/CreateSimpleProduct.vue";
import invoiceItems from "./partial/indexCategoryItems.vue";
import Composite from "./partial/Composite.vue";
import moment from "moment-jalaali";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import InvoiceSearch from "@/views/dashboard/pages/invoice/CashRegister/partial/InvoiceSearch.vue";
import PermissionDialog from "@/views/dashboard/pages/invoice/CashRegister/partial/PermissionDialog.vue";
import HeaderDiscountCodeDialog from "./partial/HeaderDiscountCodeDialog.vue";
import HeaderDiscountModeDialog from "./partial/HeaderDiscountModeDialog.vue";
import ReprintPreviewDialog from "./partial/ReprintPreviewDialog.vue";
import SerialManagementDialog from "../../components/general/serials/SerialManagementDialog";

export default {
  name: "InvoiceIndex",
  components: {
    Products: () => import("../../components/general/Products/ProductsWithCategory.vue"),
    Tag: () => import("../../components/general/Tag/tag"),
    Status: () => import("../../components/general/Status/status"),
    numpad: () => import("../../components/general/numpad/index.vue"),
    invoiceItems,
    Description,
    indexPrint,
    Product,
    CreateSimpleProduct,
    print,
    segmentDisplay,
    autocomplete,
    Task,
    Composite,
    MyIcon,
    InvoiceSearch,
    PermissionDialog,
    HeaderDiscountCodeDialog,
    HeaderDiscountModeDialog,
    ReprintPreviewDialog,
    SerialManagementDialog,
  },
  mixins: [General],
  props: [
    "input",
    "formType",
    "refId",
    "accountProp",
    "itemsProp",
    "sellLinkProp",
    "returnSellProp",
  ],
  data: function () {
    return {
      scanBuffer: [],
      //trigger to advance)
      trigger: false,
      advanceTitleTick: 0,
      //
      //barcode config
      fromThisCharecterItemCode: null,
      untilThisCharecterItemCode: null,
      fromThisCharecterItemWeight: null,
      untilThisCharecterItemWeight: null,
      //
      lastId: null,
      currentId: 0,
      createIdInvoice: null,
      otherProductCounter: 1,
      pattern: 1,
      selected: [],
      configDialog: false,
      addProductDialog: false,
      createSimpleProductToolbarTitle: false,
      helpDialog: false,
      bottomNavigation: true,
      defaultCash: null,
      numpadDialog: null,
      numpadValue: null,
      selectedItemNumpad: null,
      newProduct: null,
      paymentAmount: null,
      cashAmount: null,
      paymentByPos: null,
      customPaymentAmount: false,
      lodingText: null,
      spliceInv: false,
      idPrint: null,
      printStatus: "print",
      fullscreen: false,
      searchBarcode: null,
      numberForEdit: null,
      abrName: null,
      weight: null,
      tab: null,
      scale: false,
      formSetting: {
        show_price: false,
        show_product_code: false,
        show_barcode: false,
      },
      productDetailsConfig: {
        show_price: false,
        show_product_code: false,
        show_barcode: false,
      },
      scaleType: null,
      scalePort: null,
      uid: null,
      ouid: null,
      redirectUrl: true,
      checkDiscountEdit: false,
      abrironPrinter: false,
      render: true,
      validBank: true,
      selectRow: null,
      offlineSaveStatus: null,
      offline: false,
      nextPermission: false,
      tableHeightInvoice: 380,
      showCurrency: true,
      reportData: null,
      id: null,
      reportName: null,
      plan: null,
      percentDiscountStatus: false,
      bodyStatus: false,
      dialogPriceChange: false,
      allowPriceChange: false,
      invoicePrintType: "normal",
      printDialog: false,
      discountEdit: 0,
      checkNumber: false,
      checkOfficialNumber: false,
      deletDialog: false,
      showClearing: true,
      showSelect: false,
      showProductList: false,
      feeCalculatorEnabled: true,
      clearingStatus: false,
      filter: false,
      valid: true,
      bank: null,
      payments: null,
      checks: null,
      model: null,
      printType: "fish",
      from: 1,
      taskDialog: null,
      temp: null,
      taxPercent: null,
      taxToggleConfigValue: "active",
      deleteItem: null,
      sellStatus: null,
      _hydratingItems: false,
      typeItems: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      priceTimer: 0,
      invoiceNumberTimer: 0,
      _invoiceNumberRequestId: 0,
      totalItems: 1000,
      isLoading: false,
      snakbar: false,
      taskId: null,
      snakbarText: null,
      loading: true,
      tableOptions: {
        itemsPerPage: 1000,
      },
      listOptions: {
        page: 1,
        itemsPerPage: 100,
      },
      headers: null,
      search: null,
      discountPercent: false,
      totalDiscount: 0,
      totalFee: 0,
      sumRow: 0,
      appendTimer: 0,
      decimal: 0,
      autoPrint: true,
      openedInvForEdit: null,
      totalDiscountType: false,
      itemsTableBodyHeight: 300,
      barcodeQueue: [],
      processingBarcode: false,
      barcodeInputThreshold: 300,
      scannerStealThreshold: 50,
      lastKeypressTime: 0,
      barcode: "",
      lastProcessedBarcode: null,
      lastProcessedAt: 0,
      posHeaders: [],
      posItems: [],
      isPosActive: false,
      addNewPosDialog: false,
      newPos: {
        title: null,
        posDevice: null,
        posIp: null,
        posPort: null,
        bank: null,
        status: null,
      },
      dialogType: null,
      selectedIndex: null,
      // optionDialogType: null,
      deletePermissionDialog: false,
      deletedIndex: null,
      isAllItemsDelete: false,
      posesList: [],
      posPending: false,
      selectedPrinter: null,
      activeTab: 0,
      printerList: [],
      POSIP: null,
      POSPORT: null,
      progressPercent: 0,
      returnPosInfo: null,
      isPosSuccessfull: false,
      compositeAmount: null,
      socketPrintRes: null,
      lastPrintJob: null,
      idUser: null,
      credit: null,
      prevCredit: null,
      askPermissionDialog: false,
      visitType: null,
      additionalDrawer: false,
      decStatusEditInvDialog: false,
      errorIndexes: null,
      savedItems: null,
      restoreItems: false,
      printPreviewDialog: false,
      reprintPreviewDialog: false,
      invoiceSubmited: false,
      searchInvDialog: false,
      invoiceType: null,
      posErrorDialog: false,
      posErrorTxt: null,
      pendingHeaderDiscount: null,
      snapshotHeaderDiscount: null,
      snapshotHeaderDiscountPercent: null,
      headerDiscountInputKey: 0,
      discountCodeDialog: false,
      discountModeDialog: false,
      _headerDiscountModeSubmitted: false,
      _vaznDistributeJustApplied: false,
      performingInv: false,
      uidLastInv: null,
      _showRequestId: 0,
      _showCancelledThrough: 0,
      _openEditFromSearch: false,
      _focusEditTabOnOpen: false,
      _suppressAutoReopenEdit: false,
      selectedBank: null,
      currentVersion: null,
      scaleSocket: null,
      invoices: [],
      activeInv: 0,
      askPerm: null,
      txtPerm: null,
      detailPerm: null,
      ObsrvAccount: null,
      ObsrvItems: null,
      ObsrvType: null,
      ObsrvCurrency: null,
      ObsrvTaxStatus: false,
      ObsrvTotalPayment: 0,
      ObsrvCreditStatus: false,
      ObsrvCompositeTableData: null,
      ObsrvOrderType: null,
      hallsType: null,
      userInfo: null,
      shouldSearchDialogOpen: false,
      tableNumbers: null,
      serialDialog: false,
      serialsLoading: false,
      serialPage: 1,
      serialLastPage: 1,
      serialSearch: "",
      serialCancelToken: null,
      serialRequestId: 0,
      serialItem: null,
    };
  },
  computed: {
    currentInvoiceType() {
      return (
        (this.invoices[this.activeInv] && this.invoices[this.activeInv].type) || "sell"
      );
    },
    showSerialFeature() {
      return ["purchase", "sell", "returnPurchase", "returnSell", "presale"].includes(
        this.currentInvoiceType
      );
    },
    serialFlow() {
      const inputTypes = ["purchase", "returnSell"];
      const outputTypes = ["sell", "returnPurchase", "presale"];
      if (inputTypes.includes(this.currentInvoiceType)) return "in";
      if (outputTypes.includes(this.currentInvoiceType)) return "out";
      return "in";
    },
    serialDialogList() {
      if (!this.serialItem) return [];
      if (this.serialFlow === "out") {
        return this.serialItem.serialOptions || [];
      }
      return this.serialItem.serials || [];
    },
    serialHasMore() {
      return this.serialFlow === "out" && this.serialPage < this.serialLastPage;
    },
    scalePortRules() {
      if (this.scaleType && this.scaleType.value === 2) {
        return [];
      }
      return [(v) => !!v || this.$t("is-required")];
    },
    itemCodeRules() {
      if (this.scaleType?.value === 2) return [(v) => !!v || this.$t("is-required")];
      return [];
    },
    scalePorts() {
      return [
        { label: this.$t("COM1"), value: "COM1" },
        { label: this.$t("COM2"), value: "COM2" },
        { label: this.$t("COM3"), value: "COM3" },
        { label: this.$t("COM4"), value: "COM4" },
        { label: this.$t("COM5"), value: "COM5" },
      ];
    },
    scalesType() {
      return [
        { label: this.$t("barcode-Based-Scale"), value: 2 },
        { label: this.$t("TozinSadr"), value: 1 },
        { label: this.$t("Mahak"), value: 0 },
      ];
    },
    total: function () {
      if (this.invoices && this.invoices.length > 0) {
        const inv = this.invoices[this.activeInv];
        let headerDiscount = 0;
        if (inv.totalDiscountType) {
          headerDiscount = parseFloat(
            inv.discount !== "" && inv.discount != null ? inv.discount : 0
          );
        } else {
          headerDiscount = parseFloat(this.totalDiscount !== "" ? this.totalDiscount : 0);
        }
        // var sum = parseFloat(inv.sum) - headerDiscount;
        var sum = parseFloat(inv.sum);
        if (inv.totalDiscountType) {
          sum -= headerDiscount;
        }
        this.checkBankRemain(sum);
        return sum.toFixed(this.decimal);
      }
    },
    taxOption() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    feeCalculatorStatus() {
      return this.feeCalculatorEnabled ? "active" : "deactive";
    },
    priceTypeItems() {
      return [
        { value: "fixedPrice", text: this.$t("fixedPrice") },
        { value: "formulaPrice", text: this.$t("formulaPrice") },
      ];
    },
    creditAmount() {
      if (this.invoices[this.activeInv].credit_status) {
        if (Number(this.invoices[this.activeInv].userCredit) <= Number(this.total)) {
          this.credit = Number(this.invoices[this.activeInv].userCredit);
          return Number(this.invoices[this.activeInv].userCredit);
        } else if (
          Number(this.invoices[this.activeInv].userCredit) > Number(this.total)
        ) {
          this.credit = Number(this.total);
          return Number(this.total);
        }
      } else {
        this.credit = 0;
        return 0;
      }
    },
    printCredit() {
      if (!this.hasCustomerClub) {
        return 0;
      }
      const inv = this.invoices && this.invoices[this.activeInv];
      if (!inv) {
        return 0;
      }
      if (inv.edit) {
        return Number(this.prevCredit || 0);
      }
      if (!inv.credit_status) {
        return 0;
      }
      const userCredit = Number(inv.userCredit || 0);
      const total = Number(this.total || 0);
      return userCredit <= total ? userCredit : total;
    },
    promoCustomerPhone() {
      const acc = this.invoices[this.activeInv]?.account;
      return acc?.mobile;
    },
    promoHeaderDiscount() {
      const inv = this.invoices[this.activeInv];
      const disc = this.parseHeaderDiscountAmount(inv?.discount);
      return disc > 0 ? disc : "";
    },
    promoUseWallet() {
      return !!this.invoices[this.activeInv]?.credit_status;
    },
    promoBranchName() {
      const branch = this.invoices[this.activeInv]?.branch;
      return branch?.name || "";
    },
    orderType() {
      return [
        { label: this.$t("dining-hall"), value: "in_hall" },
        { label: this.$t("takeaway"), value: "take_away" },
      ];
    },
    shippingWay() {
      return [
        { label: this.$t("pickup-in-person"), value: "in_person" },
        { label: this.$t("delivery-by-courier"), value: "courier" },
      ];
    },
    createDialogCardHeight() {
      return "calc(100vh - 165px)";
    },
    anyBlockingDialogOpen() {
      const inv = this.invoices[this.activeInv];
      return !!(
        this.configDialog ||
        this.addProductDialog ||
        this.helpDialog ||
        this.numpadDialog ||
        this.printDialog ||
        this.deletDialog ||
        this.taskDialog ||
        this.addNewPosDialog ||
        this.deletePermissionDialog ||
        this.askPermissionDialog ||
        this.decStatusEditInvDialog ||
        this.printPreviewDialog ||
        this.reprintPreviewDialog ||
        this.searchInvDialog ||
        this.posErrorDialog ||
        this.discountModeDialog ||
        (inv && inv.orderInfoDialog) ||
        (inv && inv.optionDialogType)
      );
    },
  },
  created() {
    this.savedItems = localStorage.getItem("invoices");
    let savedInvoices = JSON.parse(localStorage.getItem("invoices"));
    if (savedInvoices && savedInvoices.length > 0) {
      if (savedInvoices[0].items && savedInvoices[0].items.length > 0) {
        this.askPermissionDialog = true;
      }
      this.visitType = "localstorage";
    }
  },
  watch: {
    anyBlockingDialogOpen(val) {
      if (val) this.closeChildCalculator();
    },
    scaleType(val) {
      if (val && val.value === 2) {
        this.scalePort = null;
      }
    },
    invoices: {
      handler(val) {
        if (val && val.length > 0) {
          localStorage.setItem("invoices", JSON.stringify(this.invoices));
          this.ObsrvAccount = this.invoices[this.activeInv].account;
          this.ObsrvItems = this.invoices[this.activeInv].items;
          this.ObsrvType = this.invoices[this.activeInv].type;
          this.ObsrvCurrency = this.invoices[this.activeInv].currency;
          this.ObsrvTaxStatus = this.invoices[this.activeInv].taxStatus;
          this.ObsrvTotalPayment = this.invoices[this.activeInv].totalPayment;
          this.ObsrvCreditStatus = this.invoices[this.activeInv].credit_status;
          this.ObsrvCompositeTableData = this.invoices[this.activeInv].compositeTableData;
          this.ObsrvOrderType = this.invoices[this.activeInv].restaurant?.order_type;
        }
        if (val && val.length == 0) {
          this.addInvoice();
        }
      },
      deep: true,
    },
    ObsrvOrderType: {
      handler(val) {
        if (val == "in_hall") {
          this.invoices[this.activeInv].selectedHallType =
            this.hallsType && this.hallsType.length > 0 ? this.hallsType[0].id : null;
          this.invoices[this.activeInv].restaurant.delivery_method = null;
          this.invoices[this.activeInv].guestName = null;
          this.invoices[this.activeInv].guestPhone = null;
        }
        if (val == "take_away") {
          this.invoices[this.activeInv].restaurant.delivery_method = "in_person";
          this.invoices[this.activeInv].selectedHallType = null;
          this.invoices[this.activeInv].restaurant.table_id = null;
          this.invoices[this.activeInv].restaurant.guest_count = null;
        }
      },
      deep: true,
      immediate: true,
    },
    hallsType: {
      handler(val) {
        if (val && val.length > 0) {
          this.invoices[this.activeInv].selectedHallType = val[0].id;
        }
      },
      deep: true,
      immediate: true,
    },
    activeInv(val, oldVal) {
      if (oldVal !== undefined && oldVal !== val) {
        this.errorIndexes = null;
      }
      //add total dicount bugfix
      if (oldVal !== undefined && this.invoices[oldVal]) {
        const prev = this.invoices[oldVal];
        prev.totalDiscountType = this.totalDiscountType;
        prev.headerDiscountPercent = this.discountPercent;
        prev.percentDiscountStatus = this.percentDiscountStatus;
      }
      const inv = this.invoices[val];
      if (!inv) return;
      this.totalDiscountType = !!inv.totalDiscountType;
      this.discountPercent =
        inv.headerDiscountPercent !== undefined ? inv.headerDiscountPercent : false;
      this.percentDiscountStatus = !!inv.percentDiscountStatus;
      if (inv && !inv.edit) {
        this.id = null;
        this.uid = null;
      } else if (inv && inv.edit && inv.id) {
        this.id = inv.id;
        this.uid = inv.uid;
      }
    },
    printType(val) {
      console.log(val);
    },
    restoreItems(val) {
      if (val) {
        this._hydratingItems = true;
        try {
          this.invoices = JSON.parse(this.savedItems);
        } catch (e) {}
        this.$nextTick(() => {
          this._hydratingItems = false;
        });
      } else {
        this.addInvoice();
      }
      this.askPermissionDialog = false;
    },
    socketPrintRes: {
      handler(val) {
        if (val && val.status == "Printed" && val.type == "create") {
        }
        if (val && val.status == "Printed" && val.type == "update") {
        }
      },
      immediate: true,
      deep: true,
    },
    addProductDialog(val) {
      if (val) {
        // this.$store.commit('SET_AUTOFOCUS', false)
        this.$nextTick(() => {
          const child = this.$refs.refCreateSimpleProduct;
          if (child && typeof child.simple !== "undefined") {
            this.trigger = child.simple;
            this.advanceTitleTick += 1;
          }
        });
      } else {
        // this.$store.commit('SET_AUTOFOCUS', true)
        // this.$store.commit('SET_PREINPUT', null)
        // this.$refs.productCategoryRef.setFocus()
      }
    },
    cashAmount(val) {
      if (val && !this.defaultCash) {
        this.configDialog = true;
        this.snakbarText = this.$t("pleaseSelectCashForCashPayment");
        this.snakbarColor = "blue";
        this.snakbar = true;
      }
      if (val) {
        var remain = +this.total - +val;
        if (remain > 0) {
          this.paymentAmount = remain;
        }
      }
    },
    defaultCash(val) {
      localStorage.setItem("defaultCash", JSON.stringify(val));
      this.bank = this.defaultCash;
    },
    total(val) {
      this.paymentAmount = val;
      this.invoices[this.activeInv].remainInvoice =
        val - this.invoices[this.activeInv].totalPayment;
    },
    ObsrvTotalPayment: {
      handler(val) {
        if (val || val == 0) {
          this.invoices[this.activeInv].remainInvoice =
            this.total - this.invoices[this.activeInv].totalPayment;
        }
      },
      deep: true,
    },
    ObsrvCreditStatus(val) {
      if (val) {
        this.invoices[this.activeInv].remainInvoice =
          this.total -
          this.invoices[this.activeInv].totalPayment -
          this.invoices[this.activeInv].userCredit;
      } else {
        this.invoices[this.activeInv].remainInvoice =
          this.total - this.invoices[this.activeInv].totalPayment;
      }
    },
    ObsrvCompositeTableData(val) {
      if (val) {
        this.invoices[this.activeInv].remainInvoice =
          this.total - this.invoices[this.activeInv].totalPayment;
      }
    },
    customPaymentAmount(val) {
      this.paymentAmount = this.total;
    },
    returnSellProp(val) {
      this.onResize();
    },
    abrironPrinter(val) {
      localStorage.setItem("abrironPrinter", val);
    },
    showProductList(val, oldVal) {
      if (val) {
        localStorage.setItem("showProductListInvoice", val);
      } else {
        localStorage.removeItem("showProductListInvoice");
      }
    },
    feeCalculatorEnabled(val) {
      localStorage.setItem("feeCalculatorEnabled", val ? "true" : "false");
    },
    ObsrvAccount: {
      handler(val) {
        if (!this.id) {
          localStorage.setItem("defaultAccount", JSON.stringify(val));
        }
        if (val && this.invoices && this.invoices[this.activeInv]) {
          if (val.customer_club_credit && val.customer_club_credit.length > 0) {
            this.invoices[this.activeInv].userCredit = Number(
              val.customer_club_credit[0].value || 0
            );
          } else {
            this.invoices[this.activeInv].userCredit = 0;
          }
          this.idUser = val.id;
          // if (this.idUser) {
          //   this.fetchUserCredit();
          // }
          if (this.shouldApplyPricing()) {
            this.applyAllRowsFee();
          }
          // this.applyAllRowsFee();
        }
      },
      deep: true,
      immediate: true,
    },
    ObsrvItems: {
      handler(val) {
        if (val.length == 0) {
          // if (!this.totalDiscountType) {
          //add total dicount bugfix
          this.invoices[this.activeInv].discount = 0;
          this.invoices[this.activeInv].totalDiscountType = false;
          this.totalDiscountType = false;
          this.invoices[this.activeInv].headerDiscountPercent = false;
          this.discountPercent = false;
          this.invoices[this.activeInv].percentDiscountStatus = false;
          this.percentDiscountStatus = false;
          this.totalDiscount = 0;
          this.invoices[this.activeInv].remainInvoice = 0;
        } else {
          let sumDiscount = val.reduce((acc, row) => {
            const d = Number(row?.discount);
            return acc + (Number.isFinite(d) ? d : 0);
          }, 0);
          // if (!this.totalDiscountType) {
          if (!this.invoices[this.activeInv].totalDiscountType) {
            this.invoices[this.activeInv].discount = sumDiscount;
          }
        }
      },
      deep: true,
    },
    ObsrvType(val) {
      this.invoiceType = val;
    },
    ObsrvCurrency(val, old) {
      this.decimal = 0;
      if (val) {
        this.decimal = val.decimal;
        if (this.render) {
          this.invoices[this.activeInv].currency_amount = val.amount;
          this.bank = null;
        }
      } else {
        this.invoices[this.activeInv].currency_amount = null;
      }
      if (this.render) {
        // this.clearRows()
      }
    },
    ObsrvTaxStatus(val, old) {
      // if (val) {
      //   this.totalDiscountType = false;
      //   this.invoices[this.activeInv].totalDiscountType = false;
      //   this.totalDiscount = 0;
      //   this.invoices[this.activeInv].discount = 0;
      // }
      this.calcSum();
    },
    taxPercent(val, old) {
      // if (this.invoices[this.activeInv].taxStatus) {
      //   this.totalDiscountType = false;
      //   this.invoices[this.activeInv].totalDiscountType = false;
      //   this.totalDiscount = 0;
      //   this.invoices[this.activeInv].discount = 0;
      // }
      this.calcSum();
    },
    discountModeDialog(val, oldVal) {
      if (
        oldVal &&
        !val &&
        this.pendingHeaderDiscount !== null &&
        !this._headerDiscountModeSubmitted
      ) {
        this.onHeaderDiscountModeCancel();
      }
    },
    defaultCurrency() {
      if (this.defaultCurrency && !this.id) {
        this.$refs.refCurrency.setModel(this.defaultCurrency);
        this.invoices[this.activeInv].currency_amount = this.defaultCurrency.amount;
      }
    },
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected?.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0]?.text;
        this.temp = this.selected[0]?.text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    payments: {
      handler() {
        var app = this;
        app.showClearing = true;
        if (app.payments && app.payments.length > 0) {
          app.payments.map(function (value, key) {
            if (value.chip) {
              app.showClearing = false;
              app.clearingStatus = false;
              app.bank = null;
            }
          });
        }
        // app.checks.map(function (value, key) {
        //   if (value.chip) {
        //     app.showClearing = false
        //     app.clearingStatus = false
        //     app.bank = null
        //   }
        // })
      },
      deep: true,
    },
    tableOptions: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.tableOptions.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
    itemsProp(val) {
      if (val) {
        this.invoices[this.activeInv].items = val;
      } else {
        this.invoices[this.activeInv].items = [];
        this.addRow();
      }
    },
    offline() {
      if (this.offline && !this.callInvoiceByNumber) {
        this.getInvoiceNumberOffline();
      } else {
        this.getInvoiceNumber();
      }
      this.setCookie("offlineInvoice", this.offline);
    },
    scale: {
      handler(val) {
        if (val) {
          this.getWeight();
        }
      },
      deep: true,
    },
    activeTab(val) {
      if (val && val == 2) {
        this.getPrinterListBySocket();
      }
    },
    selectedPrinter(val) {
      localStorage.setItem("selectedPrinter", val);
    },
  },
  activated: function () {
    this.beforeMount();
    window.removeEventListener("keydown", this.handleBarcodeScannerInput, true);
    window.addEventListener("keydown", this.handleBarcodeScannerInput, true);
  },
  deactivated: function () {
    window.removeEventListener("keydown", this.handleBarcodeScannerInput, true);
  },
  beforeMount() {
    this.addInvoice();
    this.getProductDetailsConfig();
    this.posHeaders = [
      {
        text: this.$t("active"),
        align: "start",
        sortable: false,
        value: "status",
        width: 30,
      },
      {
        text: this.$t("device-title"),
        align: "start",
        sortable: false,
        value: "title",
      },
      {
        text: this.$t("posType"),
        align: "start",
        sortable: false,
        value: "posDevice",
      },
      {
        text: this.$t("bank"),
        align: "start",
        sortable: false,
        value: "bank",
      },
      {
        text: this.$t("PosIp"),
        align: "start",
        sortable: false,
        value: "posIp",
      },
      {
        text: this.$t("PosPort"),
        align: "start",
        sortable: false,
        value: "posPort",
      },
      {
        text: this.$t("edit"),
        align: "start",
        sortable: false,
        value: "edit",
      },
    ];
  },
  mounted() {
    var app = this;
    const config_ = JSON.parse(localStorage.getItem("scaleConfig") || "{}");
    if (config_ != {}) {
      this.fromThisCharecterItemCode = config_.fromThisCharecterItemCode;
      this.untilThisCharecterItemCode = config_.untilThisCharecterItemCode;
      this.fromThisCharecterItemWeight = config_.fromThisCharecterItemWeight;
      this.untilThisCharecterItemWeight = config_.untilThisCharecterItemWeight;
    }
    app.userInfo = JSON.parse(localStorage.getItem("token"));
    // app.checkSystemUpdate()
    app.getPosInfo();
    app.getSocketVersion();

    app.invoiceType = app.invoices[app.activeInv].type;

    if (app.$route.name === "invoiceCasher") {
      app.invoices[app.activeInv].type = "sell";
    }
    if (app.$route.name === "returnSellCasher") {
      app.invoices[app.activeInv].type = "returnSell";
    }
    if (app.$route.name === "invoiceCasher_") {
      app.invoices[app.activeInv].type = "sell";
    }
    if (app.$route.name === "returnSellCasher_") {
      app.invoices[app.activeInv].type = "returnSell";
    }
    if (app.$route.name === "purchase") {
      app.invoices[app.activeInv].type = "purchase";
    }
    if (app.$route.name === "returnPurchase") {
      app.invoices[app.activeInv].type = "returnPurchase";
    }
    if (app.$route.name === "returnSell") {
      app.invoices[app.activeInv].type = "returnSell";
    }
    // app.offline = true
    if (localStorage.getItem("showProductListInvoice")) {
      app.showProductList = true;
    }
    if (localStorage.getItem("feeCalculatorEnabled") !== null) {
      app.feeCalculatorEnabled = localStorage.getItem("feeCalculatorEnabled") === "true";
    }
    if (localStorage.getItem("abrironPrinter")) {
      app.abrironPrinter = localStorage.getItem("abrironPrinter");
    }
    if (localStorage.getItem("defaultCash")) {
      app.defaultCash = JSON.parse(localStorage.getItem("defaultCash"));
      app.bank = app.defaultCash;
    }
    if (localStorage.getItem("posDevice")) {
      app.posItems = JSON.parse(localStorage.getItem("posDevice"));
    }
    if (localStorage.getItem("scaleConfig")) {
      let scaleConfig = JSON.parse(localStorage.getItem("scaleConfig"));
      app.scalePort = scaleConfig.scalePort;
      app.scaleType = scaleConfig.scaleType;
      app.scale = scaleConfig.scaleStatus;
    }
    app.taxPercent = app.$store.state.tax;
    app.getTaxToggleConfig();
    app.headers = [
      {
        text: app.$t("actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 40,
      },
      {
        text: app.$t("row"),
        align: "start",
        sortable: false,
        value: "row",
        width: 40,
      },
      {
        text: app.$t("product") + "/" + app.$t("service"),
        sortable: false,
        value: "product",
        width: 300,
      },
      {
        text: app.$t("unit"),
        sortable: false,
        value: "unit",
        width: 140,
      },
      {
        text: app.$t("count"),
        sortable: false,
        value: "count",
        width: 200,
      },
      {
        text: app.$t("fee"),
        sortable: false,
        value: "fee",
        width: 200,
      },
      {
        text: app.$t("discount"),
        sortable: false,
        value: "discount",
        width: 230,
      },
      {
        text: app.$t("tax"),
        sortable: false,
        value: "tax",
        width: 160,
      },
      {
        text: app.$t("sum"),
        sortable: false,
        value: "sum",
        width: 170,
      },
    ];
    var presaleDisable = false;
    if (app.$route.name === "presaleEdit" && app.id) {
      presaleDisable = true;
    }
    app.typeItems = [
      {
        value: "sell",
        text: app.$t("sell"),
      },
      {
        value: "presale",
        text: app.$t("presale"),
      },
      {
        value: "returnSell",
        text: app.$t("returnSell"),
        disable: presaleDisable,
      },
      {
        value: "purchase",
        text: app.$t("purchase"),
        disable: presaleDisable,
      },
      {
        value: "returnPurchase",
        text: app.$t("returnPurchase"),
        disable: presaleDisable,
      },
    ];
    if (app.input) {
      app.model = app.input;
    }
    app.loading = false;
    if (app.$route.params.id === null || app.$route.params.id === undefined) {
      // app.addRow()
      // app.currency = app.$store.state.currency
      // app.currency_amount = app.$store.state.currency.amount
    }
    app.$nextTick(() => {
      window.addEventListener("resize", app.onResize);
    });
    if (app.isMobile) {
      app.printType = "fish";
    }
    // app.getAllProductsOffline(app.type)
    // app.getAllPersonOffline()
    app.getAbrOffline();
    if (app.invoices[app.activeInv].type === "returnSell") {
      app.$root.$on("createReturnSell", () => {
        app.redirectUrl = false;
        app.create();
      });
    }
    app.setDefaultCooki();
    var invoiceluncher = localStorage.getItem("invoiceLuncher");
    if (!invoiceluncher) {
      localStorage.setItem("invoiceLuncher", "dbCreated");
    }
    if (invoiceluncher === "dbCreated") {
      localStorage.setItem("invoiceLuncher", "dataSet");
      app.getAllProductsOffline("product");
      app.$store.commit("SET_RELOAD", true);
      app.helpDialog = true;
    }
    var defaultAccount = localStorage.getItem("defaultAccount");
    if (
      defaultAccount != null &&
      defaultAccount != undefined &&
      defaultAccount != "undefined"
    ) {
      app.invoices[app.activeInv].account = JSON.parse(defaultAccount);
    }
    // window.addEventListener("keydown", app.handleBarcodeScannerInput);
    app.selectedPrinter = localStorage.getItem("selectedPrinter");

    document.addEventListener("fullscreenchange", () => {
      this.fullscreen = !!document.fullscreenElement;
    });

    app.fetchHallsType();
    app.fetchTableNumber();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("keydown", this.handleBarcodeScannerInput, true);
    if (this.serialCancelToken) {
      this.serialCancelToken.cancel("Canceled due to destroy");
    }
  },
  methods: {
    closeChildCalculator() {
      const itemsRef = this.$refs.refInvoiceItems;
      const itemsList = Array.isArray(itemsRef) ? itemsRef : itemsRef ? [itemsRef] : [];
      itemsList.forEach((items) => {
        if (items && items.closeCalculator) {
          items.closeCalculator();
        }
      });
      if (this.numpadDialog) {
        this.numpadDialog = false;
      }
    },
    // add trigger advance title (each toggle updates tick so title re-renders)
    handleTriggerTitle(val) {
      this.trigger = val;
      this.advanceTitleTick += 1;
    },
    //set and get ProductDetailsConfig // other setting
    setProductDetailsConfig() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(app.$endpoint + "panel-ui", {
          // params: {
          key: "indexCasher",
          value: JSON.stringify(app.formSetting),
          // },
        })
        .then((res) => {
          app.productDetailsConfig = { ...app.formSetting };
          app.getProductDetailsConfig();
        })
        .catch((err) => {
          app.isLoading = false;
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    getProductDetailsConfig() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .get(app.$endpoint + "panel-ui", {
          params: {
            key: "indexCasher",
          },
        })
        .then((res) => {
          const panelUiConfig = res?.data?.data || res?.data || {};
          const rawValue = panelUiConfig?.value;
          let parsedValue = {};
          if (typeof rawValue === "string") {
            try {
              parsedValue = JSON.parse(rawValue);
            } catch (e) {
              parsedValue = {};
            }
          } else if (rawValue && typeof rawValue === "object") {
            parsedValue = rawValue;
          }
          const fetchedConfig = {
            show_price: !!parsedValue.show_price,
            show_product_code: !!parsedValue.show_product_code,
            show_barcode: !!parsedValue.show_barcode,
          };
          app.formSetting = { ...fetchedConfig };
          app.productDetailsConfig = { ...fetchedConfig };
        })
        .catch((err) => {
          app.isLoading = false;
        })
        .finally(() => {
          app.isLoading = false;
          app.configDialog = false;
        });
    },
    //barcode section
    handleBarcodeScannerInput(event) {
      // console.log(event, "this is event");
      // console.log(typeof event, "this is event");
      // console.log({
      //   key: event.key,
      //   code: event.code,
      //   altKey: event.altKey,
      //   shiftKey: event.shiftKey,
      //   location: event.location,
      // });
      if (event.key == "Alt") return;
      if (event.altKey && /^[0-9]$/.test(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        const now = Date.now();
        if (now - this.lastKeypressTime >= 800) {
          this.barcode = "";
          this.altCodeBuffer = "";
        }
        this.lastKeypressTime = now;
        this.altCodeBuffer += event.key;
        while (this.altCodeBuffer.length >= 3) {
          const code = parseInt(this.altCodeBuffer.slice(0, 3), 10);
          this.altCodeBuffer = this.altCodeBuffer.slice(3);
          if (code > 0) this.barcode += String.fromCharCode(code);
        }
        return;
      }
      const ignoreKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Escape",
        "Tab",
        "Control",
        // "Alt",
        "Meta",
        "CapsLock",
        "Shift",
      ];
      if (ignoreKeys.includes(event.key)) {
        return;
      }

      if (event.key === "F2") {
        event.preventDefault();
        this.addInvoice();
        return;
      }
      const currentTime = new Date().getTime();
      const timeSinceLastKeypress = currentTime - this.lastKeypressTime;
      this.lastKeypressTime = currentTime;
      // add Point of distinction scanner with user
      const el = document.activeElement;
      const isEditable =
        el &&
        (el.tagName === "INPUT" ||
          el.tagName === "TEXTAREA" ||
          el.isContentEditable === true);
      const barcodeComp =
        this.$refs.productCategoryRef &&
        this.$refs.productCategoryRef[this.activeInv] &&
        this.$refs.productCategoryRef[this.activeInv].$refs.refSearchBarcode;
      const isBarcodeField =
        barcodeComp && barcodeComp.$el && barcodeComp.$el.contains(el);

      if (isEditable && !isBarcodeField) {
        this.barcode = "";
        return;
      }
      const looksLikeScanner = timeSinceLastKeypress < this.scannerStealThreshold;
      if (isEditable && !looksLikeScanner) {
        if (timeSinceLastKeypress < this.barcodeInputThreshold) {
          this.barcode = "";
          return;
        }
        this.barcode = event.key.length === 1 ? event.key : "";
        return;
      }

      if (timeSinceLastKeypress < this.barcodeInputThreshold) {
        if (event.key !== "Shift" && event.key !== "Tab") {
          event.preventDefault();
          event.stopPropagation();
        }
        if (
          isEditable &&
          looksLikeScanner &&
          this.barcode &&
          typeof el.value === "string" &&
          el.value.endsWith(this.barcode)
        ) {
          el.value = el.value.slice(0, -this.barcode.length);
          el.dispatchEvent(new Event("input", { bubbles: true }));
        }
        if (isEditable && looksLikeScanner && el.blur) {
          el.blur();
        }
        if (event.key === "Enter") {
          const cleanedBarcode = this.barcode;
          this.barcodeQueue.push(cleanedBarcode);
          this.barcode = "";
          this.scanBuffer = [];
          if (!this.processingBarcode) {
            this.processBarcodes();
          }
        } else if (event.key.length === 1) {
          this.barcode += event.key;
        }
      } else {
        this.barcode = event.key.length === 1 ? event.key : "";
      }
    },
    processBarcodes() {
      if (this.barcodeQueue.length > 0) {
        this.processingBarcode = true;
        const barcodeToProcess = this.barcodeQueue.shift();
        if (!barcodeToProcess || barcodeToProcess.length < 2) {
          setTimeout(() => {
            this.processBarcodes();
          }, 50);
          return;
        }
        const now = Date.now();
        if (
          barcodeToProcess === this.lastProcessedBarcode &&
          now - this.lastProcessedAt < 10
        ) {
          setTimeout(() => {
            this.processBarcodes();
          }, 50);
          return;
        }
        this.lastProcessedBarcode = barcodeToProcess;
        this.lastProcessedAt = now;
        this.$refs.productCategoryRef[this.activeInv].searchBarcode = barcodeToProcess;
        this.$refs.productCategoryRef[this.activeInv].searchIntegrator();
        setTimeout(() => {
          this.processBarcodes();
        }, 300);
      } else {
        this.processingBarcode = false;
      }
    },
    resolveLabelWeight(product) {
      const idsKG = [13, 44, 47, 51];
      const idsG = [14];
      let weight;
      if (idsKG.includes(product.unit.id)) {
        weight = product.labelWeight / 1000;
      } else if (idsG.includes(product.unit.id)) {
        weight = product.labelWeight;
      } else {
        weight = product.labelWeight;
      }

      // Round the result to 4 decimal places
      return parseFloat(weight.toFixed(4));
    },
    append(product, call = null, invIndex = null) {
      this.offline = false;
      var app = this;
      const targetInv = invIndex != null ? invIndex : app.activeInv;
      var count = product.labelWeight
        ? app.resolveLabelWeight(product)
        : product.count
        ? product.count
        : 1;

      var stock = 20000000;
      if (!app.offline && product.type === "product") {
        stock = product.stock ? product.stock.count : 2000000;
        if (
          app.invoices[targetInv].type === "sell" ||
          app.invoices[targetInv].type === "returnPurchase"
        ) {
          if (app.offline && (!product.stock || product.stock.count <= 0)) {
            app.snakbarText = app.$t("alert-is-not-enough-inventory");
            app.snakbarColor = "pink";
            app.snakbar = true;
            return false;
          }
          if (product.stock && product.stock.count < 1) {
            // count = parseFloat(product.stock.count)
          }
        }
      }
      var index = -1;
      // if (app.items && app.items.length == 0) {
      //   app.addRow()
      // }

      if (
        app.invoices[targetInv].items &&
        app.invoices[targetInv].items.length > 0 &&
        !app.invoices[targetInv].items[0].product
      ) {
        app.invoices[targetInv].items.splice(0, 1);
      }
      index = app.invoices[targetInv].items.findIndex((x) =>
        x.product ? x.product.id === product.id : null
      );
      if (index !== -1) {
        if (
          parseFloat(stock) -
            parseFloat(app.invoices[targetInv].items[index].count) -
            parseFloat(count) >=
          0
        ) {
        }
        app.invoices[targetInv].items[index].count =
          parseFloat(app.invoices[targetInv].items[index].count) + parseFloat(count);
        if (
          app.invoices[targetInv].type === "sell" ||
          app.invoices[targetInv].type === "presale"
        ) {
          if (product && product.pricing && product.pricing.length > 0) {
            app.applyRowFee(app.invoices[targetInv].items[index], targetInv);
          } else if (product && !product.price) {
            app.getPrice(app.invoices[targetInv].items[index]);
          }
        }
      } else {
        if (
          !product.labelWeight &&
          app.scale &&
          product.unit &&
          product.unit.type === "jointed"
        ) {
          if (product.unit.name === "Kg") {
            count = parseFloat(app.weight / 1000);
          } else {
            count = parseFloat(app.weight);
          }
        }
        var price = product.price ? product.price : 0;
        app.addRow(product, count, price, targetInv);
      }
      clearTimeout(app.appendTimer);
      if (call === "openEdit") {
        setTimeout(function () {
          app.$refs.refInvoiceItems.openProductEdit(
            app.invoices[targetInv].items[app.invoices[targetInv].items.length - 1]
          );
        }, 100);
      }
      app.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 250);
    },
    addRow(product = null, count = 0, price = 0, invIndex = null) {
      const targetInv = invIndex != null ? invIndex : this.activeInv;
      const productDisc = product ? parseFloat(product.discount) : 0;
      const productDiscPct = product ? parseFloat(product.discount_percent) : 0;
      // Amount wins over percent (same as calcSum / index.vue).
      // Percent-only keeps discount at 0 so calcSum derives amount from fee × count.
      const hasAmountDiscount = productDisc > 0;
      const rowMax = parseFloat(price || 0) * parseFloat(count || 0);
      const amountDiscountPercent =
        hasAmountDiscount && rowMax > 0
          ? parseFloat(((productDisc / rowMax) * 100).toFixed(this.decimal))
          : 0;
      this.invoices[targetInv].items.push({
        product: product,
        count: count,
        countEdit: 0,
        fee: price,
        discount: hasAmountDiscount ? productDisc : 0,
        discountPercent: hasAmountDiscount
          ? amountDiscountPercent
          : productDiscPct > 0
          ? productDiscPct
          : 0,
        tax: 0,
        tax_percent: product && product.tax_percent > 0 ? product.tax_percent : 0,
        unit: null,
        content: 0,
        serials: [],
      });
      //add serial
      this.syncRowSerialFlag(
        this.invoices[targetInv].items[this.invoices[targetInv].items.length - 1]
      );
      var rowIndex = this.invoices[targetInv].items.findIndex(
        (x) => x.product && x.product.id === product.id
      );
      if (rowIndex !== -1 && product && product.pricing && product.pricing.length > 0) {
        this.applyRowFee(this.invoices[targetInv].items[rowIndex], targetInv);
      } else if (
        this.invoices[targetInv].type === "sell" &&
        product &&
        !product.price &&
        rowIndex !== -1
      ) {
        this.getPrice(this.invoices[targetInv].items[rowIndex]);
      }
    },
    //add serial
    getProductHasSerial(product) {
      if (!product) return false;
      const flag = (product.meta && product.meta.has_serial) || product.has_serial;
      return flag === "active";
    },
    rowHasSerial(item) {
      return !!(
        item &&
        (item.has_serial === "active" || this.getProductHasSerial(item.product))
      );
    },
    syncRowSerialFlag(item) {
      if (!item) return;
      const productId = item.product && item.product.id;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = productId;
        return;
      }
      if (productId && productId === item._serialProductId) return;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = productId || null;
    },
    normalizeArticleSerials(source) {
      return (source || [])
        .map((serial, index) => {
          const raw =
            typeof serial === "string"
              ? serial
              : serial &&
                (serial.value ||
                  serial.serial ||
                  serial.serial_number ||
                  serial.code ||
                  "");
          const value = String(raw || "").trim();
          if (!value) return null;
          return {
            id: (serial && (serial.id || serial.serial_id)) || null,
            uid: (serial && (serial.uid || serial.id)) || `${value}-${index}`,
            value,
            created_at: (serial && (serial.created_at || serial.createdAt)) || "",
            selected: serial && serial.selected !== undefined ? !!serial.selected : true,
          };
        })
        .filter(Boolean);
    },
    hydrateItemSerials(item) {
      if (!item || !item.product) return;
      if (this.getProductHasSerial(item.product)) {
        this.$set(item, "has_serial", "active");
        item._serialProductId = item.product.id;
      }
      if (item.serials && item.serials.length) return;
      this.$set(item, "serials", this.normalizeArticleSerials(item.product.serials));
    },
    openSerialDialog(item) {
      const inv = this.invoices[this.activeInv] || {};
      const entrepot = (item && item.article_entrepot) || inv.entrepot;
      if (!entrepot || !entrepot.id) {
        this.snakbarText = this.$t("serial-entrepot-required");
        this.snakbarColor = "pink";
        this.snakbar = true;
        return;
      }
      this.hydrateItemSerials(item);
      if (!item.serials) item.serials = [];
      this.serialItem = item;
      this.serialDialog = true;
      if (this.serialFlow === "out") {
        this.serialPage = 1;
        this.serialLastPage = 1;
        this.serialSearch = "";
        this.$set(item, "serialOptions", []);
        this.fetchProductSerials(item, { page: 1, search: "", append: false });
      }
    },
    onSerialSearch(search) {
      if (!this.serialItem || this.serialFlow !== "out") return;
      this.serialSearch = search || "";
      this.serialPage = 1;
      this.fetchProductSerials(this.serialItem, {
        page: 1,
        search: this.serialSearch,
        append: false,
      });
    },
    loadMoreSerials() {
      if (
        !this.serialItem ||
        this.serialFlow !== "out" ||
        this.serialsLoading ||
        this.serialPage >= this.serialLastPage
      ) {
        return;
      }
      this.fetchProductSerials(this.serialItem, {
        page: this.serialPage + 1,
        search: this.serialSearch,
        append: true,
      });
    },
    mergeSerialOptions(existing, incoming) {
      const next = Array.isArray(existing) ? existing.slice() : [];
      const seen = new Set(next.map((serial) => serial.id).filter((id) => id != null));
      incoming.forEach((serial) => {
        if (serial.id != null && seen.has(serial.id)) return;
        if (serial.id != null) seen.add(serial.id);
        next.push(serial);
      });
      return next;
    },
    selectedSerialRows(item) {
      return this.normalizeArticleSerials(item && item.serials).map((serial) => ({
        ...serial,
        selected: true,
      }));
    },
    fetchProductSerials(item, options = {}) {
      if (!item || !item.product || !item.product.id) {
        this.serialsLoading = false;
        return;
      }
      const page = options.page || 1;
      const search = options.search !== undefined ? options.search : this.serialSearch;
      const append = !!options.append;
      if (append && this.serialsLoading) return;
      const inv = this.invoices[this.activeInv] || {};
      const entrepotId = (item.article_entrepot || inv.entrepot || {}).id;
      var app = this;
      if (app.serialCancelToken) {
        app.serialCancelToken.cancel("Canceled due to new serial request");
      }
      app.serialCancelToken = app.$axios.CancelToken.source();
      const requestId = ++app.serialRequestId;
      app.serialsLoading = true;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            select: "getProductSerials",
            product_id: item.product.id,
            entrepot_id: entrepotId,
            search: search || "",
            page,
          },
          cancelToken: app.serialCancelToken.token,
        })
        .then((res) => {
          if (requestId !== app.serialRequestId || app.serialItem !== item) return;
          const payload = res.data;
          const list = Array.isArray(payload) ? payload : (payload && payload.data) || [];
          app.serialPage =
            (payload &&
              (payload.current_page || (payload.meta && payload.meta.current_page))) ||
            page;
          app.serialLastPage =
            (payload &&
              (payload.last_page || (payload.meta && payload.meta.last_page))) ||
            1;
          const selectedIds = new Set(
            (item.serials || []).map((serial) => serial.id).filter((id) => id != null)
          );
          const selectedValues = new Set(
            (item.serials || []).map((serial) => String(serial.value || "").trim())
          );
          const optionsList = app.normalizeArticleSerials(list).map((serial) => ({
            ...serial,
            selected:
              selectedIds.has(serial.id) ||
              selectedValues.has(String(serial.value || "").trim()),
          }));
          const merged = append
            ? app.mergeSerialOptions(item.serialOptions, optionsList)
            : app.mergeSerialOptions(app.selectedSerialRows(item), optionsList);
          app.$set(item, "serialOptions", merged);
        })
        .catch((err) => {
          if (!app.$axios.isCancel(err)) {
            app.serverErrorHandeler(err);
          }
        })
        .finally(() => {
          if (requestId === app.serialRequestId) {
            app.serialsLoading = false;
          }
        });
    },
    setSerials(serials) {
      if (!this.serialItem) return;
      this.$set(this.serialItem, "serials", serials);
      if (this.serialFlow === "out" && this.serialItem.serialOptions) {
        const selectedIds = new Set(
          (serials || []).map((serial) => serial.id).filter((id) => id != null)
        );
        this.serialItem.serialOptions.forEach((option) => {
          option.selected = selectedIds.has(option.id);
        });
      }
    },
    sanitizeSerialItems(items) {
      const isOut = this.serialFlow === "out";
      return (items || []).map((item) => {
        const next = { ...item };
        delete next._serialProductId;
        delete next.serialOptions;
        if (isOut) {
          next.serial_ids = (item.serials || [])
            .map((serial) => serial && serial.id)
            .filter((id) => id != null);
          delete next.serials;
        }
        return next;
      });
    },
    //
    submitOrderInfo() {
      if (this.invoices[this.activeInv].restaurant.order_type == "in_hall") {
        if (
          this.invoices[this.activeInv].restaurant.table_id == null ||
          this.invoices[this.activeInv].restaurant.guest_count == 0 ||
          this.invoices[this.activeInv].restaurant.guest_count == null
        ) {
          this.snakbar = true;
          this.snakbarColor = "red";
          this.snakbarText = this.$t("table number and guests count is required.");
          return null;
        }
      }
      this.invoices[this.activeInv].orderCreated = true;
      this.invoices[this.activeInv].orderInfoDialog = false;
    },
    closeOrderDialog() {
      this.invoices[this.activeInv].orderInfoDialog = false;
      this.invoices[this.activeInv].restaurant.order_type = "in_hall";
      this.invoices[this.activeInv].selectedHallType =
        this.hallsType && this.hallsType.length > 0 ? this.hallsType[0].id : null;
      this.invoices[this.activeInv].restaurant.table_id = null;
      this.invoices[this.activeInv].restaurant.guest_count = null;
      this.invoices[this.activeInv].restaurant.delivery_method = null;
      this.invoices[this.activeInv].guestName = null;
      this.invoices[this.activeInv].guestPhone = null;
      this.invoices[this.activeInv].orderCreated = false;
    },
    selectShippingWay(item) {
      if (item.value == "in_person") {
        this.invoices[this.activeInv].restaurant.delivery_method = item.value;
      } else {
        this.snakbarText = this.$t("the delivery-by-courier option is not active yet!");
        this.snakbarColor = "red";
        this.snakbar = true;
        this.invoices[this.activeInv].restaurant.delivery_method = "in_person";
      }
    },
    checkGuestsCount(value) {
      if (value < 0) {
        this.invoices[this.activeInv].restaurant.guest_count = 0;
      }
    },
    selectHallType(item) {
      this.invoices[this.activeInv].selectedHallType = item.id;
    },
    selectOrderType(item) {
      this.invoices[this.activeInv].restaurant.order_type = item.value;
    },
    fetchHallsType() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "restaurant/halls", {
          params: {
            options: app.listOptions,
          },
        })
        .then((r) => {
          app.hallsType = r.data.data;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        });
    },
    fetchTableNumber() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "restaurant/tables", {
          params: {
            options: app.listOptions,
          },
        })
        .then((r) => {
          app.tableNumbers = r.data.data;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        });
    },
    resolveTableNumber(value) {
      return this.tableNumbers.find((item) => item.id == value)?.number;
    },
    resolveHallType(value) {
      return this.hallsType.find((item) => item.id == value)?.name;
    },
    resolveInvNum(index) {
      if (this.invoices.some((inv) => inv.edit)) {
        return index;
      } else {
        return index + 1;
      }
    },
    resolveHeightBtn() {
      if (this.restaurantPermission) {
        return 47;
      } else {
        return 50;
      }
    },
    resolveSubmitBtnHeight() {
      if (this.$vuetify.breakpoint.width <= 1137) {
        return this.restaurantPermission ? 30 : 34;
      }
      return this.restaurantPermission ? 36 : 38;
    },
    openDiscountCodeDialog() {
      if (!this.invoices[this.activeInv]?.account?.mobile) {
        this.snakbarText = `${this.$t("choose_cutomer_is_required")}`;
        this.snakbarColor = "red";
        this.snakbar = true;
        return;
      }
      this.discountCodeDialog = true;
    },
    openDiscountModeDialog() {
      this.discountModeDialog = true;
    },
    applyInvoiceDiscountCode(payload) {
      const app = this;
      const inv = app.invoices[app.activeInv];
      const discountAmount = payload?.discount ?? payload?.discounted_amount;
      if (!payload || discountAmount == null || isNaN(Number(discountAmount))) {
        return;
      }
      if (!inv.items || inv.items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return;
      }
      if (app.percentDiscountStatus) {
        app.percentDiscountStatus = false;
        inv.percentDiscountStatus = false;
      }
      const formatted = Number(discountAmount).toFixed(app.decimal);
      inv.discount = formatted;
      inv.discountCode = payload.promo_code ? String(payload.promo_code).trim() : "";
      app.checkTotalDiscount();
      app.headerDiscountInputKey += 1;
      app.$nextTick(() => {
        inv.discount = formatted;
        app.snakbarText = app.$t("apply-discount");
        app.snakbarColor = "green";
        app.snakbar = true;
      });
    },
    resolveRepitetiveKeys() {
      if (this.activeInv != 0) {
        this.invoices[this.activeInv].account = this.invoices[this.activeInv - 1].account;
        this.invoices[this.activeInv].entrepot = this.invoices[
          this.activeInv - 1
        ].entrepot;
      } else {
        this.invoices[this.activeInv].account = null;
        this.invoices[this.activeInv].entrepot = null;
      }
    },
    openSearchDialog() {
      if (this.invoices.some((item) => item.edit != undefined && item.edit)) {
        this.openedInvForEdit = this.invoices.find(
          (item) => item.edit != undefined && item.edit
        );
        this.decStatusEditInvDialog = true;
        this.spliceInv = true;
        this.shouldSearchDialogOpen = true;
      } else {
        this.searchInvDialog = true;
      }
    },
    closeEditInv(type) {
      const editIndex = this.invoices.findIndex(
        (item) => item.edit != undefined && item.edit
      );
      const tabBeforeClose = this.activeInv;
      if (editIndex !== -1) {
        this.activeInv = editIndex;
      }
      this.accept(type);
      this.decStatusEditInvDialog = false;
      if (!this.spliceInv) {
        this._focusEditTabOnOpen = true;
        this.show(this.currentId, this.visitType);
      } else {
        this.clearClosedEditContext();
        let restoreIndex = tabBeforeClose;
        if (editIndex !== -1 && tabBeforeClose > editIndex) {
          restoreIndex = tabBeforeClose - 1;
        }
        if (
          editIndex !== -1 &&
          tabBeforeClose !== editIndex &&
          restoreIndex >= 0 &&
          restoreIndex < this.invoices.length
        ) {
          this.activeInv = restoreIndex;
        }
        const openSearch = this.shouldSearchDialogOpen;
        this.shouldSearchDialogOpen = false;
        this.spliceInv = false;
        if (openSearch) {
          this.searchInvDialog = true;
        }
      }
    },
    clearClosedEditContext() {
      this.id = null;
      this.uid = null;
      this.uidLastInv = null;
      this.currentId = 0;
      this.enedInvForEdit = null;
      if (typeof this._showRequestId !== "number" || Number.isNaN(this._showRequestId)) {
        this._showRequestId = 0;
      }
      this._showCancelledThrough = this._showRequestId;
      this._suppressAutoReopenEdit = true;
    },
    addInvoice() {
      let newInvoice = {
        number: null,
        content: null,
        dueDate: null,
        officialNumber: null,
        status: null,
        tag: null,
        currency: this.$store.state.currency,
        currency_amount: 1,
        branch: null,
        type: "sell",
        given: null,
        account: null,
        date: this.setToday(),
        entrepot: null,
        items: [],
        discount: 0,
        discountCode: null,
        //add total dicount bugfix
        totalDiscountType: false,
        headerDiscountPercent: false,
        percentDiscountStatus: false,
        //
        selectedTaxOption: this.taxToggleConfigValue || "active",
        priceType: "fixedPrice",
        taxStatus: this.taxToggleConfigValue || "active",
        totalTax: null,
        totalCount: null,
        totalPayment: null,
        remainInvoice: null,
        sum: 0,
        compositeTableData: null,
        credit_status: false,
        userCredit: 0,
        optionDialogType: null,
        orderInfoDialog: false,
        orderCreated: false,
        guestName: null,
        guestPhone: null,
        selectedHallType: null,
        restaurant: {
          order_type: "in_hall",
          table_id: null,
          guest_count: 0,
          delivery_method: null,
        },
      };
      this.invoices.push({ ...newInvoice });
      let lastInvIndx = this.invoices.length - 1;
      this.activeInv = lastInvIndx;
      this.resolveRepitetiveKeys();
    },
    askPermission(inv, index) {
      if (inv.edit != undefined && inv.edit) {
        this.openedInvForEdit = inv;
        this.decStatusEditInvDialog = true;
        this.spliceInv = true;
      } else {
        this.askPerm = true;
        this.txtPerm = this.$t("are-you-sure-delete-this-case");
        this.detailPerm = this.$t("invoice-number") + " : " + (index + 1);
        this.activeInv = index;
      }
    },
    accept(type) {
      if (this.activeInv != -1) {
        if (this.activeInv == 0 && this.invoices.length == 1) {
          if (type == "submition") {
            this.clearForm();
            return false;
          }
          if (type == "edition") {
            this.invoices.splice(this.activeInv, 1);
          }
        } else {
          this.invoices.splice(this.activeInv, 1);
        }

        const firstInv = this.activeInv == 0;
        const middleInv =
          this.activeInv > 0 && this.activeInv <= this.invoices.length - 1;
        const lastInv = this.activeInv == this.invoices.length;

        if (firstInv && this.invoices.length > 0) {
        }
        if (middleInv) {
        }
        if (lastInv) {
          this.activeInv = this.invoices.length - 1;
        }
      }
    },
    scrollQueue(direction) {
      const factorsQueue = this.$refs.factorsQueue;
      if (direction === "left") {
        factorsQueue.scrollLeft -= 100;
      } else if (direction === "right") {
        factorsQueue.scrollLeft += 100;
      }
    },
    setScaleConfig() {
      if (this.$refs.formScale.validate()) {
        if (this.scaleType.value == 2) {
          localStorage.setItem(
            "scaleConfig",
            JSON.stringify({
              scaleStatus: this.scale,
              scalePort: this.scalePort,
              scaleType: this.scaleType,
              // barcode characters
              fromThisCharecterItemCode: this.fromThisCharecterItemCode,
              untilThisCharecterItemCode: this.untilThisCharecterItemCode,
              fromThisCharecterItemWeight: this.fromThisCharecterItemWeight,
              untilThisCharecterItemWeight: this.untilThisCharecterItemWeight,
            })
          );
          this.configDialog = false;
          this.snakbarText = this.$t("scale setting was set successfuly!");
          this.snakbarColor = "green";
          this.snakbar = true;
        } else {
          this.loading = true;
          const socket = new WebSocket("ws://127.0.0.1:8145/Command");
          socket.onopen = () => {
            const message = {
              Key: 2,
              Data: {
                ComPort: this.scalePort?.value,
                ScaleType: this.scaleType.value,
              },
            };
            socket.send(JSON.stringify(message));
          };
          socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            if (data == 0) {
              // success
              this.loading = false;
              localStorage.setItem(
                "scaleConfig",
                JSON.stringify({
                  scaleStatus: this.scale,
                  scalePort: this.scalePort,
                  scaleType: this.scaleType,
                })
              );

              this.configDialog = false;

              this.snakbarText = this.$t("scale setting was set successfuly!");
              this.snakbarColor = "green";
              this.snakbar = true;
            } else {
              // failed
              this.loading = false;

              this.snakbarText = this.$t("scale setting was not set!");
              this.snakbarColor = "red";
              this.snakbar = true;
            }
          };
        }
      }
    },
    resolveCompositeType() {
      if (
        this.invoiceType == "sell" ||
        this.invoiceType == "presale" ||
        this.invoiceType == "returnPurchase"
      ) {
        return "recieve";
      } else {
        return "pay";
      }
    },
    removeInv() {
      var app = this;
      app.performingInv = true;
      app.$axios
        .delete(app.$apipoint + `v2/invoice/${app.lastId}`)
        .then((r) => {
          if (r.data.message) {
            app.accept("submition");

            setTimeout(function () {
              app.getLastInvoiceNumber();
            }, 100);

            app.posErrorDialog = false;
            app.performingInv = false;
            app.posPending = false;
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(function () {
          app.deleteItem = null;
          app.posErrorDialog = false;
          app.performingInv = false;
          app.posPending = false;
        });
    },
    getLastInvoiceNumber() {
      var app = this;
      app.$axios
        .get(app.$endpoint + "getdetail", {
          params: {
            type: app.invoices[app.activeInv].type,
            select: "getInvoiceNumber",
          },
        })
        .then((r) => {
          if (r.data) {
            // app.invoices[app.activeInv].number = r.data.number
            app.performingInv = false;
            app.posErrorDialog = false;
            app.posPending = false;
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    editInv() {
      this.performingInv = true;
      this.id = this.uidLastInv;
      this._suppressAutoReopenEdit = false;
      this._openEditFromSearch = true;
      this._focusEditTabOnOpen = true;
      this.show(null, null, this.uidLastInv);
    },
    submitRecieve() {
      var app = this;
      app.$axios
        .post(app.$endpoint + "payments", {
          account: app.invoices[app.activeInv].account,
          amount: app.returnPosInfo.amount,
          date: app.invoices[app.activeInv].date,
          bank: app.selectedBank,
          type: app.resolveCompositeType(), // recieve or pay
          branch: app.invoices[app.activeInv].branch,
          currency: app.invoices[app.activeInv].currency,
          currency_amount: app.invoices[app.activeInv].currency_amount,
          relations: [
            {
              id: app.lastId,
              number: app.invoices[app.activeInv].number,
              doc_type: app.invoices[app.activeInv].type, // sell , purchase , ...
            },
          ],
        })
        .then((r) => {
          if (r.data.message) {
            app.print("create");
          }
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.isLoading = false;
        });
    },
    selectRowHandler(selectedRow) {
      const invoiceUid = selectedRow?.uid || selectedRow?.id;
      if (!invoiceUid) {
        return;
      }
      this._suppressAutoReopenEdit = false;
      this._openEditFromSearch = true;
      this.id = invoiceUid;
      this.show(null, null, invoiceUid);
      this.searchInvDialog = false;
    },
    submitPreview() {
      this.create(null);
      this.printPreviewDialog = true;
    },
    errorIndexesHandler(i) {
      const idx = this.errorIndexes?.indexOf(i);
      if (idx !== -1) {
        this.errorIndexes?.splice(idx, 1);
      }
    },
    fetchUserCredit() {
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(app.$apipoint + "config/customer-club/dobare/current-credit", {
          user_id: app.idUser,
        })
        .then((r) => {
          app.invoices[app.activeInv].userCredit = r.data.data.customer_club_credit;
          app.isLoading = false;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    getPosInfo() {
      const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
      if (posDeviceArray != undefined && posDeviceArray.length > 0) {
        const activePos = posDeviceArray.find((obj) => obj.status == "active");
        if (
          activePos != undefined &&
          activePos.posIp != null &&
          activePos.posPort != null
        ) {
          const socket = new WebSocket("ws://127.0.0.1:8145/Query");
          socket.onopen = () => {
            socket.send(JSON.stringify({ Key: "POS" }));
          };
          socket.onmessage = (event) => {
            const data = JSON.parse(event.data);
            this.POSIP = data.Result.posIp;
            this.POSPORT = data.Result.posPort;
          };
        }
      }
    },
    getSocketVersion() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "DRIVER_VERSION" }));
      };
    },
    totalAmount(value) {
      this.invoices[this.activeInv].totalPayment = value;
    },
    selectFeeCalculatorOption(item) {
      this.feeCalculatorEnabled = item.value === "active";
    },
    selectTaxOption(item) {
      const inv = this.invoices[this.activeInv];
      inv.selectedTaxOption = item.value;
      if (item.value == "active") {
        inv.taxStatus = "active";
        this.calcSum();
      } else {
        inv.taxStatus = "deactive";
        this.calcSum();
      }
      if (!this.$route.params.id && !(inv && inv.edit)) {
        this.setTaxToggleConfig(item.value);
      }
    },
    getTaxToggleConfig() {
      if (this.$route.params.id) return;
      var app = this;
      app.$axios
        .get(app.$endpoint + "panel-ui", {
          params: { key: "selectedTaxOption" },
        })
        .then((res) => {
          const data = res?.data?.data || res?.data || {};
          const value = data?.value;

          if (value === "deactive") {
            app.taxToggleConfigValue = "deactive";
          } else {
            app.taxToggleConfigValue = "active";
          }

          const inv = app.invoices[app.activeInv];
          if (!inv || inv.edit) return;

          inv.taxStatus = app.taxToggleConfigValue;
          inv.selectedTaxOption = app.taxToggleConfigValue;
        })
        .catch(() => {
          app.taxToggleConfigValue = "active";
          const inv = app.invoices[app.activeInv];
          if (!inv || inv.edit) return;
          inv.taxStatus = "active";
          inv.selectedTaxOption = "active";
        });
    },
    setTaxToggleConfig(val) {
      this.taxToggleConfigValue = val;
      this.$axios.post(this.$endpoint + "panel-ui", {
        key: "selectedTaxOption",
        value: val,
      });
    },
    getPosesListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");
      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "POSES" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        this.posesList = data.Result;
      };
    },
    openPosDialog(type, selectedItem) {
      this.addNewPosDialog = true;
      this.getPosesListBySocket();
      if (type == "add") {
        this.dialogType = "add";
        /* if (this.posItems.length > 0) { */
        this.clearPosForm();
        /* }  */
      }
      if (type == "edit" && selectedItem != null) {
        this.dialogType = "edit";
        this.newPos = {
          title: selectedItem.title,
          posDevice: selectedItem.posDevice,
          posIp: selectedItem.posIp,
          posPort: selectedItem.posPort,
          bank: selectedItem.bank,
          status: selectedItem.status,
        };
        this.selectedIndex = this.posItems.findIndex(
          (item) =>
            item.title == selectedItem.title &&
            item.posIp == selectedItem.posIp &&
            item.posPort == selectedItem.posPort
        );
      }
    },
    checkValidation() {
      if (this.$refs.posForm.validate() && this.dialogType == "add") {
        this.addPosRecord();
      }
      if (this.$refs.posForm.validate() && this.dialogType == "edit") {
        this.editPosRecord();
      }
    },
    addPosRecord() {
      this.posItems.push(this.newPos);
      this.posItems.forEach((item, index) => {
        item.status = index === 0 ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    editPosRecord() {
      this.posItems.splice(this.selectedIndex, 1, this.newPos);
      this.addNewPosDialog = false;
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    clearPosForm() {
      this.newPos = {
        title: null,
        posDevice: null,
        posIp: null,
        posPort: null,
        bank: null,
        status: null,
      };
      // reset form
      if (this.$refs.posForm) {
        this.$refs.posForm.reset();
      }
    },
    setActiveStatus(selectedIndex) {
      this.posItems.forEach((item, index) => {
        item.status = index === selectedIndex ? "active" : "deactive";
      });
      this.isPosActive = this.posItems[0].status === "active";
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
    },
    openDeletePermissionDialog(type, item, index) {
      this.deletePermissionDialog = true;
      if (type == "all") {
        this.isAllItemsDelete = true;
      }
      if (type == "single") {
        this.deletedIndex = index;
      }
    },
    removePosRecord() {
      if (this.isAllItemsDelete) {
        this.posItems = [];
      } else {
        this.posItems.splice(this.deletedIndex, 1);
      }
      localStorage.setItem("posDevice", JSON.stringify(this.posItems));
      this.deletePermissionDialog = false;
    },
    openOptionsDialog(value) {
      this.closeChildCalculator();
      this.invoices[this.activeInv].optionDialogType = value;
    },
    onTableUpdate(value) {
      this.invoices[this.activeInv].compositeTableData = value;
    },
    getPrinterListBySocket() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Query");

      socket.onopen = () => {
        socket.send(JSON.stringify({ Key: "PRINTERQUERY" }));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        this.printerList = data.Result;

        // socket.close()
      };
    },
    goToInvoice(type) {
      this.visitType = type;
      this.spliceInv = false;
      if (this.invoices.some((item) => item.edit != undefined && item.edit)) {
        this.openedInvForEdit = this.invoices.find(
          (item) => item.edit != undefined && item.edit
        );
        this.decStatusEditInvDialog = true;
      } else {
        this.askPermissionDialog = true;
        this.errorIndexes = null;
      }
    },
    prevInvoice() {
      this.askPermissionDialog = false;
      const invoiceRef = this.id || this.uidLastInv || this.lastId;
      if (!invoiceRef) return;
      this.show(this.currentId || this.lastId, "prev", invoiceRef);
    },
    nextInvoice() {
      this.askPermissionDialog = false;
      const invoiceRef = this.id || this.uidLastInv || this.lastId;
      if (!invoiceRef) return;
      this.show(this.currentId || this.lastId, "next", invoiceRef);
    },
    // prevInvoice() {
    //   this.askPermissionDialog = false;
    //   this.show(this.currentId, "prev");
    // },
    // nextInvoice() {
    //   this.askPermissionDialog = false;
    //   this.show(this.currentId, "next");
    // },
    otherProduct() {
      var app = this;
      var name = (app.$t("otherProduct") + " " + app.otherProductCounter).toString();
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active") {
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + app.$store.state.userId);
        connection
          .select({
            from: "products",
            where: {
              name: name,
            },
          })
          .then(function (data) {
            if (data && data.length > 0) {
              data[0].price = 0;
              app.append(data[0], "openEdit");
              app.otherProductCounter++;
            } else {
              app.$axios
                .get(app.$endpoint + "getdetail", {
                  params: {
                    select: "getOtherProduct",
                    name: name,
                  },
                })
                .then((res) => {
                  res = res.data;
                  res.price = 0;
                  app.append(res, "openEdit");
                  connection.insert({ into: "products", upsert: true, values: [res] });
                  app.otherProductCounter++;
                })
                .catch((err) => {
                  app.serverErrorHandeler(err);
                })
                .finally(
                  () =>
                    function () {
                      app.isLoading = false;
                      app.loading = false;
                    }
                );
            }
          });
      }
    },
    setRefBody(val) {
      this.itemsTableBodyHeight = val;
    },
    openNumpad(item) {
      this.selectedItemNumpad = item;
      this.numpadValue = item.count;
      this.numpadDialog = true;
    },
    setNumpad(data) {
      this.numpadDialog = false;
      this.selectedItemNumpad.count = data;
    },
    addProductFromDialog(data) {
      this.append(data);
      var isDB = localStorage.getItem("dbCreated");
      if (isDB) {
        this.DBCreate();
      }
      if (isDB && isDB === "active") {
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + this.$store.state.userId);
        connection.insert({ into: "products", upsert: true, values: [data] });
      }
      // this.getAllProductsOffline('product')
    },
    downloadTools() {
      window.open("https://abriron.com/abrironapp/abriron-tools-windows.rar", "_blank");
      this.helpDialog = false;
    },
    clearAllItems() {
      if (this.askPermissionDialog) {
        this.askPermissionDialog = false;
      }
      this.invoices[this.activeInv].items = [];
      this.calcSum();
      this.total = 0;
      this.invoices[this.activeInv].totalTax = 0;
      this.invoices[this.activeInv].discount = 0;
      this.invoices[this.activeInv].totalCount = 0;
      this.invoices[this.activeInv].totalPayment = 0;
    },
    searchIntegrator() {
      var isDB = localStorage.getItem("dbCreated");
      if (isDB && isDB === "active") {
        var app = this;
        var connection = new window.JsStore.Connection();
        connection.openDb("db_" + app.$store.state.userId);
        connection
          .select({
            from: "products",
            join: {
              with: "productIntegrator",
              on: "products.id=productIntegrator.product_id",
              type: "inner",
              where: {
                value: {
                  like: "%" + (app.searchBarcode ? app.searchBarcode : "") + "%",
                },
              },
            },
            groupBy: "product_id",
          })
          .then(function (data) {});
      }
    },
    printWithTools() {
      var local = localStorage.getItem("token");
      this.abrName = this.$store.state.abrName;
      var data = {
        userId: JSON.parse(local).init.userId + "000",
        body: this.$data,
      };
      this.$socket.emit("setValue", JSON.stringify(data));
    },
    setFocus() {
      if (this.$refs.productCategoryRef) {
        // this.$refs.productCategoryRef.setSearchFocus()
      }
      // this.$refs.searchRef.focus()
    },
    fullScreenFunc() {
      const elem = document.getElementById("app");

      if (!document.fullscreenElement) {
        elem.requestFullscreen();
        this.fullscreen = true;
      } else {
        document.exitFullscreen();
        this.fullscreen = false;
      }
    },
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    setParsang() {
      this.scaleSocket.send(JSON.stringify({ Cmd: 2 }));
      this.scaleSocket.send(JSON.stringify({ Cmd: 4 }));
      this.scaleSocket.send(JSON.stringify({ Cmd: 1 }));
    },
    async getWeight() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Scale");
      this.scaleSocket = socket;
      let cmd1Sent = false;
      let isStreaming = false;

      socket.onopen = () => {
        socket.send(JSON.stringify({ Cmd: 0 }));
      };

      socket.onmessage = (event) => {
        const data = Number(event.data.toString().trim());

        if (isNaN(data)) return;

        if (data == 0 && !cmd1Sent) {
          socket.send(JSON.stringify({ Cmd: 1 }));
          cmd1Sent = true;
          isStreaming = true;
          return;
        }

        if (isStreaming) {
          this.weight = data;
        }
      };
    },
    addCount(item) {
      item.count++;
      var app = this;
      clearTimeout(app.appendTimer);
      app.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 100);
    },
    minusCount(item) {
      item.count--;
      var app = this;
      clearTimeout(app.appendTimer);
      app.appendTimer = setTimeout(function () {
        app.calcSum();
      }, 100);
    },
    goToReturnSell() {
      // this.$root.$emit('createReturnSell')
      this.$router.push({
        name: "returnSellCasher",
        params: {
          accountProp: this.invoices[this.activeInv].account,
          sellLinkProp: true,
        },
      });
    },
    goToSell() {
      if (!this.$refs.form.validate()) return false;
      var data = {
        total: this.total,
      };
      this.$router.push({ name: "invoiceCasher", params: { returnSellProp: data } });
    },
    setOffline(val) {
      this.offline = val;
    },
    unitCalc(item) {
      if (item.product && item.unit) {
        var i = item.product.units.findIndex((x) => x.unit_id === item.unit.id);
        if (i !== -1 && item.product.units[i].value) {
          return +item.product.units[i].value;
        } else {
          return 1;
        }
      }
    },
    unitItems(item) {
      if (item.product) {
        var units = [item.product.unit];
        if (item.product.units) {
          item.product.units.map(function (value, index) {
            value.unit.value = value.value;
            units.push(value.unit);
          });
        }
        if (!item.unit) {
          item.unit = item.product.unit;
        }
        return units;
      } else {
        return [];
      }
    },
    onResize() {
      var height = 350;
      if (!this.isMobile && window.innerHeight < 750) {
        height = 507;
      }
      if (this.isMobile) {
        height = 440 + (this.returnSellProp ? 70 : 0);
      }
      if (this.isMobile && window.innerHeight < 900 && window.innerHeight > 750) {
        height = 460 + (this.returnSellProp ? 70 : 0);
      }
      if (this.isMobile && window.innerHeight < 750) {
        height = 480 + (this.returnSellProp ? 70 : 0);
      }
      this.tableHeightInvoice = window.outerHeight - height;
      this.$store.commit("SET_TABLEHEIGHTINVOICE", this.tableHeightInvoice);
    },
    beforeMount() {
      this.bottomNavigation = true;
      if (this.accountProp) {
        this.invoices[this.activeInv].account = this.accountProp;
      }
      if (this.$route.params.id != null) {
        this.id = this.$route.params.id;
        this.uid = this.$route.params.id;
        this._suppressAutoReopenEdit = false;
        this._openEditFromSearch = true;
        this._focusEditTabOnOpen = true;
        this.show(null, null, this.$route.params.id);
        this.render = false;
      } else {
        this.defaultCurrency = this.getDefault("defaultCurrency");
        this.invoices[this.activeInv].currency = this.$store.state.currency;
        if (this.offline && !this.callInvoiceByNumber) {
          this.getInvoiceNumberOffline();
        } else {
          this.getInvoiceNumber();
        }
        if (
          this.invoices[this.activeInv].items &&
          this.invoices[this.activeInv].items.length === 0
        ) {
          // this.addRow()
        }
      }
      if (
        this.$store.state.currency &&
        !this.id &&
        !this.invoices[this.activeInv].account
      ) {
        this.invoices[this.activeInv].currency = this.$store.state.currency;
        this.invoices[this.activeInv].currency_amount = this.$store.state.currency.amount;
      }
      if (this.itemsProp) {
        this.invoices[this.activeInv].items = this.itemsProp;
        (this.invoices[this.activeInv].items || []).forEach((item) =>
          this.hydrateItemSerials(item)
        );
      } else {
        if (!this.isMobile && !this.invoices[this.activeInv].account && !this.id) {
          /* this.items = [] */
          // this.addRow()
        }
      }
      var isDB = localStorage.getItem("dbCreated");
      if (!isDB) {
        this.DBCreate();
      }
    },
    checkProductsCount() {
      var app = this;
      if (
        app.invoices[app.activeInv].items &&
        app.invoices[app.activeInv].items.length > 0
      ) {
        app.invoices[app.activeInv].items.map(function (value, index) {
          // value.product = null
          if (app.$refs["refProduct" + index] !== undefined) {
            // app.$refs['refProduct' + index].clear()
          }
        });
      }
    },
    zeroCountCheck(item) {
      if (parseFloat(item.count) === 0) {
        item.count = 1;
        this.checkCount(item);
      }
    },
    discountChangeStatus() {
      this.percentDiscountStatus = !this.percentDiscountStatus;
      this.invoices[this.activeInv].percentDiscountStatus = this.percentDiscountStatus;
      this.invoices[this.activeInv].taxStatus = false;
    },
    discountCheck() {
      this.resolveHeaderDiscountFromPercent();
    },
    clampHeaderDiscountPercent() {
      if (Number(this.discountPercent) > 100) {
        this.discountPercent = 100;
      }
      if (Number(this.discountPercent) < 0) {
        this.discountPercent = 0;
      }
    },
    resolveHeaderDiscountFromPercent() {
      const inv = this.invoices[this.activeInv];
      this.clampHeaderDiscountPercent();
      let baseTotal = 0;
      (inv.items || []).forEach((row) => {
        if (!row || !row.product) {
          return;
        }
        baseTotal += parseFloat(row.fee || 0) * parseFloat(row.count || 0);
      });
      const pct = Number(this.discountPercent) || 0;
      const discount = parseFloat((baseTotal * (pct / 100)).toFixed(this.decimal));
      inv.discount = discount;
      inv.headerDiscountPercent = this.discountPercent;
      inv.percentDiscountStatus = this.percentDiscountStatus;
    },
    onHeaderDiscountPercentInput() {
      this.resolveHeaderDiscountFromPercent();
    },
    onHeaderDiscountPercentBlur() {
      this.resolveHeaderDiscountFromPercent();
      this.onHeaderDiscountBlur();
    },
    checkBankRemain(sum) {
      var app = this;
      app.validBank = true;
      if (
        app.invoices[app.activeInv].type === "purchase" ||
        app.invoices[app.activeInv].type === "returnSell"
      ) {
        if (
          app.clearingStatus &&
          app.bank &&
          sum > parseFloat(app.bank.remain.currency_remain)
        ) {
          app.validBank = true;
          app.snakbarText = app.$t("alert-pay-amount-bigger-than-bank-remain");
          app.snakbarColor = "pink";
          app.snakbar = true;
        }
      }
    },
    getInvoiceNumber() {
      if (
        this.invoices[this.activeInv].type === "returnPurchase" ||
        this.invoices[this.activeInv].type === "purchase"
      ) {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(app.invoiceNumberTimer);
      const invoiceNumberReq = ++app._invoiceNumberRequestId;
      app.invoiceNumberTimer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.invoices[app.activeInv].type,
              // id: app.id,
              id: app.invoices[app.activeInv].edit ? app.id : null,
              number: app.invoices[app.activeInv].number,
              callInvoice: app.callInvoiceByNumber,
              select: "getInvoiceNumber",
            },
          })
          .then((res) => {
            if (invoiceNumberReq !== app._invoiceNumberRequestId) {
              return;
            }
            res = res.data;
            if (res.status === "error") {
              if (app.checkNumber && !app.callInvoiceByNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              // app.invoices[app.activeInv].number = res.number
              if (app.callInvoiceByNumber && res.invoice) {
                if (app._suppressAutoReopenEdit) {
                  const userEnteredNumber = !!app.invoices[app.activeInv].number;
                  if (!userEnteredNumber) {
                    return;
                  }
                }
                app._suppressAutoReopenEdit = false;
                app._focusEditTabOnOpen = true;
                app.id = res.invoice.uid;
                app.show(null, null, res.invoice.uid);
                // app.$router.push({ name: 'invoiceCasherEdit', params: { id: res.invoice.uid, tabName: res.invoice.number } })
              } else {
                // app.invoices[app.activeInv].number = res.number
              }
            }
            // app.invoices[app.activeInv].number = res.number
            app.checkNumber = true;
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.loading = false;
            app.isLoading = false;
          });
      }, 50);
    },
    callInvoiceById(e) {
      if (!this.numberForEdit) {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      app.clearForm();
      clearTimeout(app.timer);
      app.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              number: app.numberForEdit,
              select: "getInvoiceUidById",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.uid) {
              app._suppressAutoReopenEdit = false;
              app._openEditFromSearch = true;
              app._focusEditTabOnOpen = true;
              app.id = res.uid;
              app.show(null, null, res.uid);
            }
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(function () {
            app.loading = false;
            app.isLoading = false;
          });
      }, 50);
    },
    getOfficialInvoiceNumber() {
      if (
        this.invoices[this.activeInv].type === "returnPurchase" ||
        this.invoices[this.activeInv].type === "purchase"
      ) {
        return false;
      }
      this.loading = true;
      var app = this;
      app.isLoading = true;
      clearTimeout(app.timer);
      app.timer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              type: app.invoices[app.activeInv].type,
              id: app.id,
              number: app.invoices[app.activeInv].officialNumber,
              select: "getOfficialInvoiceNumber",
            },
          })
          .then((res) => {
            res = res.data;
            if (res.status === "error") {
              if (app.checkOfficialNumber) {
                app.snakbarText = res.message;
                app.snakbarColor = "pink";
                app.snakbar = true;
              }
              // app.invoices[app.activeInv].officialNumber = res.number
            }
            app.checkOfficialNumber = true;
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 50);
      // setTimeout(() => {
      //   app.$refs.autocomplete.onScroll()
      // }, 1500)
      app.loading = false;
    },
    changeProduct(item) {
      this.syncRowSerialFlag(item);
      if (
        this.invoices[this.activeInv].type === "sell" ||
        this.invoices[this.activeInv].type === "returnPurchase" ||
        this.invoices[this.activeInv].type === "presale"
      ) {
        if (!this.shouldApplyPricing()) {
          if (!this.isInvoiceEdit()) {
            this.applyFixedRowFee(item);
          }
          return;
        }
        if (item.product && item.product.pricing && item.product.pricing.length > 0) {
          this.applyRowFee(item);
        } else if (
          this.invoices[this.activeInv].currency &&
          item.product &&
          item.product.price &&
          this.invoices[this.activeInv].currency.id === this.$store.state.currency.id
        ) {
          item.fee = item.product.price;
        } else {
          if (!this.id && !this.itemsProp) {
            // item.fee = 0
          }
        }
      }
    },
    clearRow(item) {
      item.fee = 0;
      item.count = 0;
      item.discount = 0;
      item.discountPercent = 0;
      item.tax = 0;
      this.$set(item, "has_serial", "deactive");
      item.serials = [];
      item._serialProductId = null;
    },
    clearRows() {
      this.invoices[this.activeInv].items.map(function (value, index) {
        value.fee = 0;
        value.count = 0;
        value.discount = 0;
        value.discountPercent = 0;
        value.tax = 0;
      });
    },
    changePercent(val) {
      this.discountPercent = val;
      this.percentDiscountStatus = true;
      this.invoices[this.activeInv].headerDiscountPercent = val;
      this.invoices[this.activeInv].percentDiscountStatus = true;
    },
    findMatchedPricingRule(product, count, branch, currency, categoryId, ruleType) {
      const pricing = product?.pricing;
      if (!pricing || pricing.length === 0) {
        return null;
      }
      const branchId = branch?.id ?? null;
      const currencyId = currency?.id ?? null;
      const accountCategoryId = categoryId ?? null;
      const qty = parseFloat(count || 0);
      const findRule = (targetCategoryId) =>
        pricing.find((rule) => {
          if (rule.type !== ruleType) {
            return false;
          }
          const ruleCategoryId = rule.category_id ?? rule.category?.id ?? null;
          if (ruleCategoryId !== targetCategoryId) {
            return false;
          }
          const ruleBranchId = rule.branch_id ?? rule.branch?.id ?? null;
          if (ruleBranchId != null && ruleBranchId !== branchId) {
            return false;
          }
          const ruleCurrencyId = rule.currency_id ?? rule.currency?.id ?? null;
          if (
            ruleCurrencyId != null &&
            currencyId != null &&
            ruleCurrencyId !== currencyId
          ) {
            return false;
          }
          const min =
            rule.min != null && rule.min !== "" ? parseFloat(rule.min) : -Infinity;
          const max =
            rule.max != null && rule.max !== "" ? parseFloat(rule.max) : Infinity;
          return qty >= min && qty <= max;
        }) || null;

      return accountCategoryId != null
        ? findRule(accountCategoryId) || findRule(null)
        : findRule(null);
    },
    applyPricingToRow(item, branch, currency, account, totalDiscountType = false) {
      if (!item?.product) {
        return;
      }
      const product = item.product;
      const categoryId = account?.category_id ?? null;
      const baseFee = parseFloat(product.price || 0);
      const count = parseFloat(item.count || 0);
      item.fee = baseFee;
      const baseRowMax = baseFee * count;
      const productDisc = parseFloat(product.discount || 0);
      const productDiscPct = parseFloat(product.discount_percent || 0);
      if (!totalDiscountType && productDisc > 0) {
        item.discount = Math.min(baseRowMax || productDisc, productDisc);
        item.discountPercent =
          baseRowMax > 0
            ? parseFloat(((item.discount / baseRowMax) * 100).toFixed(this.decimal))
            : 0;
      } else if (productDiscPct > 0 && !totalDiscountType) {
        item.discountPercent = productDiscPct;
        item.discount = parseFloat(
          (baseRowMax * (productDiscPct / 100)).toFixed(this.decimal)
        );
      } else {
        item.discount = 0;
        item.discountPercent = 0;
      }
      const priceRule = this.findMatchedPricingRule(
        product,
        item.count,
        branch,
        currency,
        categoryId,
        "price"
      );
      const discountRule = !totalDiscountType
        ? this.findMatchedPricingRule(
            product,
            item.count,
            branch,
            currency,
            categoryId,
            "discount"
          )
        : null;
      if (priceRule && priceRule.price != null) {
        item.fee = parseFloat(priceRule.price);
      }
      if (discountRule) {
        const rulePrice = parseFloat(discountRule.price || 0);
        const hasPercent = discountRule.percent != null && discountRule.percent !== "";
        const currentRowMax = parseFloat(item.fee || 0) * count;
        if (hasPercent && rulePrice === 0) {
          const pct = parseFloat(discountRule.percent);
          item.discountPercent = pct;
          item.discount = parseFloat((currentRowMax * (pct / 100)).toFixed(this.decimal));
        } else if (
          (discountRule.percent == null || discountRule.percent === "") &&
          rulePrice > 0
        ) {
          item.discount = Math.min(currentRowMax, rulePrice);
          item.discountPercent =
            currentRowMax > 0
              ? parseFloat(((item.discount / currentRowMax) * 100).toFixed(this.decimal))
              : 0;
        }
      }
    },
    shouldApplyPricing(invIndex = null) {
      const targetInv = invIndex != null ? invIndex : this.activeInv;
      const inv = this.invoices[targetInv];
      return inv?.priceType === "formulaPrice";
    },
    isInvoiceEdit(invIndex = null) {
      const targetInv = invIndex != null ? invIndex : this.activeInv;
      const inv = this.invoices[targetInv];
      return !!(this.id || inv?.edit);
    },
    applyFixedRowFee(item) {
      if (item?.product?.price != null && item.product.price !== "") {
        item.fee = parseFloat(item.product.price);
      }
    },
    onPriceTypeChange(invIndex) {
      this.applyAllRowsFee(invIndex);
    },
    applyRowFee(item, invIndex = null) {
      const targetInv = invIndex != null ? invIndex : this.activeInv;
      const inv = this.invoices[targetInv];
      if (!item || !item.product) {
        return;
      }
      if (!this.shouldApplyPricing(targetInv)) {
        if (!this.isInvoiceEdit(targetInv)) {
          this.applyFixedRowFee(item);
        }
        return;
      }
      if (
        inv.type === "sell" ||
        inv.type === "presale" ||
        inv.type === "returnPurchase"
      ) {
        if (item.product.pricing && item.product.pricing.length > 0) {
          this.applyPricingToRow(
            item,
            inv.branch,
            inv.currency,
            inv.account,
            inv.totalDiscountType
          );
        } else if (!item.product.price) {
          this.getPrice(item);
        }
      }
    },
    applyAllRowsFee(invIndex = null) {
      const targetInv = invIndex != null ? invIndex : this.activeInv;
      const items = this.invoices[targetInv]?.items || [];
      if (this.shouldApplyPricing(targetInv)) {
        items.forEach((item) => {
          this.applyRowFee(item, targetInv);
        });
      } else if (!this.isInvoiceEdit(targetInv)) {
        items.forEach((item) => {
          this.applyFixedRowFee(item);
        });
      }
      this.calcSum();
    },
    onAccountInput(index) {
      //this comment for ticket 7621
      // this.applyAllRowsFee(index);
      if (this.shouldApplyPricing(index)) {
        this.applyAllRowsFee(index);
      }
      this.$nextTick(() => {
        const refs = this.$refs.refAccount;
        const comp = Array.isArray(refs) ? refs[index] : refs;
        if (!comp) return;
        clearTimeout(comp.searchTimeout);
        // comp.search = null;
        const ac = comp.$refs && comp.$refs.autocomplete;
        if (ac) {
          ac.isMenuActive = false;
          if (ac.blur) ac.blur();
        }
      });
    },
    getPrice(item) {
      if (!this.shouldApplyPricing()) {
        return;
      }
      var app = this;
      clearTimeout(app.priceTimer);
      if (!app.showProductList) {
        app.isLoading = true;
      }
      app.priceTimer = setTimeout(function () {
        app.$axios
          .get(app.$endpoint + "getdetail", {
            params: {
              select: "getPrice",
              currency_id: app.invoices[app.activeInv].currency?.id,
              count: item.count,
              product_id: item.product.id,
              category_id:
                app.invoices[app.activeInv].account && app.category_id
                  ? app.invoices[app.activeInv].account.category_id
                  : -1,
            },
          })
          .then((res) => {
            res = res.data;
            if (res.price > 0) {
              item.fee = res.price;
            } else {
              item.fee = 0;
            }
            // if (item.fee > 0 && item.count > 0) {
            //   if (res.discount.amount) {
            //     item.discount = res.discount.amount;
            //   }
            //   if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
            //     var discount =
            //       parseFloat(item.fee) *
            //       parseFloat(item.count) *
            //       (parseFloat(res.discount.percent) / 100);
            //     item.discount = discount;
            //   }
            // }
            if (
              item.fee > 0 &&
              item.count > 0 &&
              !app.invoices[app.activeInv].totalDiscountType
            ) {
              if (res.discount.amount) {
                item.discount = res.discount.amount;
              }
              if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                var discount =
                  parseFloat(item.fee) *
                  parseFloat(item.count) *
                  (parseFloat(res.discount.percent) / 100);
                item.discount = discount;
              }
            }
            app.calcSum();
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => (app.isLoading = false));
      }, 500);
      app.loading = false;
    },
    calcSum() {
      var app = this;
      if (!app.invoices || !app.invoices[app.activeInv]) {
        return;
      }
      app.invoices[app.activeInv].totalTax = 0;
      // app.totalDiscount = app.discountEdit ? app.discountEdit : 0;
      if (!app.invoices[app.activeInv].totalDiscountType) {
        app.totalDiscount = app.discountEdit ? app.discountEdit : 0;
      }
      app.invoices[app.activeInv].totalCount = 0;
      app.totalFee = 0;
      app.invoices[app.activeInv].sum = 0;
      var sumDiscount = 0;
      // if (!app.discountPercent) {
      //   app.discount = 0
      // }
      app.invoices[app.activeInv].items.map(function (value, index) {
        // if (value.discountPercent > 0) {
        //   value.discount =
        //     parseFloat(value.fee * value.count) * (value.discountPercent / 100);
        // }
        // if (
        //   parseFloat(value.count) * parseFloat(value.fee) <
        //   parseFloat(value.discount)
        // ) {
        //   value.discount = 0;
        //   app.invoices[app.activeInv].discount = 0;
        //   app.totalDiscount = 0;
        // }
        // if (app.invoices[app.activeInv].totalDiscountType) {
        //   value.discount = 0;
        //   value.tax = 0;
        // } else {
        //   sumDiscount = sumDiscount + parseFloat(value.discount);
        //   app.calcTax(value);
        // }
        if (app.invoices[app.activeInv].totalDiscountType) {
          value.discount = 0;
          value.discountPercent = 0;
          // value.tax = 0;
          app.calcTax(value);
        } else {
          const rowMax = parseFloat(value.fee || 0) * parseFloat(value.count || 0);
          let pct = parseFloat(value.discountPercent) || 0;
          const existingDisc = parseFloat(value.discount) || 0;
          if (app._vaznDistributeJustApplied && rowMax > 0) {
            let disc = Math.min(rowMax, existingDisc);
            value.discount = disc;
            value.discountPercent = rowMax > 0 ? parseFloat((disc / rowMax) * 100) : 0;
            sumDiscount = sumDiscount + disc;
          } else if (existingDisc > 0 && rowMax > 0) {
            let disc = Math.min(rowMax, existingDisc);
            value.discount = disc;
            value.discountPercent = rowMax > 0 ? parseFloat((disc / rowMax) * 100) : 0;
            if (rowMax > 0 && disc > rowMax) {
              value.discount = rowMax;
              value.discountPercent = 100;
            }
            sumDiscount = sumDiscount + parseFloat(value.discount);
          } else if (pct > 0) {
            pct = Math.min(100, Math.max(0, pct));
            value.discountPercent = pct;
            value.discount = parseFloat((rowMax * (pct / 100)).toFixed(app.decimal));
            if (rowMax > 0 && parseFloat(value.discount) > rowMax) {
              value.discount = rowMax;
              value.discountPercent = 100;
            }
            sumDiscount = sumDiscount + parseFloat(value.discount);
          }
          app.calcTax(value);
        }
        app.totalFee =
          parseFloat(value.count) * parseFloat(value.fee) + parseFloat(app.totalFee);
        app.invoices[app.activeInv].totalCount =
          parseFloat(value.count) + parseFloat(app.invoices[app.activeInv].totalCount);
        app.invoices[app.activeInv].totalTax =
          parseFloat(value.tax) + parseFloat(app.invoices[app.activeInv].totalTax);
        var rowPrice =
          parseFloat(value.fee * value.count) -
          parseFloat(value.discount === "" || !value.discount ? 0 : value.discount) +
          parseFloat(isNaN(value.tax) ? 0 : value.tax);
        app.invoices[app.activeInv].sum =
          parseFloat(rowPrice) + parseFloat(app.invoices[app.activeInv].sum);
      });
      app.totalFee = app.totalFee.toFixed(app.decimal);
      app.invoices[app.activeInv].totalTax = app.invoices[app.activeInv].totalTax.toFixed(
        app.decimal
      );
      // if (sumDiscount > 0) {
      //   app.invoices[app.activeInv].discount = sumDiscount;
      // }
      if (!app.invoices[app.activeInv].totalDiscountType) {
        app.invoices[app.activeInv].discount = sumDiscount;
        app.totalDiscount = sumDiscount;
      }
      if (app.invoices[app.activeInv].totalDiscountType) {
        app.totalDiscount = parseFloat(
          app.invoices[app.activeInv].discount !== "" &&
            app.invoices[app.activeInv].discount != null
            ? app.invoices[app.activeInv].discount
            : 0
        );
      }
      app.discountEdit = 0;
    },
    captureHeaderDiscountSnapshot(inv) {
      this.snapshotHeaderDiscount = inv.discount;
      this.snapshotHeaderDiscountPercent = this.discountPercent;
    },
    resolveHeaderDiscountSnapshot(inv) {
      if (
        this.snapshotHeaderDiscount !== null &&
        this.snapshotHeaderDiscount !== undefined
      ) {
        return this.snapshotHeaderDiscount;
      }
      if (!inv.totalDiscountType) {
        let sum = 0;
        inv.items.forEach((row) => {
          sum += parseFloat(row.discount) || 0;
        });
        return sum;
      }
      return inv.discount;
    },
    restoreHeaderDiscountToSnapshot() {
      const inv = this.invoices[this.activeInv];
      const restored = this.resolveHeaderDiscountSnapshot(inv);
      if (restored === null || restored === undefined) {
        return;
      }
      this.snapshotHeaderDiscount = restored;
      inv.discount = restored;
      if (
        this.snapshotHeaderDiscountPercent !== null &&
        this.snapshotHeaderDiscountPercent !== undefined
      ) {
        this.discountPercent = this.snapshotHeaderDiscountPercent;
        inv.headerDiscountPercent = this.discountPercent;
      }
      if (!inv.totalDiscountType) {
        this.totalDiscount = restored;
      }
      this.headerDiscountInputKey += 1;
      this.$nextTick(() => {
        inv.discount = restored;
        if (!inv.totalDiscountType) {
          this.totalDiscount = restored;
        }
        this.calcSum();
      });
    },
    onHeaderDiscountFocus() {
      const inv = this.invoices[this.activeInv];
      this.captureHeaderDiscountSnapshot(inv);
    },
    onHeaderDiscountInput(value) {
      const inv = this.invoices[this.activeInv];
      inv.discount = value;
    },
    onHeaderDiscountBlur() {
      if (this.discountModeDialog) {
        return;
      }
      const inv = this.invoices[this.activeInv];
      const current = this.parseHeaderDiscountAmount(inv.discount);
      const previous = this.parseHeaderDiscountAmount(
        this.resolveHeaderDiscountSnapshot(inv)
      );
      if (current === previous) {
        return;
      }
      this.snapshotHeaderDiscount = this.resolveHeaderDiscountSnapshot(inv);
      this.pendingHeaderDiscount = current;
      this._headerDiscountModeSubmitted = false;
      this.discountModeDialog = true;
    },
    parseHeaderDiscountAmount(value) {
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      return parseFloat(String(value).replace(/,/g, "")) || 0;
    },
    distributeHeaderDiscountByRowWeight(totalDiscount) {
      this.applyHeaderDiscountByRowWeight(totalDiscount, false);
    },
    appendHeaderDiscountByRowWeight(totalDiscount) {
      this.applyHeaderDiscountByRowWeight(totalDiscount, true);
    },
    applyHeaderDiscountByRowWeight(totalDiscount, addToExisting) {
      const inv = this.invoices[this.activeInv];
      const decimal = this.decimal;
      const rows = inv.items.filter((row) => row && row.product);
      let baseTotal = 0;
      rows.forEach((row) => {
        baseTotal += parseFloat(row.fee || 0) * parseFloat(row.count || 0);
      });
      if (baseTotal <= 0) {
        return;
      }
      const total = this.parseHeaderDiscountAmount(totalDiscount);
      if (total <= 0) {
        return;
      }
      let assigned = 0;
      rows.forEach((row, index) => {
        const rowBase = parseFloat(row.fee || 0) * parseFloat(row.count || 0);
        if (rowBase <= 0) {
          return;
        }
        let share;
        if (index === rows.length - 1) {
          share = parseFloat((total - assigned).toFixed(decimal));
        } else {
          share = parseFloat((total * (rowBase / baseTotal)).toFixed(decimal));
          assigned += share;
        }
        const existing = addToExisting ? parseFloat(row.discount) || 0 : 0;
        let disc = existing + share;
        disc = Math.min(rowBase, Math.max(0, disc));
        const pct = rowBase > 0 ? parseFloat(((disc / rowBase) * 100).toFixed(2)) : 0;
        this.$set(row, "discount", disc);
        this.$set(row, "discountPercent", pct);
      });
      let sumRows = 0;
      rows.forEach((row) => {
        sumRows += parseFloat(row.discount) || 0;
      });
      inv.discount = parseFloat(sumRows.toFixed(decimal));
      this.totalDiscount = inv.discount;
    },
    onHeaderDiscountModeSubmit(mode) {
      this._headerDiscountModeSubmitted = true;
      if (this.pendingHeaderDiscount == null) {
        return;
      }
      const inv = this.invoices[this.activeInv];
      const totalDisc = this.parseHeaderDiscountAmount(this.pendingHeaderDiscount);
      inv.discount = totalDisc;
      if (mode === "append") {
        this.appendHeaderDiscountByRowWeight(totalDisc);
      } else {
        this.distributeHeaderDiscountByRowWeight(totalDisc);
      }
      this.totalDiscountType = false;
      inv.totalDiscountType = false;
      this._vaznDistributeJustApplied = true;
      this.calcSum();
      this._vaznDistributeJustApplied = false;
      this.pendingHeaderDiscount = null;
      this.snapshotHeaderDiscount = null;
      this.snapshotHeaderDiscountPercent = null;
    },
    onHeaderDiscountModeCancel() {
      if (this.pendingHeaderDiscount !== null) {
        this.restoreHeaderDiscountToSnapshot();
      }
      this.pendingHeaderDiscount = null;
      this.snapshotHeaderDiscount = null;
      this.snapshotHeaderDiscountPercent = null;
      this._headerDiscountModeSubmitted = false;
    },
    checkTotalDiscount() {
      // this.invoices[this.activeInv].taxStatus = false;
      this.totalDiscountType = true;
      this.invoices[this.activeInv].totalDiscountType = true;
      this.calcSum();

      this.totalDiscount = this.invoices[this.activeInv].discount;

      if (
        this.discountPercent === false &&
        parseFloat(this.invoices[this.activeInv].discount) >
          parseFloat(this.invoices[this.activeInv].sum)
      ) {
        this.invoices[this.activeInv].discount = 0;
        this.totalDiscount = 0;
      }
    },
    calcTax(item) {
      if (this.invoices[this.activeInv].taxStatus === "active") {
        var tax =
          ((parseFloat(item.fee * item.count) -
            parseFloat(item.discount === "" || !item.discount ? 0 : item.discount)) *
            item.tax_percent) /
          100;
        item.tax = tax.toFixed(this.$store.state.currency.decimal);
      } else {
        item.tax = 0;
      }
    },
    changeCurrency() {
      this.bankRemain = 0;
      this.invoices[this.activeInv].currency_amount = this.invoices[
        this.activeInv
      ].currency.amount;
      this.options = {
        locale: "en-US",
        prefix: "",
        suffix: this.invoices[this.activeInv].currency.name,
        precision: 0,
      };
      this.applyAllRowsFee();
    },
    remove(item) {
      var i = this.invoices[this.activeInv].items.indexOf(item);
      this.invoices[this.activeInv].items.splice(i, 1);
      //add total dicount bugfix
      if (this.invoices[this.activeInv].items.length === 0) {
        this.invoices[this.activeInv].discount = 0;
        this.invoices[this.activeInv].totalDiscountType = false;
        this.totalDiscountType = false;
        this.invoices[this.activeInv].headerDiscountPercent = false;
        this.discountPercent = false;
        this.invoices[this.activeInv].percentDiscountStatus = false;
        this.percentDiscountStatus = false;
        this.totalDiscount = 0;
      }
      this.deleteItem = null;
      this.calcSum();
      this.deletDialog = false;
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "ProductEdit", params: { id: item.id } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "products", {
          params: {
            search: app.search,
            page: app.tableOptions.page,
            refId: app.refId,
            type: app.invoices[app.activeInv].type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.tableOptions,
            tag: app.invoices[app.activeInv].tag,
            // typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.invoices[app.activeInv].items = res.data;
          app.totalItems = res.total;
          app.from = res.from;
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    checkProduct(item, key) {
      if (item) {
        var index = this.invoices[this.activeInv].items.findIndex(
          (x) => x.product.id === item.id
        );
        if (index !== key) {
          this.$refs["refProduct" + key].clear();
          this.snakbarText = this.$t("alert-product-is-repetitive");
          this.snakbarColor = "pink";
          this.snakbar = true;
        }
      }
    },
    switchFromManualHeaderDiscountIfRowHasDiscount(item) {
      const inv = this.invoices[this.activeInv];
      if (!inv.totalDiscountType) {
        return false;
      }
      const hasRow =
        (parseFloat(item.discount) || 0) > 0 ||
        (parseFloat(item.discountPercent) || 0) > 0;
      if (!hasRow) {
        return false;
      }
      this.totalDiscountType = false;
      inv.totalDiscountType = false;
      inv.discount = 0;
      this.totalDiscount = 0;
      return true;
    },
    checkDiscount(item) {
      const inv = this.invoices[this.activeInv];
      if (inv.totalDiscountType) {
        if (!this.switchFromManualHeaderDiscountIfRowHasDiscount(item)) {
          item.discount = 0;
          item.discountPercent = 0;
          this.calcSum();
          return;
        }
      }
      if (!inv.totalDiscountType) {
        this.totalDiscountType = false;
        inv.totalDiscountType = false;
        this.totalDiscount = 0;
        inv.discount = 0;
      }
      // if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
      //   item.discount = 0;
      // }
      const rowMax = parseFloat(item.fee || 0) * parseFloat(item.count || 0);
      if (rowMax > 0 && parseFloat(item.discount) > rowMax) {
        item.discount = rowMax;
        item.discountPercent = 100;
      } else {
        item.discountPercent = this.itemDiscountPercentCalc(item);
        if (parseFloat(item.discountPercent) > 100) {
          item.discountPercent = 100;
          item.discount = rowMax;
        }
      }
      this.calcSum();
    },
    checkDiscountPercent(item) {
      const inv = this.invoices[this.activeInv];
      if (inv.totalDiscountType) {
        if (!this.switchFromManualHeaderDiscountIfRowHasDiscount(item)) {
          item.discount = 0;
          item.discountPercent = 0;
          this.calcSum();
          return;
        }
      }
      if (!inv.totalDiscountType) {
        this.totalDiscountType = false;
        inv.totalDiscountType = false;
        this.totalDiscount = 0;
        inv.discount = 0;
      }
      const rowMax = parseFloat(item.fee || 0) * parseFloat(item.count || 0);
      const existingDisc = parseFloat(item.discount) || 0;
      let pct = parseFloat(item.discountPercent) || 0;
      pct = Math.min(100, Math.max(0, pct));
      if (existingDisc > 0 && rowMax > 0) {
        let disc = Math.min(rowMax, existingDisc);
        item.discount = disc;
        item.discountPercent = parseFloat((disc / rowMax) * 100);
        if (item.discountPercent > 100) {
          item.discountPercent = 100;
          item.discount = rowMax;
        }
      } else if (pct > 0 && rowMax > 0) {
        item.discountPercent = pct;
        item.discount = parseFloat((rowMax * (pct / 100)).toFixed(this.decimal));
      } else {
        item.discountPercent = pct;
        item.discount = 0;
      }
      // item.discount = (
      //   parseFloat(item.fee * item.count) *
      //   (item.discountPercent / 100)
      // ).toFixed(this.decimal);
      // if (parseFloat(item.discount) > parseFloat(item.fee * item.count)) {
      //   item.discount = 0;
      //   item.discountPercent = 0;
      // }
      this.calcSum();
    },
    itemDiscountPercentCalc(item) {
      return (parseFloat(item.discount) / parseFloat(item.fee * item.count)) * 100;
    },
    checkCount(item) {
      if (
        !this.offline &&
        (this.invoices[this.activeInv].type === "sell" ||
          this.invoices[this.activeInv].type === "presale" ||
          this.invoices[this.activeInv].type === "returnPurchase")
      ) {
        var productStock =
          item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0;
        if (
          item.product &&
          item.product.type === "product" &&
          this.$store.state.negative_inventory === "no" &&
          parseFloat(item.count) >
            productStock +
              parseFloat(this.$route.name !== "presaleEdit" ? item.countEdit : 0)
        ) {
          this.snakbarText = this.$t("alert-inventory-is-not-enough");
          this.snakbarColor = "pink";
          this.snakbar = true;
          // item.count = 0
        } else {
          if (this.$route.name !== "presaleEdit" && item.product && !item.product.price) {
            if (
              this.invoices[this.activeInv].type === "sell" ||
              this.invoices[this.activeInv].type === "presale"
            ) {
              this.getPrice(item);
            }
          }
        }
      }
      this.calcSum();
    },
    removegroup() {
      var app = this;
      app.selected.map(function (value, key) {
        app.remove(value, key);
      });
    },
    createOffline() {
      if (!this.$refs.form.validate()) return false;
      var app = this;
      var token = JSON.parse(localStorage.getItem("token"));
      var list = JSON.parse(localStorage.getItem("invoice"));
      if (!list) {
        list = [];
      }
      app.ouid =
        token.init.userId + "@" + Date.now() + "@" + app.invoices[app.activeInv].number;
      list.push(app.$data);
      localStorage.setItem("invoice", JSON.stringify(list));
      localStorage.setItem("invoiceNumber", app.invoices[app.activeInv].number);
      if (!app.$store.state.offlineInvoiceTrigger) {
        app.createInvoiceOffline();
      }
      app.$store.commit("SET_OFFLINEINVOICETRIGGER", true);
      if (app.autoPrint && app.redirectUrl) {
        if (
          app.invoices[app.activeInv].type === "sell" ||
          app.invoices[app.activeInv].type === "presale"
        ) {
          if (app.printType === "normal") {
            app.$router.push({
              name: "invoicePrint",
              params: { id: app.ouid, offlineProp: true },
            });
          } else {
            var numberPrintForNewInvoice =
              app.invoices[app.activeInv].type === "sell" &&
              !app.id &&
              app.$store.state &&
              app.$store.state.allConfig &&
              app.$store.state.allConfig.printNumberForNewInvoice === "active"
                ? true
                : null;
            app.$router.push({
              name: "invoiceRollprint",
              params: {
                id: app.ouid,
                backUrl: "invoiceCasher",
                offlineProp: true,
                abrironPrinterProp: app.abrironPrinter,
                numberPrint: numberPrintForNewInvoice,
              },
            });
          }
        } else {
          app.goTo(app.invoices[app.activeInv].type + "List");
        }
      }
      app.invoices[app.activeInv].items = [];
      app.invoices[app.activeInv].account = null;
      if (app.invoices[app.activeInv].type === "sell" && app.returnSellProp) {
        // app.$root.$emit('createReturnSell')
      }
      app.redirectUrl = true;
    },
    createInvoiceHeader(type = null) {
      var app = this;
      var checkVisitor = false;
      if (!app.invoices[app.activeInv].account) {
        app.pattern = 2;
      }
      if (!app.$refs.form.validate()) return false;
      if (
        app.invoices[app.activeInv].type === "sell" &&
        app.$store.state.allConfig &&
        app.$store.state.allConfig.userInt &&
        app.$store.state.allConfig.userInt.visitor === "active"
      ) {
        checkVisitor = true;
      }
      if (app.invoices[app.activeInv].items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (!app.invoices[app.activeInv].account) {
        app.snakbarText = app.$t("noAccount");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (app.offline && !checkVisitor) {
        // app.createOffline()
        // return false
      }
      app.createIdInvoice = "active";
      app.snakbar = false;
      app.isLoading = true;
      app.$axios
        .post(app.$endpoint + "invoice", app.$data)
        .then((res) => {
          res = res.data;
          app.idPrint = res.id;
          app.id = res.id;
          app.uid = res.uid;
          app.redirectUrl = true;
          app.printStatus = type;
          setTimeout(function () {
            if (type === "printId" || type === "print") {
              app.print();
            }
          }, 100);
          app.update();
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.nextPermission = false;
          app.redirectUrl = true;
          app.isLoading = false;
        });
    },
    resolvePrintType(type) {
      if (type == "posProcess") {
        return "print";
      } else {
        return type;
      }
    },
    create(type = null, e) {
      if (e?.preventDefault) e.preventDefault();
      if (this.isLoading) return;
      var app = this;
      var checkVisitor = false;
      if (!app.invoices[app.activeInv].account) {
        app.pattern = 2;
      }
      if (!app.invoices[app.activeInv].account) {
        app.snakbarText = app.$t("alert-select-customer");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      /* if (app.$refs.form.validate()) { */
      /* if (!app.$refs.form.validate()) return false */
      // app.items.map(function (value, index) {
      //   if (!value.product) {
      //     app.remove(value, index)
      //   }
      // })
      if (
        app.invoices[app.activeInv].type === "sell" &&
        app.$store.state.allConfig &&
        app.$store.state.allConfig.userInt &&
        app.$store.state.allConfig.userInt.visitor === "active"
      ) {
        checkVisitor = true;
      }
      if (app.invoices[app.activeInv].items.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }
      if (!app.invoices[app.activeInv].account) {
        app.snakbarText = app.$t("noAccount");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }

      if (!app.invoices[app.activeInv].date) {
        app.snakbarText = app.$t("please enter the date");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return false;
      }

      if (app.invoices[app.activeInv].orderCreated) {
        app.payload = app.invoices[app.activeInv];
      } else {
        const modified = { ...app.invoices[app.activeInv] };
        modified.selectedHallType = null;
        if (modified.restaurant) {
          modified.restaurant.order_type = null;
          modified.restaurant.table_id = null;
          modified.restaurant.guest_count = null;
          modified.restaurant.delivery_method = null;
        }
        app.payload = modified;
      }

      app.snakbar = false;
      app.isLoading = true;
      app.payload.discount = Number(app.payload.discount || 0);
      //add conditon for totalDiscount
      if (app.invoices[app.activeInv].totalDiscountType) {
        app.payload.totalDiscount = app.payload.discount;
        app.payload.totalDiscountType = true;
      } else {
        app.payload.totalDiscount = 0;
        app.payload.totalDiscountType = false;
      }
      let temp = app.payload.userCredit;
      const payload = {
        ...app.payload,
        credit: temp,
        items: app.sanitizeSerialItems(app.payload.items),
      };
      app.$axios
        .post(app.$endpoint + "invoice", payload)
        .then((res) => {
          if (res) {
            res = res?.data;
            app.nextPermission = true;
            if (res.status === "success") {
              app.invoiceSubmited = true;
              app.snakbarText = app.$t("registered");
              app.snakbarColor = "green";
              app.snakbar = true;
              app.errorIndexes = null;

              if (checkVisitor) {
                app.invoices[app.activeInv].account = null;
              }
              app.idPrint = res.data.id;
              app.redirectUrl = true;
              app.lastId = res.data.id;
              app.currentId = res.data.id;
              app.invoices[app.activeInv].number = res.data.number;
              app.uidLastInv = res.data.uid;

              if (type === "printId" || type === "print") {
                app.$nextTick(() => app.print("create"));
              } else {
                setTimeout(function () {
                  if (type != "posProcess") {
                    app.accept("submition");
                  }
                }, 200);
              }
              if (type == "posProcess") {
                app.startPosProsess();
              }
            } else {
              app.snakbarText = app.$t("error");
              app.snakbarColor = "green";
              app.snakbar = true;
              const errors = res.errors;
              if (errors) {
                const indexErrors = [];
                Object.keys(errors).forEach((key) => {
                  indexErrors.push(parseInt(key.split(".")[1]));
                });
                app.errorIndexes = indexErrors;
              }
            }
          }
        })
        .catch((err) => {
          app.isLoading = false;
          if (err && err.response) {
            app.serverErrorHandeler(err);
            // out-of-stock product
            if (
              err.response.data.status == 500 &&
              err.response.data.errorItems &&
              err.response.data.errorItems.length > 0
            ) {
              const outOfStockIndexes = err.response.data.errorItems.map(
                (item) => item.index
              );
              app.errorIndexes = outOfStockIndexes;

              app.snakbarText = app.$t("there is no enough products for app entrepots");
              app.snakbarColor = "pink";
              app.snakbar = true;
            } else {
              // amount (fee)
              const errors = err.response.data.errors;
              if (errors) {
                const indexErrors = [];
                Object.keys(errors).forEach((key) => {
                  indexErrors.push(parseInt(key.split(".")[1]));
                });
                app.errorIndexes = indexErrors;
              }
            }
          }
        })
        .finally(() => {
          app.nextPermission = false;
          app.redirectUrl = true;
          app.isLoading = false;
        });
      /* } else {
          const refs = ['number', 'refAccount', 'date', 'refCurrency']
          const invalidFields = []

          refs.forEach(ref => {
            const field = app.$refs[ref]

            if (!field) {
              return
            }

            const value = field.internalValue ?? field.value ?? field.$el?.value

            // Check if field is empty
            if (!value) {
              invalidFields.push(field.label || field.title || ref)
            }

            // If validate method exists, use it as well
            if (typeof field.validate === 'function' && !field.validate()) {
              const label = field.label || field.title || field.$attrs?.label || ref
              if (!invalidFields.includes(label)) invalidFields.push(label)
            }
          })

          if (invalidFields.length) {
            app.snakbarText = app.$t('pleaseCheckFields') + ': ' + invalidFields.join(', ')
            app.snakbarColor = 'pink'
            app.snakbar = true
          }
        } */
    },
    update(type = null) {
      if (
        this.$store.state.permissions &&
        this.$store.state.permissions.includes("sellEdit")
      ) {
        var app = this;
        let editedInv = app.invoices.find((item) => item.edit != undefined && item.edit);
        app.activeInv = app.invoices.findIndex(
          (item) => item.edit != undefined && item.edit
        );
        if (app.invoices[app.activeInv].items.length === 0) {
          app.snakbarText = app.$t("noItems");
          app.snakbarColor = "pink";
          app.snakbar = true;
          return false;
        }

        if (app.invoices[app.activeInv].orderCreated) {
          app.payload = app.invoices[app.activeInv];
        } else {
          const modified = { ...app.invoices[app.activeInv] };
          modified.selectedHallType = null;
          if (modified.restaurant) {
            modified.restaurant.order_type = null;
            modified.restaurant.table_id = null;
            modified.restaurant.guest_count = null;
            modified.restaurant.delivery_method = null;
          }
          app.payload = modified;
        }

        app.snakbar = false;
        app.isLoading = true;
        editedInv.discount = Number(editedInv.discount || 0);
        //add conditopn for totalDiscount
        if (app.invoices[app.activeInv].totalDiscountType) {
          editedInv.totalDiscount = editedInv.discount;
          editedInv.totalDiscountType = true;
        } else {
          editedInv.totalDiscount = 0;
          editedInv.totalDiscountType = false;
        }
        /* if (type === 'printId' || type === 'print') {
          app.print()
        } */
        const updatePayload = {
          ...editedInv,
          items: app.sanitizeSerialItems(editedInv.items),
        };
        app.$axios
          .put(app.$endpoint + "invoice/" + app.uid, updatePayload)
          .then((res) => {
            app.errorIndexes = null;
            res = res.data;
            app.invoices[app.activeInv].number = res.data.number;

            if (type === "printId" || type === "print") {
              app.$nextTick(() => app.print("update"));
            } else {
              setTimeout(function () {
                if (type != "posProcess") {
                  app.clearableForm();
                }
              }, 200);
            }
            if (type == "posProcess") {
              app.startPosProsess();
            }
            if (type == "visit" && !app.spliceInv) {
              app.show(app.currentId, app.visitType);
            } else if (type == "visit" && app.spliceInv) {
              app.currentId = 0;
              if (app.shouldSearchDialogOpen) {
                app.searchInvDialog = true;
              }
            }
          })
          .catch((err) => {
            app.isLoading = false;
            if (err && err.response) {
              app.serverErrorHandeler(err);
              // out-of-stock product
              if (
                err.response.data.status == 500 &&
                err.response.data.errorItems &&
                err.response.data.errorItems.length > 0
              ) {
                const outOfStockIndexes = err.response.data.errorItems.map(
                  (item) => item.index
                );
                app.errorIndexes = outOfStockIndexes;
              } else {
                // stock
                const errors = err.response.data.errors;
                if (errors) {
                  const indexErrors = [];
                  Object.keys(errors).forEach((key) => {
                    indexErrors.push(parseInt(key.split(".")[1]));
                  });
                  app.errorIndexes = indexErrors;
                }
              }
            }
          })
          .finally(() => {
            app.nextPermission = false;
            app.isLoading = false;
          });
      } else {
        this.snakbarText = this.$t("notAccessToEdit");
        this.snakbarColor = "pink";
        this.snakbar = true;
      }
    },
    show(currentId = null, order = null, editInvoiceId = null) {
      var app = this;
      const invoiceId = editInvoiceId != null ? editInvoiceId : app.id;
      if (!invoiceId) {
        app.loading = false;
        return;
      }
      const fromSearchPending = app._openEditFromSearch;
      const isNavigationPending =
        order === "prev" || order === "next" || order === "visit";
      if (app._suppressAutoReopenEdit && !fromSearchPending && !isNavigationPending) {
        app.loading = false;
        return;
      }
      if (typeof app._showRequestId !== "number" || Number.isNaN(app._showRequestId)) {
        app._showRequestId = 0;
      }
      const myRequestId = ++app._showRequestId;
      const fromSearch = app._openEditFromSearch;
      app._openEditFromSearch = false;
      const focusEditOnComplete = fromSearch || app._focusEditTabOnOpen;
      app._focusEditTabOnOpen = false;
      const requestActiveInv = app.activeInv;
      app.loading = true;
      app.$axios
        .get(app.$endpoint + "invoice/" + invoiceId + "/edit", {
          params: {
            id: invoiceId,
            currentId: currentId,
            order: order,
            type: app.invoices[app.activeInv].type,
          },
        })
        .then((res) => {
          if (myRequestId <= app._showCancelledThrough) {
            return;
          }
          app.$nextTick(() => {
            if (myRequestId <= app._showCancelledThrough) {
              return;
            }
            if (res.data !== "") {
              res = res.data;

              const isNavigationShow =
                order === "prev" || order === "next" || order === "visit";
              const userRequestedEditTab = fromSearch || isNavigationShow;
              if (app._suppressAutoReopenEdit && !isNavigationShow) {
                return;
              }

              app.id = res.id;
              if (!app.lastId) {
                app.lastId = res.id;
              }
              app.currentId = res.id;
              app.uid = res.uid;
              app.uidLastInv = res.uid;
              app.decimal = res.currency ? res.currency.decimal : 0;
              (res.article || []).forEach((item) => app.hydrateItemSerials(item));

              let newInvoice = {
                number: res.number,
                content: res.content,
                dueDate: res.due_date,
                officialNumber: res.official_number,
                status: res.last_status ? res.last_status.status : null,
                currency: res.currency,
                currency_amount: res.currency_amount,
                branch: res.branch ? res.branch : null,
                type: res.type,
                given: res.given,
                account: res.customer,
                date: res.date,
                entrepot: res.entrepot ? res.entrepot.entrepot : null,
                items: res.article,

                restaurant: res.restaurant_invoices,
                selectedHallType:
                  res.restaurant_invoices && res.restaurant_invoices.table
                    ? res.restaurant_invoices.table.hall_id
                    : null,
                orderInfoDialog: false,
                orderCreated:
                  res.restaurant_invoices && res.restaurant_invoices.order_type != null
                    ? true
                    : false,
                guestName: null,
                guestPhone: null,

                discount: res.discount,
                totalTax: null,
                totalCount: null,
                totalPayment: null,
                remainInvoice: null,
                sum: 0,
                compositeTableData: res.compositeTableData,
                credit_status: res.creditStatus,
                userCredit: 0,
                edit: true,
                optionDialogType: null,
                priceType: "fixedPrice",
                id: res.id,
                uid: res.uid,
              };
              const userSwitchedTabDuringLoad = app.activeInv !== requestActiveInv;
              const onNewInvoiceTab =
                app.invoices[app.activeInv] && !app.invoices[app.activeInv].edit;
              let editTabOpen = app.invoices.some(
                (item) => item.edit != undefined && item.edit
              );
              const keepCurrentTab = editTabOpen;
              editTabOpen = !editTabOpen;
              const switchToEditTab = focusEditOnComplete && !userSwitchedTabDuringLoad;
              const shouldSwitchToEdit = switchToEditTab || isNavigationShow;
              const existingEditIndex = app.invoices.findIndex(
                (item) => item.edit && (item.id === res.id || item.number === res.number)
              );
              if (existingEditIndex !== -1) {
                if (keepCurrentTab) {
                  return;
                }
                app.invoices[existingEditIndex] = {
                  ...app.invoices[existingEditIndex],
                  ...newInvoice,
                };
                if (shouldSwitchToEdit) {
                  app.activeInv = existingEditIndex;
                }
              } else if (res.number != app.invoices[app.activeInv].number) {
                if (!userRequestedEditTab) {
                  return;
                }
                const tabRef = keepCurrentTab ? app.invoices[app.activeInv] : null;
                app.invoices.unshift({ ...newInvoice });
                if (keepCurrentTab) {
                  app.activeInv = app.invoices.indexOf(tabRef);
                  return;
                }
                if (shouldSwitchToEdit) {
                  app.activeInv = 0;
                }
              } else {
                app.posErrorDialog = false;
                app.performingInv = false;
                app.posPending = false;
                setTimeout(function () {
                  app.render = true;
                }, 1000);
                app.calcSum();
              }

              app.invoices[app.activeInv].items.map(function (value, index) {
                if (value.discount && value.discount > 0) {
                  app.checkDiscountEdit = true;
                }
              });

              app.payments = res.payments;
              app.credit = res.credit;
              app.prevCredit = res.credit;
              app.checks = res.checks;
              app.plan = res.plan ? res.plan.plan : null;
              app.totalDiscount = res.discount;

              if (!app.checkDiscountEdit) {
                app.discountEdit = res.discount;
              }
              // app.totaltax = res.tax
              if (res.tax > 0) {
                app.invoices[app.activeInv].taxStatus = "active";
                app.invoices[app.activeInv].selectedTaxOption = "active";
                app.taxPercent = res.tax_percent;
              } else {
                app.invoices[app.activeInv].taxStatus = "deactive";
                app.invoices[app.activeInv].selectedTaxOption = "deactive";
                app.taxPercent = res.tax_percent;
              }
              if (res.tags) {
                app.invoices[app.activeInv].tag = res.tags;
                app.more = true;
              }
              app.posErrorDialog = false;
              app.performingInv = false;
              app.posPending = false;
              setTimeout(function () {
                app.render = true;
              }, 1000);
              app.calcSum();
            }
          });
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = String(m.jMonth() + 1).padStart(2, "0");
        const shamsiDay = String(m.jDate()).padStart(2, "0");
        return `${shamsiYear}/${shamsiMonth}/${shamsiDay}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        return m.format("YYYY/MM/DD");
      }
    },
    getInvoiceNumberOffline() {
      if (
        this.invoices[this.activeInv].type === "returnPurchase" ||
        this.invoices[this.activeInv].type === "purchase"
      ) {
        return false;
      }
      var number = JSON.parse(localStorage.getItem("invoiceNumber"));
      if (!number) {
        number = 1;
      } else {
        number = +number + 1;
      }
      // this.invoices[this.activeInv].number = number
    },
    clearableForm() {
      this.invoices[this.activeInv].account = null;
      this.numberForEdit = null;
      this.accept("edition");
      this.decStatusEditInvDialog = false;
      this.clearClosedEditContext();
    },
    clearForm() {
      if (this.askPermissionDialog) {
        this.askPermissionDialog = false;
      }
      this.selected = [];
      this.render = true;
      this.otherProductCounter = 1;
      this.createIdInvoice = null;
      this.paymentByPos = null;
      this.cashAmount = null;
      this.paymentAmount = null;
      this.lodingText = null;
      this.loadingDialog = false;
      this.bodyStatus = false;
      this.printDialog = false;
      this.credit = null;
      this.deletDialog = false;
      this.errorIndexes = null;
      this.showClearing = true;
      this.showSelect = false;
      this.showProductList = false;
      // this.clearingStatus = false
      this.filter = false;
      this.valid = true;
      // this.bank = null
      // this.entrepot = null
      this.payments = null;
      this.uid = null;
      this.checks = null;
      // this.account = null
      // this.date = null
      // this.currency_amount = null
      this.model = null;
      this.from = 1;
      this.taskDialog = null;
      this.id = null;
      this.temp = null;
      this.deleteItem = null;
      this.sellStatus = null;
      this.dialog = null;
      this.timer = 0;
      this.isLoading = false;
      /* this.snakbar = false */
      this.taskId = null;
      /* this.snakbarText = null */
      this.loading = false;
      this.search = null;
      this.discountPercent = false;
      this.totalDiscount = 0;
      this.totalFee = 0;
      this.sumRow = 0;
      this.clearingStatus = false;
      /* this.branch = null */
      this.totalDiscountType = false;
      this.invoices[this.activeInv].totalDiscountType = false;
      this.invoices[this.activeInv].headerDiscountPercent = false;
      this.invoices[this.activeInv].percentDiscountStatus = false;
      this.invoices[this.activeInv].date = this.setToday();
      this.invoices[this.activeInv].number = null;
      this.invoices[this.activeInv].given = null;
      this.invoices[this.activeInv].officialNumber = null;
      this.invoices[this.activeInv].dueDate = null;
      this.invoices[this.activeInv].content = null;
      // this.invoices[this.activeInv].account = null
      // this.invoices[this.activeInv].date = null
      // this.invoices[this.activeInv].entrepot = null
      this.invoices[this.activeInv].status = null;
      this.invoices[this.activeInv].tag = null;
      this.invoices[this.activeInv].items = [];
      this.invoices[this.activeInv].totalCount = 0;
      this.invoices[this.activeInv].discount = 0;
      this.invoices[this.activeInv].totalTax = 0;
      this.invoices[this.activeInv].sum = 0;
      this.invoices[this.activeInv].compositeTableData = [];
      this.invoices[this.activeInv].selectedTaxOption =
        this.taxToggleConfigValue || "active";
      this.invoices[this.activeInv].taxStatus = this.taxToggleConfigValue || "active";
      this.invoices[this.activeInv].credit_status = false;
      this.invoices[this.activeInv].userCredit = null;
      this.closeOrderDialog();
      if (this.offline && !this.callInvoiceByNumber) {
        this.getInvoiceNumberOffline();
      } else {
        this.getInvoiceNumber();
      }
      // if (!this.autoPrint) {
      //   this.invoices[this.activeInv].account = null;
      // }
      // this.invoices[this.activeInv].account = null;
      this.addRow();
      // this.$refs.form.resetValidation();
    },
    openCalculator() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Utility");
      socket.onopen = () => {
        socket.send(JSON.stringify({ cmd: "0" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.IsSuccessful) {
          this.snakbar = true;
          this.snakbarText = this.$t("runing system calculator");
          this.snakbarColor = "green";
        }
        // socket.close()
      };
    },
    openWindowsKeyboard() {
      const socket = new WebSocket("ws://127.0.0.1:8145/Utility");
      socket.onopen = () => {
        socket.send(JSON.stringify({ cmd: "1" }));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.IsSuccessful) {
          this.snakbar = true;
          this.snakbarText = this.$t("runing system keyboard");
          this.snakbarColor = "green";
        }
        // socket.close()
      };
    },
    sendToPosProcess(value) {
      if (value != undefined && value != null && value != "remain") {
        this.compositeAmount = value;
      }
      if (
        this.invoices[this.activeInv].edit != undefined &&
        this.invoices[this.activeInv].edit
      ) {
        this.update("posProcess");
      } else {
        this.create("posProcess");
      }
    },
    startPosProsess() {
      // check added pos device
      const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
      if (
        (posDeviceArray != undefined && posDeviceArray.length == 0) ||
        posDeviceArray == undefined
      ) {
        this.snakbar = true;
        this.snakbarText = this.$t("first in setting below set your pos device.");
        this.snakbarColor = "red";
      }
      // start the process:
      if (posDeviceArray != undefined && posDeviceArray.length > 0) {
        //set PosIp
        this.setPosIp(posDeviceArray);
      }
    },
    setPosIp(value) {
      const selectedPos = value.find((item) => item.status == "active");
      var selectedPosKey;
      if (selectedPos.posDevice.Key == "EghtesadNovin") {
        selectedPosKey = 0;
      }
      if (selectedPos.posDevice.Key == "Saman") {
        selectedPosKey = 1;
      }
      if (selectedPos.posDevice.Key == "BehPardakht") {
        selectedPosKey = 2;
      }
      if (selectedPos.posDevice.Key == "Fanap") {
        selectedPosKey = 3;
      }
      if (selectedPos.posDevice.Key == "Parsian") {
        selectedPosKey = 4;
      }
      const socket = new WebSocket("ws://127.0.0.1:8145/Command");
      socket.onopen = () => {
        const message = {
          Key: 1,
          Data: {
            PosIP: this.POSIP == null ? this.newPos.posIp : this.POSIP,
            PosPort: this.POSPORT == null ? this.newPos.posPort : this.POSPORT,
            PosType: selectedPosKey,
          },
        };
        socket.send(JSON.stringify(message));
      };
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data == 0) {
          // success
          // initialize pos device
          this.sendToPos(selectedPosKey);
        } else {
          // failed
          this.isLoading = false;
          this.posErrorDialog = true;
          this.posErrorTxt = this.$t("POSIP did not set correctly.");
        }
      };
    },
    sendToPos(selectedPosKey) {
      const socket = new WebSocket("ws://127.0.0.1:8145/Pos");
      this.progressPercent = 0;
      this.isPosSuccessfull = false;
      this.posPending = true;
      this.loadingDialog = true;
      this.lodingText = this.$t("waitingTogetDataFromPOS");

      let interval = setInterval(() => {
        if (this.progressPercent < 100) {
          this.progressPercent += 1;
        } else {
          clearInterval(interval);
        }
      }, 300);

      let state = "init"; // or: 'waitingForResponse'

      const timeout = setTimeout(() => {
        if (!this.isPosSuccessfull && state === "waitingForResponse") {
          clearInterval(interval);
          this.loadingDialog = false;
          this.posPending = false;
          this.snakbar = true;
          this.snakbarText = data.ResponseMessage;
          this.snakbarColor = "red";
        }
      }, 35000);

      socket.onopen = () => {
        const message = {
          Cmd: 0,
          PosType: selectedPosKey,
        };
        socket.send(JSON.stringify(message));
      };

      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);

        if (state === "init" && data === 0) {
          // Initial response, send transaction
          const message = {
            Cmd: 1,
            PosType: selectedPosKey,
            Amount:
              this.compositeAmount != null
                ? Number(this.compositeAmount)
                : Number(this.invoices[this.activeInv].remainInvoice),
          };
          socket.send(JSON.stringify(message));
          state = "waitingForResponse";
        } else if (state === "waitingForResponse") {
          if (data?.IsSuccessfull) {
            const posDeviceArray = JSON.parse(localStorage.getItem("posDevice"));
            if (posDeviceArray != undefined && posDeviceArray.length > 0) {
              this.selectedBank = posDeviceArray.find(
                (obj) => obj.status == "active"
              ).bank;
            }

            // Success
            this.snakbar = true;
            this.snakbarText = data.ResponseMessage;
            this.snakbarColor = "green";

            clearInterval(interval);

            clearTimeout(timeout);
            this.progressPercent = 100;
            this.isPosSuccessfull = true;

            this.returnPosInfo = {
              amount: data.Amount,
              date: data.Time,
            };

            this.invoices[this.activeInv].optionDialogType = null;
            this.$nextTick(() => {
              this.invoices[this.activeInv].optionDialogType = "pos";
            });

            setTimeout(() => {
              this.loadingDialog = false;
              this.posPending = false;
              // *** call recieve api
              this.submitRecieve();
            }, 4000);
          } else if (data?.IsSuccessfull === false) {
            // Canceled or failed early
            clearInterval(interval);
            clearTimeout(timeout);
            this.progressPercent = 0;
            this.isPosSuccessfull = false;
            this.loadingDialog = false;
            this.posPending = false;

            this.isLoading = false;
            this.posErrorDialog = true;
            this.posErrorTxt = data.ResponseMessage;

            if (data.ResponseMessage == "پاسخ تعریف نشده") {
              this.isLoading = false;
              this.posErrorDialog = true;
              this.posErrorTxt = this.$t(
                "connection to the socket has problem please try again."
              );
            }
          }
          if (this.compositeAmount != null) {
            this.compositeAmount = null;
          }
        } else {
          // Connection failed or unexpected message
          clearInterval(interval);
          clearTimeout(timeout);
          this.progressPercent = 0;

          this.isLoading = false;
          this.posErrorDialog = true;
          this.posErrorTxt = this.$t("connection to pos Device didn't create");

          this.loadingDialog = false;
        }
      };
    },
    buildPrintHtml() {
      if (!this.$refs.refPrint) {
        return "";
      }
      const body = this.$refs.refPrint.innerHTML;
      return buildPrintHtmlFromBody(body);
    },
    previewPrintHtml() {
      const html = this.buildPrintHtml();
      const previewWindow = window.open("", "_blank");
      if (!previewWindow) {
        return html;
      }
      previewWindow.document.open();
      previewWindow.document.write(html);
      previewWindow.document.close();
      return html;
    },
    // print(type) {
    //   var app = this;
    //   const html = app.buildPrintHtml();
    //   const socket = new WebSocket("ws://127.0.0.1:8145/Print");
    //   socket.onopen = () => {
    //     const message = {
    //       Data: html,
    //       PrinterName: app.selectedPrinter,
    //     };
    //     socket.send(JSON.stringify(message));

    //     socket.onmessage = (event) => {
    //       app.socketPrintRes = {
    //         status: event.data,
    //         timestamp: Date.now(),
    //         type: type ? type : "create",
    //       };
    //       app.accept("submition");
    //     };
    //   };

    //   socket.onclose = (event) => {
    //   };
    // },
    sendHtmlToPrinter(html, jobType, onSent) {
      var app = this;
      const socket = new WebSocket("ws://127.0.0.1:8145/Print");
      let settled = false;
      let waitTimer = null;

      const failPrint = () => {
        if (settled) {
          return;
        }
        settled = true;
        clearTimeout(waitTimer);
        app.snakbarText = app.$t("connection to the socket has problem please try again");
        app.snakbarColor = "pink";
        app.snakbar = true;
        try {
          socket.close();
        } catch (e) {}
      };

      waitTimer = setTimeout(failPrint, 10000);

      socket.onopen = () => {
        const message = {
          Data: html,
          PrinterName: app.selectedPrinter,
        };
        socket.send(JSON.stringify(message));
        if (typeof onSent === "function") {
          onSent();
        }
      };

      socket.onmessage = (event) => {
        app.socketPrintRes = {
          status: event.data,
          timestamp: Date.now(),
          type: jobType,
        };
        if (event.data !== "Printed") {
          return;
        }
        settled = true;
        clearTimeout(waitTimer);
        try {
          socket.close();
        } catch (e) {}
      };

      socket.onerror = failPrint;
      socket.onclose = failPrint;
    },
    print(type) {
      var app = this;
      const printType = type ? type : "create";

      const activeInvoice = app.invoices ? app.invoices[app.activeInv] : null;
      const printableRows = ((activeInvoice && activeInvoice.items) || []).filter(
        (row) => row && row.product
      );
      if (printableRows.length === 0) {
        app.snakbarText = app.$t("noItems");
        app.snakbarColor = "pink";
        app.snakbar = true;
        return;
      }

      const html = app.buildPrintHtml();
      if (!html) {
        return;
      }

      app.lastPrintJob = {
        html,
        type: printType,
        number: activeInvoice ? activeInvoice.number : null,
        createdAt: Date.now(),
      };

      app.sendHtmlToPrinter(html, printType, () => {
        if (printType === "update") {
          app.clearableForm();
        } else {
          app.accept("submition");
        }
      });
    },
    openReprintPreview() {
      if (!this.lastPrintJob || !this.lastPrintJob.html) {
        return;
      }
      this.reprintPreviewDialog = true;
    },
    confirmReprintLastInvoice() {
      if (!this.lastPrintJob || !this.lastPrintJob.html) {
        this.reprintPreviewDialog = false;
        return;
      }
      this.reprintPreviewDialog = false;
      this.sendHtmlToPrinter(this.lastPrintJob.html, "reprint");
    },
    reprintLastInvoice() {
      this.openReprintPreview();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.nextPermission) {
      this.leavePage(to, from, next);
    } else {
      this.bottomNavigation = false;
      next();
    }
  },
};
</script>
<style scoped>
.wrapper {
  height: calc(100vh - 94px);
  display: flex;
  flex-direction: column;
}
.wrapper .product-wrapper {
  flex: 8;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.wrapper .product-wrapper .header {
  display: flex;
  gap: 0.5rem;
  width: 100%;
}
.wrapper .product-wrapper .header .queue-wrapper {
  display: flex;
  flex: 1;
  min-width: 0;
  height: 28px;
  align-items: stretch;
}
.wrapper .product-wrapper .header .queue-wrapper .factors-queue {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
  height: 28px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  scroll-behavior: smooth;
}
.wrapper .product-wrapper .header .factors-queue .child {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-left: 1px solid silver;
  height: 100%;
  cursor: pointer;
  font-size: 12px;
}
.wrapper .product-wrapper .header .factors-queue .child .text-caption {
  font-size: 12px !important;
  line-height: 1.2;
}
.wrapper .product-wrapper .header .factors-queue .child.active {
  background-color: #0066ff;
  color: #fff;
}
.wrapper .product-wrapper .header .factors-queue .child.active:first-child {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}
.wrapper .product-wrapper .header .factors-queue .child.active .v-icon {
  color: #fff;
}
.wrapper .product-wrapper .header .factors-queue .child:last-child {
  border-left: none;
}
.wrapper .product-wrapper .header .fix-btn {
  border: 1px solid #c0c0c0;
  background-color: #f6f4f4e3;
  border-radius: 4px;
  padding: 0 8px;
  height: 28px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 auto;
}
.invoice-queue-scroll {
  gap: 4px;
}
.invoice-queue-scroll-btn {
  min-width: 28px !important;
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
}
.invoice-queue-delete-btn {
  margin-inline-start: 8px;
}
.wrapper .product-wrapper .body {
  display: flex;
  flex: 1;
  gap: 0.5rem;
  min-height: 0;
}
.w-60 {
  width: 60%;
  min-width: 0;
}
.w-40 {
  width: 40%;
  min-width: 0;
}
.invoice-main-split {
  align-items: stretch;
  min-height: 0;
}
.invoice-items-col {
  min-height: 0;
  align-self: stretch;
}
.invoice-products-col {
  min-height: 0;
  align-self: stretch;
}
.invoice-products-panel {
  flex: 1 1 0;
  min-height: 0;
  height: auto !important;
  overflow: hidden;
}
.search-invoice-btn-compact {
  flex: 0 0 28px !important;
  min-width: 28px !important;
  width: 28px !important;
  padding: 0 !important;
}
.invoice-secondary-actions {
  gap: 4px;
  align-items: center;
  width: 100%;
}
.invoice-secondary-actions .v-btn {
  height: 28px !important;
  min-height: 28px !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}
.invoice-secondary-actions .v-btn ::v-deep .v-btn__content {
  font-size: 12px;
}
.invoice-secondary-actions .v-icon {
  font-size: 16px !important;
  height: 16px !important;
  width: 16px !important;
}
.invoice-secondary-actions .v-btn.search-invoice-btn-compact {
  padding: 0 !important;
  width: 28px !important;
}
.invoice-icon-btn-accent {
  background-color: #f0f6ff !important;
  border: 1px solid #0066ff !important;
}
.invoice-icon-btn-accent .v-icon {
  color: #0066ff !important;
}
.invoice-nav-btns {
  gap: 4px;
  align-items: center;
  flex: 0 0 auto;
}
.invoice-icon-actions {
  gap: 4px;
  align-items: center;
}
.invoice-icon-actions .v-btn {
  height: 28px !important;
  max-width: 28px !important;
  min-width: 28px !important;
  width: 28px !important;
}
.invoice-icon-actions .v-icon {
  font-size: 18px !important;
  height: 18px !important;
  width: 18px !important;
}
.invoice-nav-btn-compact {
  min-width: 0 !important;
  height: 28px !important;
  padding: 0 8px !important;
  font-size: 12px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}
.invoice-nav-btn-compact ::v-deep .v-btn__content {
  font-size: 12px;
}
.invoice-nav-wrapper-responsive {
  flex: 0 0 auto !important;
}
.invoice-nav-btn-responsive {
  flex: 0 1 auto !important;
  max-width: 128px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.invoice-submit-btn-fix {
  min-width: 0 !important;
  white-space: nowrap;
}
.invoice-payment-grid {
  display: grid;
  grid-template-columns: var(--payment-primary-col-width) minmax(0, 1fr);
  gap: var(--payment-grid-gap);
  align-items: stretch;
  min-width: 0;
  flex: 0 1 auto;
  width: var(--payment-grid-width);
  max-width: var(--payment-grid-width);
  height: var(--payment-stack-height);
  min-height: var(--payment-stack-height);
  max-height: var(--payment-stack-height);
  align-self: flex-start;
}
.invoice-payment-grid__primary-col {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  gap: var(--payment-grid-gap);
  min-width: 0;
  width: 100%;
  height: 100%;
}
.invoice-payment-grid__primary-col .invoice-payment-grid__btn {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: 100% !important;
  min-height: var(--payment-grid-row-height) !important;
}
.invoice-payment-grid__discount-row {
  display: flex;
  align-items: center;
  gap: 1.5px;
  width: 100%;
  min-width: 0;
  height: 100%;
  flex: 1 1 auto;
}
.invoice-payment-grid__discount-row > .v-tooltip {
  display: inline-flex;
  align-items: stretch;
  flex: 0 0 auto;
  height: 100%;
}
.invoice-payment-grid__discount-input {
  flex: 1 1 0;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: stretch;
}
.invoice-payment-grid__discount-input > div,
.invoice-payment-grid__discount-input > .v-input {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
}
.invoice-payment-grid__coupon-btn {
  flex: 0 0 auto;
  width: auto !important;
  min-width: unset !important;
  max-width: none !important;
  /* height: 100% !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: none !important;
  align-self: stretch; */
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  align-self: center;
  aspect-ratio: 1;
  padding: 0 !important;
}
.invoice-payment-grid__coupon-btn ::v-deep .v-btn__content {
  height: 100%;
}
.invoice-payment-grid__discount-input ::v-deep .v-input {
  margin-top: 0;
  padding-top: 0;
  flex: 1 1 auto;
  align-self: stretch;
  height: 100% !important;
}
.invoice-payment-grid__discount-input ::v-deep .v-text-field {
  margin-top: 0;
  padding-top: 0;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.invoice-payment-grid__discount-input ::v-deep .v-text-field .v-input__control {
  flex: 1 1 auto;
  align-items: stretch;
  height: 100% !important;
}
.invoice-payment-grid__discount-input
  ::v-deep
  .v-text-field--outlined
  > .v-input__control
  > .v-input__slot,
.invoice-payment-grid__discount-input ::v-deep .v-input__control,
.invoice-payment-grid__discount-input ::v-deep .v-input__slot {
  min-height: 100% !important;
  height: 100% !important;
  max-height: none !important;
}
.invoice-payment-grid__discount-input
  ::v-deep
  .v-text-field--outlined.v-input--dense
  .v-input__slot {
  min-height: 100% !important;
  height: 100% !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__discount-input ::v-deep input {
  max-height: none;
  height: 100%;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__discount-input
  ::v-deep
  .v-text-field.v-text-field--enclosed
  .v-text-field__details {
  display: none;
  min-height: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
}
.invoice-payment-grid__discount-input ::v-deep .v-input__slot {
  margin-bottom: 0;
}
.invoice-payment-grid__discount-input ::v-deep .v-text-field--outlined fieldset {
  top: -4px;
  bottom: 0;
}
.invoice-payment-grid__discount-input ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
}
.invoice-payment-grid__discount-input ::v-deep .v-input__append-inner .v-icon {
  margin-top: 0 !important;
}
.invoice-payment-grid__discount-col {
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  gap: var(--payment-grid-gap);
  min-width: 0;
  width: 100%;
  height: 100%;
}
.invoice-payment-grid__action-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-row: 2 / 4;
  gap: var(--payment-grid-gap);
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: 0;
}
.invoice-payment-grid__action-grid > .v-btn {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  overflow: hidden;
  height: 100% !important;
  min-height: var(--payment-grid-row-height) !important;
}
.invoice-payment-grid__action-grid > .v-btn .v-btn__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-size: 11px;
}
.invoice-payment-grid__action-grid > .invoice-payment-grid__secondary-row {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  grid-column: 1 / -1;
  grid-row: 2;
  display: flex;
  align-items: stretch;
  gap: var(--payment-grid-gap);
  min-height: var(--payment-grid-row-height) !important;
  height: 100%;
}
.invoice-payment-grid__action-grid > .invoice-payment-grid__secondary-row--align-print {
  gap: 2px;
}
.invoice-payment-grid__hall-composite-group {
  flex: 1 1 0;
  min-width: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  gap: var(--payment-grid-gap);
  height: 100%;
}
.invoice-payment-grid__hall-composite-group--with-reprint {
  grid-template-columns: var(--payment-grid-row-height) 1fr 1fr;
  gap: 2px;
}
.invoice-payment-grid__hall-composite-group--with-reprint > .invoice-payment-grid__hall {
  grid-column: 1 / 3;
}
.invoice-payment-grid__hall-composite-group--with-reprint
  > .invoice-payment-grid__composite-cell {
  grid-column: 3;
}
.invoice-payment-grid__hall-composite-group > .invoice-payment-grid__hall {
  min-width: 0;
  width: 100%;
  max-width: none;
  min-height: var(--payment-grid-row-height);
  height: 100%;
  padding: 2px 6px;
}
.invoice-payment-grid__hall-composite-group > .invoice-payment-grid__composite-cell {
  min-width: 0;
  width: 100% !important;
  max-width: none !important;
  min-height: var(--payment-grid-row-height) !important;
  height: 100%;
  display: flex;
}
.invoice-payment-grid__main-actions {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: stretch;
  gap: 2px;
  height: 100%;
}
.invoice-payment-grid__main-actions > .invoice-payment-grid__composite-cell {
  flex: 1 1 0;
  min-width: 0;
  width: auto !important;
  max-width: none !important;
  min-height: var(--payment-grid-row-height) !important;
  height: 100%;
  display: flex;
}
.invoice-payment-grid__main-actions > .v-tooltip.invoice-payment-grid__reprint-cell {
  flex: 0 0 auto;
  width: auto;
  height: auto !important;
  min-height: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
  margin: 0;
}
.invoice-payment-grid__secondary-row--solo > .invoice-payment-grid__main-actions {
  flex: 1 1 100%;
}
.invoice-payment-grid__action-grid > .invoice-payment-grid__secondary-row--with-scale {
  gap: var(--payment-grid-gap);
}
.invoice-payment-grid__secondary-row--with-scale > .invoice-scale-cluster {
  flex: 0 0 auto;
  align-self: stretch;
}
.invoice-payment-grid__action-grid > .invoice-payment-grid__primary-row {
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  align-items: stretch;
  gap: 2px;
  width: 100%;
  min-width: 0;
  height: 100%;
  min-height: var(--payment-grid-row-height);
}
.invoice-payment-grid__print-group {
  flex: 1 1 0;
  min-width: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  gap: var(--payment-grid-gap);
  height: 100%;
}
.invoice-payment-grid__print-group > .v-btn {
  min-width: 0;
  max-width: none;
  display: flex;
  align-items: stretch;
  height: 100%;
  width: 100% !important;
  padding-left: 4px !important;
  padding-right: 4px !important;
  overflow: hidden;
  min-height: var(--payment-grid-row-height) !important;
}
.invoice-payment-grid__print-group ::v-deep .v-btn__content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.invoice-payment-grid__primary-row > .v-tooltip.invoice-payment-grid__reprint-cell,
.invoice-payment-grid__secondary-row > .v-tooltip.invoice-payment-grid__reprint-cell {
  flex: 0 0 auto;
  width: auto;
  height: auto !important;
  min-height: 0;
  align-self: center;
  display: inline-flex;
  align-items: center;
}
.invoice-payment-grid__primary-row .invoice-payment-grid__reprint-btn,
.invoice-payment-grid__secondary-row .invoice-payment-grid__reprint-btn {
  width: var(--payment-grid-row-height) !important;
  min-width: var(--payment-grid-row-height) !important;
  max-width: var(--payment-grid-row-height) !important;
  height: var(--payment-grid-row-height) !important;
  min-height: var(--payment-grid-row-height) !important;
  max-height: var(--payment-grid-row-height) !important;
  padding: 0 !important;
  overflow: visible;
  align-self: center;
}
.invoice-payment-grid__reprint-btn.receipt {
  background-color: #fff7ed !important;
  border: 1px solid #f97316 !important;
}
.invoice-payment-grid__reprint-btn.receipt.v-btn--disabled,
.invoice-payment-grid__reprint-btn.receipt:disabled {
  background-color: #f5f5f5 !important;
  border: 1px solid #bdbdbd !important;
  opacity: 1 !important;
}
.invoice-payment-grid__reprint-btn.forKknife {
  background-color: #f0fdfa !important;
  border: 1px solid #0d9488 !important;
}
.invoice-payment-grid__action-grid .composite-responsive-wrapper {
  width: auto !important;
  max-width: none !important;
  flex: 1 1 0 !important;
  min-width: 0;
  height: 100%;
  display: flex;
  align-items: stretch;
  gap: 4px;
}
.invoice-payment-grid__action-grid .composite-responsive {
  width: 100% !important;
  height: 100%;
  display: flex;
  flex: 1 1 0 !important;
  min-width: 0;
}
.invoice-payment-grid__main-actions
  .invoice-payment-grid__composite-compact
  ::v-deep
  .v-btn.flex-fill-media {
  width: 100% !important;
  max-width: none !important;
  flex: 1 1 auto !important;
}
.parsang-icon-btn {
  min-width: 36px !important;
  max-width: 40px !important;
  width: 36px !important;
  height: 100% !important;
  max-height: var(--payment-grid-row-height);
  padding: 0 1px !important;
  flex: 0 0 36px;
  align-self: stretch;
  font-size: 9px !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  color: #fff !important;
  white-space: nowrap;
}
.invoice-payment-grid__composite-compact ::v-deep .v-container {
  height: 100% !important;
  width: 100% !important;
  display: flex !important;
  flex: 1 1 auto;
}

.invoice-payment-grid__composite-compact ::v-deep .v-btn.flex-fill-media {
  flex: 1 1 auto;
}
.invoice-payment-grid__composite-compact ::v-deep .v-btn.flex-fill-media {
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  height: 100% !important;
  min-height: var(--payment-grid-row-height) !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-payment-grid__composite-compact ::v-deep .v-btn.flex-fill-media .mr-1 {
  font-size: 11px;
}
.invoice-payment-grid__action-grid .invoice-payment-grid__hall-content {
  font-size: 7pt;
  line-height: 1.15;
  overflow: hidden;
}
.invoice-payment-grid__action-grid .invoice-payment-grid__hall .v-card-text {
  font-size: 8pt !important;
  line-height: 1.2;
}
.invoice-payment-grid__row {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex-wrap: nowrap;
}
.invoice-payment-grid__btn {
  flex: 0 0 auto;
}
.invoice-payment-grid__btn--compact {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.invoice-payment-grid__btn--compact ::v-deep .v-btn__content {
  font-size: 12px;
}
.invoice-payment-grid__discount {
  margin-top: 0;
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.invoice-scale-cluster {
  display: flex;
  align-items: stretch;
  gap: 4px;
  flex: 0 0 auto;
  height: 100%;
}
.invoice-scale-cluster ::v-deep .main {
  position: relative;
  width: 100px;
  min-width: 88px;
  height: 100% !important;
  min-height: 0;
  max-height: 100%;
}
.invoice-scale-cluster ::v-deep .back,
.invoice-scale-cluster ::v-deep .front {
  font-size: 15px;
}
.invoice-payment-grid__discount ::v-deep input {
  text-align: right;
}
.invoice-payment-grid__discount ::v-deep input::placeholder {
  text-align: right;
}
.invoice-payment-grid__discount .discount-panel-width {
  width: 100%;
  max-width: 100%;
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.invoice-payment-grid .discount-panel-width {
  width: 100% !important;
  max-width: 100% !important;
  height: 100%;
}
.invoice-payment-grid__discount-money {
  flex: 1 1 auto;
  width: 100%;
  height: 100% !important;
  display: flex !important;
  min-height: 0;
}
.invoice-payment-grid__discount-money ::v-deep .v-input {
  flex: 1 1 auto;
  height: 100% !important;
}
.invoice-payment-grid__hall {
  flex: 0 0 auto;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.26);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px 6px;
  background: #fff;
  box-sizing: border-box;
}
.invoice-payment-grid__hall--btn {
  border: 1px solid rgba(0, 0, 0, 0.26);
  background: #fff;
}
.invoice-payment-grid__hall-label {
  color: #000;
  font-size: 10px;
  white-space: normal;
  overflow: hidden;
  max-width: 100%;
  line-height: 1.15;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.invoice-payment-grid__hall-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-size: 8pt;
  gap: 2px;
  text-align: center;
  line-height: 1.3;
}
.composite-responsive-wrapper {
  flex: 0 1 auto;
  min-width: 0;
  min-height: 40px !important;
  max-width: 100px;
}
.composite-responsive {
  width: auto !important;
  max-width: 100%;
}
.send-to-pos-fixed-range {
  min-width: 117px !important;
  max-width: 117px !important;
}
.submit-printid-tight-range {
  width: 98px !important;
  min-width: 98px !important;
  max-width: 98px !important;
  flex: 0 0 98px !important;
}
.discount-wrapper-position {
  margin-top: 0;
}
.discount-panel-width {
  width: 155px;
}
.payment-footer-row {
  --payment-grid-row-height: 30px;
  --payment-grid-gap: 4px;
  --payment-stack-height: calc(
    var(--payment-grid-row-height) * 3 + var(--payment-grid-gap) * 2
  );
  --payment-primary-col-width: 148px;
  --payment-grid-width: 420px;
  width: 100%;
}
.payment-footer-row--no-restaurant {
  --payment-grid-row-height: 34px;
}
@media (min-width: 1138px) {
  .payment-footer-row {
    --payment-grid-row-height: 36px;
  }
  .payment-footer-row--no-restaurant {
    --payment-grid-row-height: 38px;
  }
}
.side-action-panel-width {
  width: var(--payment-primary-col-width);
  min-width: var(--payment-primary-col-width);
  max-width: var(--payment-primary-col-width);
  height: var(--payment-stack-height);
  min-height: var(--payment-stack-height);
  max-height: var(--payment-stack-height);
  display: grid !important;
  grid-template-rows: repeat(3, minmax(0, 1fr));
  gap: var(--payment-grid-gap) !important;
  align-self: flex-start;
}
.side-action-panel-width > .v-btn {
  width: 100% !important;
  min-width: 0 !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  font-size: 12px !important;
}
.side-action-panel-width ::v-deep .main {
  height: 100% !important;
  min-height: 0 !important;
  max-height: 100% !important;
  position: relative;
}
.side-action-panel-width ::v-deep .back,
.side-action-panel-width ::v-deep .front {
  font-size: 22px;
}
@media (min-width: 1138px) {
  .invoice-payment-grid__secondary-row > .invoice-payment-grid__hall {
    min-height: var(--payment-grid-row-height);
    height: 100%;
  }
}
@media (max-width: 1138px) {
  .payment-footer-row {
    --payment-primary-col-width: 118px;
    --payment-grid-width: 360px;
  }
  .invoice-payment-grid {
    grid-template-columns: var(--payment-primary-col-width) minmax(0, 1fr);
  }
  .invoice-payment-grid__action-grid .composite-responsive-wrapper {
    width: 100% !important;
    max-width: none !important;
  }
}
@media (max-width: 1023px) {
  .discount-panel-width {
    width: 130px;
  }
  .payment-footer-row {
    --payment-primary-col-width: 124px;
  }
}
@media (max-width: 850px) {
  .invoice-nav-wrapper-responsive {
    flex: 0 0 auto !important;
  }
  .invoice-nav-btn-responsive {
    max-width: 110px !important;
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .composite-responsive-wrapper {
    flex: 0 1 auto;
    min-width: 0;
    min-height: 40px !important;
    max-width: 118px !important;
    width: 114px !important;
  }
  .invoice-payment-grid__action-grid .composite-responsive-wrapper {
    width: 100% !important;
    max-width: none !important;
  }
}
.wrapper .calc-wrapper {
  flex: 2;
  width: 100% !important;
  max-width: none !important;
  padding: 0 !important;
  margin: 0 !important;
}
.v-progress-linear--reverse .v-progress-linear__determinate {
  left: auto;
  right: 0;
  height: 7px;
}

::v-deep .v-btn--icon.v-size--small .v-icon {
  margin-top: 8px;
}
::v-deep .v-input--selection-controls__ripple {
  display: none;
}
.print-button {
  border: 1px solid silver;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
.v-btn--is-elevated {
  box-shadow: none !important;
}
.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
::v-deep .v-input__slot {
  margin-bottom: 0;
}
::v-deep .v-messages {
  display: none;
}
::v-deep .v-input--selection-controls__input {
  margin-left: 0;
}
.v-application .overflow-y-auto {
  overflow-y: unset !important;
}
.fullscreen {
  position: fixed;
  top: 0px;
  z-index: 8;
  right: 0px;
  height: 100%;
}
.sum-td {
  text-align: center;
  font-size: 30px !important;
  color: white;
  background-color: #009688;
}
.fixed-bottom-payment {
  border-top: 1px solid silver;
  padding: 8px !important;
  width: 100% !important;
  max-width: none !important;
}
.fixed-bottom-payment > .d-flex {
  min-width: 0;
}
.fixed-bottom-payment > .d-flex > * {
  min-width: 0;
}
.additional-drawer-inner {
  overflow: hidden;
}
.additional-drawer-content {
  flex: 1 1 auto;
  overflow-y: auto;
}
.additional-drawer-row {
  gap: 8px;
}
.additional-drawer-description {
  border: 1px solid silver;
  width: 100%;
  border-radius: 4px;
  padding: 6px 9px 0 0;
  resize: vertical;
}
.additional-drawer .wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
  width: 100%;
}
.additional-drawer .wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.additional-drawer .wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.additional-drawer .wrapper-toggle-tax .child:nth-child(2) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax {
  border: 1px solid silver;
  border-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child {
  padding: 7.5px;
  cursor: pointer;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:first-child {
  border-left: 1px solid silver !important;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.fixed-bottom-payment .wrapper-toggle-tax .child:nth-child(2) {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.invoice-total-panel {
  height: var(--payment-stack-height);
  min-height: var(--payment-stack-height);
  max-height: var(--payment-stack-height);
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 60%;
  width: 60%;
  max-width: none;
}
.payment-footer-actions {
  min-width: 0;
  flex: 0 0 40%;
  width: 40%;
  max-width: 40%;
}
.payment-footer-actions .invoice-payment-grid {
  flex: 1 1 0;
  width: auto;
  min-width: 0;
  max-width: none;
}
.invoice-total-panel .header-total {
  flex: 0 0 var(--payment-grid-row-height);
  min-height: var(--payment-grid-row-height);
  max-height: var(--payment-grid-row-height);
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.invoice-total-panel .body-total {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.invoice-total-panel .body-total > .container {
  padding: 2px 8px !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.invoice-total-panel .body-total .my-1,
.invoice-total-panel .body-total .mt-1 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.invoice-total-panel ::v-deep .v-card__text {
  line-height: 1.15;
}
.invoice-total-panel ::v-deep .v-input--checkbox {
  margin-top: 0;
  padding-top: 0;
}
.invoice-total-panel ::v-deep .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
.invoice-total-panel ::v-deep .v-input--selection-controls .v-input__control {
  height: auto;
}
.fixed-bottom-payment .header-total {
  border: 1.5px solid #0066ff;
  padding: 0 5px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.v-card__text {
  width: auto;
}
.fixed-bottom-payment .body-total {
  border: 1.5px solid silver;
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
::v-deep .v-tabs--vertical > .v-window {
  margin-right: 30px;
}
.box {
  border: 1px solid silver;
  background-color: #f5f2f270;
  border-radius: 4px;
}
::v-deep .v-data-table.pos-table .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.pos-table {
  border: 1px solid silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.pos-table .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver !important;
  padding: 0 9px;
  color: black;
  height: 40px !important;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:first-child {
  border-top-right-radius: 4px;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > th:last-child {
  padding: 0 8px 0 4px;
  width: 30px;
  border-left: none;
  border-top-left-radius: 4px;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody {
  position: relative;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver !important;
  padding-right: 10px;
}
::v-deep
  .v-data-table
  > .v-data-table__wrapper
  tbody
  tr:first-child:hover
  td:first-child {
  border-top-left-radius: 0;
}
::v-deep .v-data-table > .v-data-table__wrapper tbody tr:first-child:hover td:last-child {
  border-top-right-radius: 0;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper tbody tr:last-child {
  border-top: 1px solid silver;
  background-color: #f6f6f6;
}
::v-deep .v-data-table.pos-table > .v-data-table__wrapper tbody tr:nth-last-child(2) {
  background-color: #f6f6f6;
}
::v-deep
  .v-data-table.pos-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td:last-child {
  width: 0;
  border-left: none;
  padding: 0 8px 0 3.6pt;
}
::v-deep .v-text-field--outlined.pos-device .v-label,
::v-deep .v-text-field--outlined.printer-device .v-label {
  top: 6px !important;
}
::v-deep .v-text-field.pos-device .v-label--active,
::v-deep .v-text-field.printer-device .v-label--active {
  top: 17px !important;
}
::v-deep .v-text-field--enclosed.pos-device .v-input__append-inner,
::v-deep .v-text-field--enclosed.printer-device .v-input__append-inner {
  margin-top: 5px;
}
::v-deep .v-text-field--outlined.printer-device .v-input__slot {
  margin-bottom: 4px !important;
}
::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px;
}
::v-deep .v-input__append-inner .v-input__icon.v-input__icon--clear {
  margin-top: 3px;
}
.discount-wrapper
  ::v-deep
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
  .v-input__control
  .v-input__slot
  .v-input__append-inner:nth-child(4) {
  margin-top: 5px;
}
::v-deep
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined
  .v-input__append-inner {
  margin-top: 0;
}
.table-select.v-text-field--enclosed
  ::v-deep
  .v-input__control
  .v-select__slot
  .v-input__append-inner {
  margin-top: 4px;
}
.wrapper-toggle {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle .child {
  padding: 7.7px;
  cursor: pointer;
  border-radius: 4px;
}
.wrapper-toggle .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle .child:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.wrapper-toggle-multiple {
  border: 1px solid silver;
  border-radius: 4px;
}
.wrapper-toggle-multiple .child {
  padding: 7.7px;
  cursor: pointer;
  border-left: 1px solid silver;
}
.wrapper-toggle-multiple .child:first-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.wrapper-toggle-multiple .child:last-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-left: none !important;
}
/* barcode dynamic scale*/
::v-deep .setting-barcode .v-label.v-label--active {
  top: 15px !important;
}
.setting-barcode ::v-deep .v-text-field__details {
  display: none !important;
}
.setting-barcode ::v-deep .v-input__append-inner .v-input__icon.v-input__icon--clear {
  margin-top: -4px;
  font-size: 2px;
}
.setting-barcode ::v-deep .v-icon {
  font-size: 12px !important;
}
.setting-barcode ::v-deep .v-input__icon {
  min-width: 10px;
  width: 10px;
}
/* add icon style for autocomplate */
::v-deep .v-autocomplete .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
  display: flex;
  align-items: center;
}
::v-deep .v-autocomplete .v-input__append-inner .v-btn {
  margin-top: 0 !important;
}
.invoice-header-fields {
  align-items: flex-start;
}
.invoice-header-fields ::v-deep .v-input {
  font-size: 12px;
  margin-top: 0;
}
.invoice-header-fields ::v-deep .v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.invoice-header-fields ::v-deep .v-text-field--outlined .v-input__control,
.invoice-header-fields ::v-deep .v-text-field--outlined .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  align-items: center !important;
}
.invoice-header-fields
  ::v-deep
  .v-text-field--outlined.v-input--dense
  > .v-input__control
  > .v-input__slot {
  min-height: 32px !important;
  height: 32px !important;
  align-items: center !important;
}
.invoice-header-fields ::v-deep .v-text-field--outlined fieldset {
  top: -5px;
}
.invoice-header-fields ::v-deep input {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  max-height: 32px;
  line-height: 20px !important;
  font-size: 12px;
}
/* inactive label = placeholder inside field (vertically centered) */
.invoice-header-fields ::v-deep .v-label {
  font-size: 12px;
  top: 6px !important;
  transform: none !important;
  line-height: 16px !important;
  margin: 0 !important;
  height: 16px !important;
}
/* floating label on border when focused / has value */
.invoice-header-fields ::v-deep .v-label--active {
  top: 10px !important;
  transform: translateY(-18px) scale(0.75) !important;
}
.invoice-header-fields ::v-deep .v-input__append-inner,
.invoice-header-fields ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  align-self: center;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 !important;
}
.invoice-header-fields ::v-deep .v-input__append-inner .v-input__icon,
.invoice-header-fields ::v-deep .v-input__prepend-inner .v-input__icon {
  height: 100% !important;
  min-width: 24px;
  width: 24px;
  align-items: center;
}
.invoice-header-fields ::v-deep .v-input__append-inner .v-btn,
.invoice-header-fields ::v-deep .v-input__prepend-inner .v-btn {
  margin: 0 !important;
}
.invoice-header-fields ::v-deep .v-icon {
  font-size: 18px !important;
  height: 18px !important;
  width: 18px !important;
  line-height: 18px !important;
}
.invoice-header-fields ::v-deep .v-btn {
  height: 24px !important;
  min-width: 24px !important;
  width: 24px !important;
  margin: 0 !important;
}
</style>
